const PISNI_TEXTS = {
  1: `Боже, славимо Тебе,  
Мiць Твою ми величаем,  
На вiвтар кладем себе,  
I Тебе Bci прославляем.  
Дивний Ти в земних дiлах  
I величний в Небесах.  
  
Все творiня на землi  
Люд Твiй вибраний, любимий,  
В Heбi Ангели святi,  
Херувими й серафими, —  
Славлять Bci з ycix широт:  
«Свят, свят, свят — Бог Саваот!»  
  
Боже вiчний i святий,  
Славу Bci Toбi приносим,  
Жертву наших уст прийми,  
— Ми Тебе Bciм серцем просим.  
Славимо тебе, Отця,  
Вседержителя, Творця`,
  2: `Перед Егови свiтлий трон,  
Народи всього свiту, йдiть,  
Приймiть Предвiчного Закон,  
I Синові Його служiть.  
  
В покорi чистим серцем всi  
Приймiть ви Божу благодать,  
Колiна перед Ним схилiть,  
А Вiн нам Свого Духа дасть.  
  
Вiрою над всiм мiцний покров  
Вiн розтягнув, немов шатро,  
Прославте Бога за любов,  
За Його свiтло i добро.  
  
Безмежний Всесвiт i земля  
По творчiй силi Божих слiв  
Колись повстали i стоять  
З давних давен до наших днiв.  
  
Прославте ж, люди всi, Творця  
За те, що кров за нас пролив.  
Бог любить свiт наш без кiнця —  
Хто б Його iм'я не хвалив!`,
  3: `Наш Господь між нами, —  
Щире поклоніння  
Ми несем Творцю й хваління.  
Серед нас Господь наш, —  
Голови схиляймо  
І коліна преклоняймо.  
Всі Творця і Отця  
В піснях величаймо  
І хвалу співаймо.  
  
Наш Господь між нами.  
Світлі херувими  
Славлять Бога зі святими.  
«Свят, свят, свят Бог — сильний,  
Честь і поклоніння!» —  
Ангели несуть хваління.  
Боже наш, глянь на нас,  
Жертву уст приносим,  
Прийми, Тебе просим.  
  
Радо покидаєм  
Світ цей з марнотою,  
Всі пороки і злу волю.  
Душу, дух і тіло,  
Наші всі хотіння  
Віддаєм Тобі в служіння.  
Ти Один, Божий Син,  
Бог над всім, Всесильний,  
Вічний, непомильний.  
  
На престолі слави,  
Боже, засідаєш,  
Ти мої думки всі знаєш.  
Я — Твоє творіння,  
Буду прославляти  
Мого Спаса й величати.  
Дай мені в повноті  
Осягти небесний  
Світла дар чудесний.`,
  4: `Як славний наш Господь в Сіоні, —  
Не пояснить людський язик.  
Великий в Небесах, на троні,  
І на землі в квітках малих.  
Ти всюди, Бог, велично дивний,  
Вночі, і вдень — сіянням рівний.  
  
Тебе Твій Агнець златорунний  
Так дивно відкриває нам.  
Ми на псалтирі милозвучній  
Тобі приносим фіміам.  
Прийми ж подяку, гімн хваління,  
Як запах чистого кадіння.  
  
Ти сонцем смертних оживляєш,  
Ти любиш, Боже, всіх людей.  
Щоденним хлібом насичаєш  
Своїх улюблених дітей.  
Ти грішний світ не забуваєш  
І дух життя всім посилаєш.  
  
О Боже наш, в Твій храм небесний  
Хай линуть наші голоси,  
Хай буде чистим спів сердечний,  
Мов перли ранньої роси.  
Тобі в серцях вівтар поставим,  
Тебе в піснях, Ісусе, славим.`,
  5: `Бог є любов — Він людей спасає,  
Бог є любов — Він любить мене.  
Радісно в серці звучить пісня щастя:  
Бог є любов — Він любить мене.  
  
Лежав я в путах гріха тяжкого —  
Господь піднятись мені поміг.  
Радісно в серці звучить пісня щастя:  
Господь піднятись мені поміг.  
  
Ісус Спаситель прийшов на землю,  
Кайдани смерті Він розірвав.  
Радісно в серці звучить пісня щастя:  
Кайдани смерті Він розірвав.  
  
Ласкавий Боже, прийми хваління,  
Бо Ти звільняєш мене з гріхів.  
Радісно в серці звучить пісня щастя:  
Господь звільняє мене з гріхів.  
  
Живу в надії на Нову Землю,  
Бог є любов — Він веде мене.  
Радісно в серці звучить пісня щастя:  
Бог є любов — Він веде мене.`,
  6: `Прославмо Бога сил  
Всім серцем і устами  
За те, що нас водив  
Безпечними шляхами,  
Бо ще з дитячих літ  
Добро нам посилав,  
Провадив і стеріг,  
Від смерті захищав.  
  
Ми просим, Боже наш:  
Будь з нами в дні майбутні,  
Щоб в цей лукавий час  
Дороги не звернути.  
За руки нас тримай  
В прийдешні дні життя,  
Як Пастир, направляй  
В щасливе майбуття.`,
  7: `Хай буде Тобі,  
Отче наш всеблагий,  
Честь, слава за дар  
Благодаті святий.  
  
Приспів:  
Алілуя! Славний Бог наш!  
Алілуя, амінь.  
Алілуя! Славний Бог наш  
Повіки, амінь.  
  
Ісусе, прийми  
Поклоніння від нас, —  
Ти любов’ю від смерті  
Дітей Своїх спас.  
  
Приспів:  
Алілуя! Славний Бог наш!  
Алілуя, амінь.  
Алілуя! Славний Бог наш  
Повіки, амінь.`,
  8: `Чую, як знов лунають в пісні похвальні звуки.  
До Бога в небо піднімаю радісно руки.  
Спів звучний хай ллється хвалою з грудей,  
Вільний від горя і муки. Амінь.  
  
Вічний Владика землі і світів безкінечних  
Шлях показав нам до джерела радощів вічних.  
Вода життя ллється струмком без кінця  
Проти сумнівів сердечних. Амінь.  
  
Співайте, друзі, вічному, всесильному Богу,  
Він проганяє з серця всі сумніви й тривогу.  
В піснях хвалу я заспіваю Творцю,  
Богу, всесильному Богу! Амінь.`,
  9: `Бог є любов. Лиш той, хто Бога знає,  
Де в серці дух Христа вогнем горить, —  
До всіх людей любов Він виявляє,  
На поміч в горі завжди поспішить.  
  
Бог є любов. Свята любов не судить,  
Вона прощає й покриває все.  
І той, хто Бога щирим серцем любить,  
Всім ближнім дар любові понесе.  
  
Бог є любов. Любов готова завжди  
Своїм теплом зігріти цілий світ,  
І втомленим в борні тяжкій подати  
Надії промінь, поміч в боротьбі.  
  
Бог є любов. Хто всім єством бажає  
Знов стати сином вічного Отця,  
Той кожний день себе хай забуває,  
І любить, як Христос, всіх без кінця.`,
  10: `Земля тремтить, в небес просторі  
Лунає грім, мов стук коліс,  
Мов гуркіт хвилі в грізнім морі, —  
Він голос Божий нам приніс:  
«Народе, ти будуєш храми,  
І храми золотом блищать,  
І в них димляться фіміами,  
Вночі і вдень вони горять».  
  
Приспів:  
«Я серце чисте хочу дати  
І волю сильну в боротьбі.  
Нехай же брат полюбить брата,  
Хай буде правда на землі».  
  
«Навіщо храмів те склепіння, —  
Каміння мертве без душі?  
Створив Я Всесвіт і промінням  
Осяяв красоту землі.  
Не прагну золота, ні срібла, —  
Їх заховав Я в надрах скал,  
І в землю, мов в скарбницю світу,  
Я влив розплавлений метал».  
  
«Ваш фіміам переді Мною.  
Навіщо це? З усіх сторін  
Своєю дивною красою  
Земля Мені співає гімн.  
Нащо свічки? Небес світила  
Я над землею засвітив,  
І, мовби іскри із горнила,  
Кидаю в темряву зірки».`,
  11: `Якби знав я, Боже правий,  
Що на небі любиш Ти  
Ангелів святих у славі,  
Духів правди й чистоти, —  
Я б в думках це осягав,  
Серцем пісню я б складав,  
Серцем пісню Богу правди  
Я б складав, завжди складав.  
  
Якби знав я, правий Боже,  
Що Ти любиш тільки тих,  
Хто на образ Твій став схожим  
І кого не рушив гріх, —  
Я б в думках це осягав,  
Серцем пісню я б складав,  
Серцем пісню Богу правди  
Я б складав, завжди складав.  
  
Та коли я чую повість,  
Що Ти любиш і мене,  
Хто грішив, стоптавши совість,  
І пішов від Тебе геть, —  
Я безсилий осягти,  
Але пісня хай звучить  
Господу любові й слави  
Хай звучить, завжди звучить!`,
  12: `Одному Богу вічна честь  
І за добро подяка.  
Нам не страшна вже люта смерть  
І темрява ніяка.  
Господь навік сподобав нас,  
Він дасть нам повний мир в той час,  
Як стихне буря всяка.  
  
До Твого світлого лиця  
Схиляємось в поклоні,  
Як свого Бога і Творця,  
Ми славимо на троні.  
Про вічний подвиг, святу кров  
Співати будем про любов  
Там, на Твоєму лоні.  
  
Ми славим нашого Творця,  
Святого Бога й Сина, —  
Він всі страждання до кінця  
За грішну ніс людину.  
І на хресті як Агнець вмер —  
Спаси від смерти нас тепер  
В оцю тяжку годину.  
  
О, Духу Правди, сильний Вождь,  
Втішителю Дух Божий,  
Зміцни весь вірний Свій народ,  
Бо стан навкруг ворожий.  
Охороняй нас від біди,  
Своїх дітей в Свій дім введи,  
Де мир панує Божий.`,
  13: `«Біблію дайте», — голос скрізь лунає,  
Ехом звучить по всіх краях землі.  
Біблія мудрість Божу відкриває  
І всю любов, проявлену в Христі.  
  
Приспів:  
Біблію дайте, бо вона навчає,  
Як нам любити Бога понад все.  
О, що за радість праведних чекає,  
Як в славі наш Господь з Небес прийде!  
  
Біблію дайте, як журба приходить,  
Як важко йти і серце защемить,  
Та лиш вона до мене заговорить —  
Радість і мир у серці зацарить.  
  
Біблію дайте, як прийде спокуса  
І сил нема її перемогти.  
З Книги Святої мудрості навчуся,  
Щоб від гріха себе оберегти.  
  
Біблію дайте, — лиш у ній спасіння  
І вірний шлях до світлої мети,  
В ній постанови Божі і веління,  
Як свято нам життя своє вести.`,
  14: `Читай постійно Боже Слово:  
В тім Слові правда нам сія,  
У нім знайдеш ти сили нові  
В борні щоденній проти зла.  
  
Приспів:  
«Читай Письмо!» — Господь так каже,  
Молись за себе і за всіх;  
Постійно стукай в двері ласки,  
Щоб зняв Господь із тебе гріх.  
  
Досліджуй Слово, досліджуй пильно,  
Воно всім свідчить про Христа,  
Бо тільки в ньому є спасіння,  
Надія втомленій душі.  
  
Досліджуй Слово, якщо бажаєш  
В оселі Неба увійти, —  
Радість небесну ти зазнаєш  
І втіху втомленій душі.`,
  15: `В Слові Божім утіху шукай, брате мій,  
В повсякденній земній боротьбі.  
Якщо важко іти в цьому світі тобі,  
Силу в Ньому знайдеш для душі.  
  
Приспів:  
Лиш на Христа в Слові Божім дивись,  
Кожен день, брате мій, ти читай і молись.  
  
В Слові Божім знайдеш ти спасіння душі, —  
Лиш довірся Йому, друже мій.  
Кров Христа, що стікала колись на хресті,  
Прощення дасть тобі і спокій.  
  
Слово Боже хай буде мірилом тобі,  
І керує постійно в житті,  
Хай підтримкою буде в важкій боротьбі,  
Другом вірним на грішній землі.`,
  16: `Твої Слова, мов та роса  
Для квіточок пахучих,  
Мов чиста, радісна сльоза,  
Що підкріпляє душі.  
Вони для нас в непевний час  
Дорогу відкривають  
І щастя обіцяють.  
  
Твої Слова — двосічний меч,  
Мов грім, що скелі крушить,  
І піч, розпалена без меж,  
Що кров і піт нам сушить.  
Нехай воно, як і давно,  
Твоє предвічне Слово,  
Очистить нас наново.  
  
Твої Слова, мов та зоря,  
Що світить серед ночі,  
І до небесного Царя  
Звертає наші очі.  
Хай світить нам і тут, і там,`,
  17: `В час нічний ти вийди в поле,  
Подивись на небеса,  
І зверни свій погляд вгору —  
Там побачиш чудеса.  
Глянь на ті нічні світила,  
Що не видно в світлі дня, —  
Їх рука Творця створила,  
Всім шляхи свої дала.  
  
Приспів:  
Слово Боже ще світліше  
Від зірок на небесах,  
Світить світлом животворним  
На землі в людських серцях.  
  
В час опівнічний мовчання  
Віджени обмани снів  
І направ свій зір в Писання  
Галилейських рибаків.  
Там, у Книзі тій чудесній,  
В Книзі ласки й щедроти,  
Ти побачиш край небесний,  
Чудеса Його краси.  
  
Час знаходь, щоб їх читати,  
Божу правду пізнавай,  
Поспіши людей навчати,  
Руку помочі їм дай;  
І вдивляйся ти на зорі  
Та на ріки, що течуть.  
Богом створені простори  
Хай у вічність їх ведуть.`,
  18: `Через всі тисячоліття  
Пригадай на мить собі,  
Як Господь давав Закон Свій  
На святій Синай-горі.  
Чути Голос: «Уважай, (двічі)  
Та богів чужих не май».  
  
Глянь, Бог хмарами зодягся,  
Вся гора кругом димить,  
Серед блискавок і грому  
Голос Божий знов велить:  
«Щоб не кланявсь образам, (двічі)  
Мертвим ідолам-богам».  
  
Бог у бурях пробуває,  
Захиталася земля,  
Трубний звук згори лунає,  
Чути Господа слова:  
«Ім'я Боже поважай, (двічі)  
Надаремно не вживай».  
  
Стоячи попід горою,  
Весь народ в страху тремтить.  
Хто ж бо встоїть близько Бога?  
Знову наш Господь велить:  
«День суботній Мій святіть, (двічі)  
Діл звичайних не робіть».  
  
«Поважай своїх батьків ти»,  
«Словом, вчинком не вбивай»,  
«Вірність зберігай в подружжі»,  
«Ближнього не обкрадай».  
Знай: для кожного із нас (двічі)  
Прийде скоро судний час.  
  
«Не свідкуй ніде фальшиво  
Ти на ближнього свого;  
Не дивися пожадливо  
На що-будь з майна його».  
Бог Закон цей дав тобі, (двічі)  
Щоб прожив ти у добрі.`,
  19: `Люблю читати Книгу  
Я Біблію святу, —  
Вона мене провадить  
В країну неземну.  
  
Приспів:  
Як люблю, як люблю  
Я Біблію щирим серцем,  
І, як лань, воду п’ю,  
Я живу — ту воду п’ю.  
  
В ній сила і надія  
Для втомлених людей.  
Вона — маяк спасіння  
В пітьмі гріха й страстей.  
  
Від золота дорожча  
Й усіх земних дарів,  
За мед вона солодша,  
Ясніша всіх вогнів.  
  
Вона — мій Вчитель вірний  
На стежці життєвій.  
Взірець Ісуса гідний  
Знайду для себе в ній.`,
  20: `Нова радість стала,  
Яка не бувала, —  
Над вертепом зірка ясна (двічі)  
На весь світ засіяла.  
  
Де Христос родився,  
З Діви воплотився,  
Як людина, пеленками (двічі)  
Вбогими вповився.  
  
Пастухи з ягнятком  
Перед тим Дитятком  
На коліна припадають, (двічі)  
Царя-Бога величають.  
  
«Просим Тебе, Царю,  
Небесний Владарю,  
Даруй літа щасливії (двічі)  
Цьому дому й господарю.  
  
Цьому господарю,  
Його господині,  
Даруй літа щасливії (двічі)  
Всій його родині.  
  
Щоб хлібець родився,  
Товарець — плодився,  
Щоб сім’я здорова була, (двічі)  
Щоб господар не журився.  
  
Дай нам мирно жити,  
Тобі догодити,  
І з Тобою в Царстві Твоїм (двічі)  
Повік вічно жити».`,
  21: `Тиха ніч, дивна ніч;
Міцний сон все сповив,
З радістю в серці Марія не спить, — 
Гарне Дитятко у яслах лежить. 
В світі Ісус народивсь, 
В світі Ісус народивсь

Тиха ніч, дивна ніч;
Ангел з неба явивсь
І пастухам урочисто сказав:
«О, не лякайтесь, — Бог радість нам дав, —
В світі Ісус народивсь,
В світі Ісус народивсь.»

Тиха ніч, дивна ніч,
Грішним всім принесла
Радість вічну від Бога Отця,
Щастям сповнені наші серця, —
Людям Христос народивсь,
Людям Христос народивсь!»`,
  22: `Велика зоря зійшла в небесах 
І світло чудове в світ принесла. 
Вона мудреців зі Сходу вела 
І до Вифлеєму їх привела.

Приспів: 
На небесах горить зоря,
Для всіх людей, для їх добра.
Веде і нас в непевний час 
З пітьми гріха Зоря Христа

З Святого Письма дізнались вони,
Що світла зоря їх буде вести
В те місце, де мав родитись Христос,
Щоб довго блукати не довелось.

Тож пильно зорю глядім день за днем,
Як ті мудреці, за нею підем,
Хай тільки Господь Один буде всім 
Зорею, що нас веде в Отчий дім.`,
  23: `Хвалу несем Христу повік.
Бо, як Син Людський, Чоловік,
Родився Він колись для нас.
Всі Ангели, співайте враз: Алілуя!

Від Нього світло настає,
Що сяйво всім світам дає,
Що світить нам, і в темний час
Синами світла робить нас. Алілуя!

Він — Божий Син і наш Творець,
Прийшов як Пастир до овець.
Він нас веде від сліз, жалю
В небесну ангельську сім'ю. Алілуя!

Убогим Він до нас зійшов,
Відкрив нам ласку і любов,
І рай блаженний обіцяв,
Надію на життя нам дав. Алілуя!

Він для людей усе зробив,
Всім грішним милість об'явив.
Радіє християнський світ,
Йому співає з роду в рід: Алілуя!`,
  24: `З висот небесних, світлих і чудесних,
Спаситель мій прийшов і тіло людське взяв;
В яслах родився, матір'ю сповився,
Він горя й смутку на землі зазнав.

Приспів: 
О, як люблю я мого Ісуса, —
Він моє Сонце, мій Хліб життя.
До Нього серцем я пригорнуся:
В Ньому лиш Божа вся повнота

Його терпіння принесло спасіння
Для всіх людей землі, що жили в темноті.
Бог милосердний дім лишив небесний,
Прийшов за нас вмирати на хресті.

Мов агнець смирний, тихий і невинний,
Христос на хрест пішов і тяжко постраждав.
Святою кров'ю, вічною любов'ю
Він дар спасіння грішним людям дав.`,
  25: `Чи ти знаєш річеньку, ту,
Що з Голгофи тихо біжить?
Хто у горі радість дає,
Нас навчає Бога любить?

Приспів: 
Хоч мій гріх великий, важкий,
Хоч я довго в світі блукав,
Але мій Отець всеблагий
Від гріха спасіння послав

На хресті в терновім вінку
Наш Спаситель тяжко страждав,
Недаремно кров Він пролив
І життя за грішних віддав.

Я по світу довго блукав,
Думав в людях правду знайти,
І Христос шлях вірний вказав,
Силу дав до Нього прийти.

І тепер я славлю Отця
За Його велику любов,
За нове і вічне життя,
За святу Ісусову кров.`,
  26: `О Ісусе найсвятіший,
Боже, на хресті розп'ятий,
Дай Твоє нам милосердя (двічі)
Щирим серцем вихваляти

О Ісусе терпеливий,
Вінчаний вінком з тернини,
Глянь на нас ласкавим оком (двічі)
І прости нам всі провини

Хай впаде життя краплина
Крові хресної святої
В серця наші і дасть сили (двічі) 
До духовної обнови`,
  27: `Чи знаєш подвиг Ісуса,
Як Він страждав на хресті?
Гірко сльозами заллюся —
Муки прийняв Він страшні.

О, як над Ним всі знущались,
Як розпинали Його,
Цвяхи, мов змії, в'їдались (двічі) 
В руки і в ноги Його

Чи знаєш подвиг Ісуса,
Як Він страждав на хресті?
Гірко сльозами заллюся —
Муки прийняв Він страшні.

Серце болить і страждає, 
Сльози течуть із очей, 
Глянь, як Господь умирає (двічі) 
В муках за грішних людей

Так Бог звершив План спасіння 
В жертві Ісуса Христа. 
Він переміг смерті тління 
І подарив нам життя. 

Це була жертва й за мене, 
Щоб не помер я, а жив. 
Жертва була недаремна, — (двічі) 
Бог нам Христа воскресив!`,
  29: `Захотів наш Спаситель померти за нас,
Щоб ми вічне життя осягли.
На хресті постраждав у призначений час, 
Щоб простити всі наші гріхи.

Приспів: 
Дорогий наш Господь 
Так цей світ полюбив, 
Що за людство Свою кров пролив. 
Всі гріхи до хреста на Голгофі прибив 
І дорогу спасіння відкрив

Милосердно, з любов'ю приймає Він нас,
І прощає провини нам всі,
У спокусі на поміч спішить в кожний час, 
Посилає небесний спокій.

Тож підем за Ісусом і будемо з Ним
Жити в мирі як дружна сім'я,
А Він буде навчати нас Словом святим, — 
Хай прославиться Боже Ім'я!`,
  30: `На Голгофу йди, душе,
Там вмирав наш Бог — Спаситель. 
В муках смертних постраждав 
Божий Син, Христос, Учитель. 
Це за тебе Він помер, 
Покорись Йому тепер

Він прибитий до хреста
Поміж небом і землею, —
За людей благав Отця,
Кров'ю жертвував Своєю.
Бідний грішнику, прийди
І в Христі спокій знайди

Як віддячу я Тобі?
Чим за все я відплачуся? 
Марне все на цій землі, 
Я до Господа звернуся: 
«Боже мій, мене прийми, 
В Царство вічне приведи»`,
  31: `Поглянь на Голгофу, мій брат, — 
Криваві хрести на горі там стоять, 
Розп'ятий Ісус на середнім хресті. 
Що злого зробив Він кому на землі? 
Впадем перед Ним

На хрест подивись, брате мій, — 
Христос там страждає за гріх мій і твій.
Його мучить спрага, — хтось оцет несе, 
Хоч річка життя всім від Нього тече. 
Впадем перед Ним

На хрест подивись, брате мій, 
«Прости їм», — Він просить Отця у мольбі.
Звершилось спасіння, прийшов смерті час. 
Підемо до Нього, — вмирав Він за нас. 
Впадем перед Ним

На хрест подивись, брате мій, — 
Спаситель наш любить, прощає тобі.
О друже, Він просить до Нього прийти, 
Бо в Ньому лиш зможеш спасіння знайти. 
Впадем перед Ним`,
  32: `Було тихо в Гефсимані,
Впав на землю Божий Син,
В смертній боротьбі й риданні 
Молиться в саду один: 
«Отче Мій, коли не може 
Проминути чаша ця, 
Хай тоді вся воля, Боже, 
Буде сповнена Твоя»

Так Ісус Отця благає
Перший, другий, третій раз,
Піт кривавий виступає
На чолі Його весь час.
Молиться в саду Спаситель. 
Сон скував учеників, —
Сплять вони, а їх Учитель 
Докоряє як братів

«Годі, друзі, вам вже спати!» —
Учням Він Своїм сказав. —
«Ось ідуть Мене вже взяти, —
Час Моїх страждань настав.
І проллю Я кров невинну 
За весь грішний світ, за вас...»
І з вогнями в ту хвилину 
Вороги з'явились враз

Юда, зрадник, прийшов з ними, —
Він Христа поцілував;
Щоб могли Його пізнати, 
Поцілунком показав. 
Руки Господу зв'язали, 
З лютим криком повели; 
Його били, обплювали 
І судити почали

При Пилаті осудили.
«Розіпни!» — народ кричав;
До хреста Його прибили, —
В муках Він за нас вмирав.
Так Христос в страшних терпіннях 
Вмер за грішних і воскрес. 
Щоб звершити План спасіння, —
В жертву Сина дав Отець`,
  33: `«Помер за тебе Я, 
І кров Свою пролив, 
З Голгофського хреста 
Дорогу в рай відкрив. 
Від злої смерті спас тебе. 
Чи ти згадав Мене? 
Я кров і сльози проливав, 
А що Мені ти дав?

Залишив дім Отця
І в Небі трон святий;
Зійшов на землю Я
Спасти весь рід людський.
Я між людьми пришельцем жив,
Був бідним на землі,
Покірно в світі цім служив,
А що ти дав Мені?

Земний Свій вік життя
Я в труднощах прожив,
Від смерті і гріха
Людей Своїх звільнив.
За тебе сльози проливав,
За тебе Я страждав,
Я все віддав колись тобі, 
А що ж ти дав Мені?

Ісусе мій благий,
Чим відплачу Тобі
За муки й хрест тяжкий 
В смертельній боротьбі?
Любити буду я Тебе 
Служити — лиш Тобі, 
Віддам навік всього себе 
На всі прийдешні дні`,
  34: `Сад Гефсиманський темрявою вкрився,
Мов перед бурею вмить занімів, —
Слухав уважно, як хтось там молився,
Гіркі Свої сльози лив

То Божий Син із важкою тугою
В смертних стражданнях на землю упав
І, весь покритий нічною росою, 
В страшній тривозі ридав

«Отче Мій, — голос почувся з благанням, —
Як тільки можна, хай чаша пройде;
Я хоч готовий на смертні страждання, — 
Хай Твоя воля буде»

А кипариси, як свідки двобою,
Гарний віночок із листя плели,
Свого Творця освіжали росою,
Плакати з Ним почали

Друзі Ісуса заснули, мов діти, —
В темряві сон підкорив їх собі...
Лиш Ангел з Неба зійшов підкріпити
Сили Його в боротьбі

Так наш Спаситель за світ цей гріховний
Випив всю чашу терпінь до кінця;
Йшов на Голгофу — на подвиг суворий,
Сповнити волю Отця`,
  35: `О, яку людям радість велику Бог дав!
Пута смерті Христос розірвав.
Страшні сили темряви Господь подолав
І прощення гріхів дарував.

Приспів: 
Він, лиш Він! Тільки Він!
Він — вічне життя і уся повнота, повнота,
Всі серця хай прославлять Христа, лиш Христа!
Всі серця хай прославлять Христа!

Наше вічне спасіння Спаситель звершив, —
В Небеса нам дорогу відкрив.
Хай радіють всі люди і сили Небес, — 
Наш Спаситель із мертвих воскрес!

Наш Господь милостивий в могилі лежав.
Він воскрес. Переможцем повстав.
Не даремно Божественну кров Він пролив, — 
Він нас з Богом навік примирив.

Ця чудова надія шле радість в серця.
Усі сумніви зникли і страх.
Він воскрес! Морок ночі навіки вже щез, — 
Він воістину в славі воскрес!`,
  36: `В могилі Він лежав, —
Мій Відкупитель.
Смерть смертю подолав
Спаситель мій.

Приспів: 
Гріб вже відкритий, — Він встав! Він живий!
Відбулося чудо із чудес! Він живий!
Владу смерті знищив, — наш Христос воскрес!
Хай несеться честь і слава до небес!
Він воскрес! Він воскрес!
Він воскрес! Він воскрес!
Алілуя, Він воскрес!

Смерть люту подолав,
Воскрес у славі;
Всім вірним радість дав 
Ісус Христос.
Шлях до життя відкрив
Христос Спаситель,
Нам вічність подарив
На Небесах.`,
  37: `Христос (воскрес)! Христос (воскрес)! 
О радість, радість нам! 
Христос (воскрес)! Христос (воскрес)! 
Кінець журбі й сльозам.
Христос (воскрес)! Христос (воскрес)! 
Смерть смертю подолав І нам спасіння вічне дав

Святі Ісуса руки
Злочинці розп'яли.
Терпів Він тяжкі муки
За всі людські гріхи.
Кров Агнця пролилася, —
За нас Він помирав...
«Звершилось все!» —
Христос сказав

З Аримафеї Йосиф
Пилата ублагав,
З хреста щоб зняти тіло. 
Ісуса поховав 
В саду у новім гробі. 
Суботній день настав, — 
Христос в могилі спочивав

В неділю дуже рано
Марія в сад прийшла,
В могилі тій неждано
Ісуса не знайшла.
З'явився Ангел з неба
І радісно сказав:
«Ісус Христос із мертвих встав!»

Марія з хвилюванням
Засмучена стоїть.
О чудо, здивування! —
Ісус з'явився їй.
Вона Його впізнала:
«Учителю!» — кричить...
І сповістити всім спішить`,
  38: `«Сина Божого в гробі нема», —
Ангел з неба цю радість звістив.
Була воля Господня така, —
До життя Він Його воскресив.

Приспів: 
Не шукай (не шукай), не шукай (не шукай), —
Серед мертвих немає Христа. 
Не шукай (не шукай), не шукай (не шукай), — 
Бог Ісуса підняв до життя

Цар життя силу смерті здолав, —
Ти у гробі Його не шукай.
Воскресінням надію Він дав
І відкрив всім дорогу у рай.

Не шукай серед мертвих Христа, — 
Над могилою світло горить. 
Наш Спаситель дасть вічне життя, 
Вірних з мертвих Він всіх воскресить.`,
  39: `Радість щедра, радість щира 
Хай наповнює серця!
Божий Син — наш Вождь всесильний — (двічі) 
Переміг смерть до кінця

Він воскрес і пробуває
Духом Правди завжди в нас,
І життя Своє вливає (двічі) 
В серце тих, кого Він спас

Він — життя і воскресіння, —
Будемо в союзі з Ним;
Радість вічного спасіння (двічі)
Нам дається Ним одним

Він воскрес з могили тління
І надію нам дає,
Що в день слави воскресіння (двічі)
Нас в безсмертя одягне`,
  40: `Шлях до спасіння — новий, живий
В жертві Своїй Христос нам відкрив.
Він в храм на Небі з кров'ю вступив,
Нас з Богом примирив.

Приспів: 
Радість, радість нині, грішним, нам, 
Бо за нас Христос — Заступник там. 
Звершує в Небі діло Своє, 
Прощення нам дає

Первосвященик — славний Ісус —
Щиру молитву в храмі почув.
Кров'ю Своєю гріх мій обмив,
Небо мені відкрив.

Скоро закриє Він храм святий, 
Скоро закінчить Він подвиг Свій. 
О, поспішіть до Бога прийти, 
Вірою в храм ввійти.`,
  41: `Слухайте вістку про жертву Христа,
Повні надії слова:
Бог від гріха нам очистив серця,
Він нас від смерті вже спас.

Приспів: 
Він нас від смерті вже спас!
Він нас від смерті вже спас!
Так, Бог нас навіки простив у Христі;
Він нас від смерті вже спас!

Може, ще пам'ять минулих років
Душу тривожить не раз, —
Вірте: Спаситель усе вам простив, — 
Бог нас від смерті вже спас.

Якщо в темряві світської журби
Промінь надії погас,
То не забудьте до Нього прийти, — 
Бог нас від смерті вже спас.`,
  42: `Бог Сина в світ з небес послав,
Щоб зло перемогти;
Йому Він владу й силу дав, (двічі)
Щоб рід людський спасти

Він, Цар всесильний і Творець,
Увесь наш світ створив.
Весь План спасіння Бог Отець (двічі)
Ісусу доручив

Своє Він Царство укріпить
На Небі і Землі,
Навіки правду утвердить (двічі)
І вічний заповіт`,
  43: `Господи, скало моя,
Лиш в Тобі сховаюсь я;
Ллється там потік святий,
Світлий, чистий і живий.
Він лікує рани всі
І змиває всякий гріх

Я не можу Твій Закон
Осягнути розумом, —
Ти ж Свій Дух у мене влив, 
Жити вірою навчив. 
Серце нове Ти даєш 
І шляхом добра ведеш

Оправдатись, Боже мій,
Я не можу з добрих дій.
Скільки б діл я не творив,
Скільки сліз би я не лив, —
Визволяє від гріха
Тільки благодать Твоя

В немочі своїй мольбу
Я до ніг Твоїх кладу.
В славний день, коли прийдеш,
Вірних в Царство всіх введеш, —
Не забудь й мене тоді
Взяти до осель Своїх`,
  44: `Великий Лікар і Творець —
Ісус — Первосвященик,
Утіха стомлених сердець,
Бальзам від ран щоденних.

Приспів: 
Хай вічно славиться за те
Ім'я Ісуса пресвяте!
Він — великий Лікар наш,
Пастир-Визволитель

Коли не маю більше сил, —
Він Словом підкріпляє;
Мене від смерті воскресив,
Від лиха захищає.

Христос гріхи прощає всі
І радість посилає;
До Неба нас візьме з землі,
Де смерті вже немає.

Він добрий, люблячий Отець,
Найкращий Вождь, Учитель;
Звертається до всіх сердець:
«Прийдіть! Я — ваш Спаситель».`,
  45: `Христова кров, пролита на хресті,
Обмиє серце і уста мені,
Щоб міг завжди, мій Боже, гідно я
В піснях підносити Твоє Ім'я.

Приспів: 
Хвалу Тобі, Господь, несу
За всю любов Твою

Я від гріхів втомивсь і занеміг,
Побитий ними з голови до ніг.
Лише любов Спасителя Христа
Спасе від смерті й дасть мені життя.

В душі моїй надії промінь згас,
Здається, що настав останній час.
На Тебе, Боже покладаюсь я, —
Прости мій гріх, зміцняй мене щодня.

Хоч тьма в душі, — Ти світло дня проллєш,
Мене, мов сина, в рідний дім приймеш.
Хоч ворог лютий, — я вже не боюсь, —
Зі мною йде всесильний мій Ісус.`,
  46: `Що змиває всякий гріх?
Тільки кров Христа Ісуса.
Дар спасіння, мир душі
Нам приносить кров Ісуса.

Приспів: 
Прославте, всі уста,
Спасителя Христа, —
Спасає від гріха
Тільки кров Христа Ісуса

З Богом примиряє всіх
Тільки кров Христа Ісуса.
Бог прощає всякий гріх
Тільки через кров Ісуса.

Мир, надію в серце ллє
Тільки кров Христа Ісуса.
Праведність мені дає
Тільки кров Христа Ісуса.

Славу Богу віддаю
За пролиту кров Ісуса.
На вівтар себе кладу
В жертву для Христа Ісуса.`,
  47: `Як сумно буває мені,
Коли не знаходжу Христа;
Не маю спокою тоді,
Змовкають, змовкають,
Змовкають, змовкають,
Німіють уста.

Немовби все спить навкруги —
І місяць, і зорі сумні;
Зітхають гаї і луги.
Так сумно, так сумно,
Так сумно, так сумно
І тяжко мені.

Коли ж тільки знову з Христом
Я зовсім близенько стою, —
Здається, співають псалом
Всі птахи, всі птахи,
Всі птахи, всі птахи
В саду і в гаю.

Як добре у цьому житті
Навчатися в школі Христа,
З Ним бути в єднанні всі дні!
Без Нього, без Нього,
Без Нього, без Нього
Усе — марнота.`,
  48: `О Галілея, край святий!
Він всім нам любий, дорогий. 
По тій землі ходив Господь, 
На схилах гір навчав народ.
Приспів: 
Ісус Христос (Ісус Христос),
Спаситель наш (Спаситель наш),
Він дав і нам (Він дав і нам),
Щасливий час: (щасливий час:)
Прийняти всім любов святу
І правду вічну, дорогу.

У Галілеї Він бував;
Учив, зціляв, і воскрешав.
Юдейський край і вся земля —
Хай славить Господа Ім'я.

І на новій, святій Землі,
Згадають всі відкуплені
Ісуса край — стежки, поля,
Що звали їх: Галілея.`,
  50: `Ясний цей шлях, що прямую ним, —
В край вічний він веде.
Хоч нелегкий, та завжди Ісус
Поруч зі мною йде.
Він захищає від спеки вдень,
Світлом вночі сія;
А як впаду, то підійме знов
Його рука міцна.
Приспів: 
Мій тепер, мій тепер!
Ісус з любов'ю купив мене, 
Від гріха вже звільнив, — 
Ісус є мій тепер!

Я до Ісуса в гріхах прийшов,
І Він мене простив,
Духом Святим серце кам'яне
Наново відродив.
Братом Своїм Він мене назвав,
І з Богом примирив,
До щастя вічного і добра
Дорогу Він відкрив.

Вже не розлучить ніщо мене 
З любим моїм Христом. 
Сміло прямую в небесний край 
Вірним Його шляхом. 
Він через світло і темряву 
Завжди мене веде; 
Радісну пісню співаю я: 
«Ісус є мій тепер!»`,
  51: `Славний наш Христос Спаситель, —
Зцілення дає для всіх,
Спокій, мир вселяє в серце
І прощає всякий гріх.
Приспів: 
Честь, хвалу (честь, хвалу) віддамо (віддамо)
Ми Спасителю Христу. 
Він явив (Він явив) на хресті (на хресті) 
Нам любові повноту

Будемо в Ім'я Христове
По шляху вузькому йти.
Він — наш щит, Він нам поможе 
Зло і гріх перемогти.
Дороге Ім'я Христове, —
Радість, щастя всім несе,
Від світських турбот гріховних
Вабить до Небес мене.

Господа Ім'я прославте
Із подякою в піснях.
Скоро Він прийде у славі, — 
З Ним ввійдемо в Небеса.`,
  52: `Ісус з любов'ю в світ прийшов,
В темряві Він мене знайшов,
І благодаттю наділив,
Мої гріхи простив, гріхи простив.
Приспів: 
Який я вдячний, Спасе мій, —
Мене Ти любиш, я вже Твій, 
Бо кров Твоя мене спасла,
Мені спасіння принесла!

У світі Він мене шукав,
Бо зовсім я Його не знав.
Я рідний голос той почув,
Мене Він пригорнув, Він пригорнув.

З Його зболілого чола
Свята, невинна кров текла,
Котрою Він мене обмив,
Мої гріхи простив, гріхи простив.

Син Божий тяжко постраждав,
Себе за людство в жертву дав,
Він План спасіння тут звершив
І нам гріхи простив, гріхи простив.`,
  53: `Любить наш Христос безмірно, —
Так любить Він! 
Завжди ніжно, завжди вірно, — 
Так любить Він! 
Щастя світу проминає, (двічі) 
Кращий друг нас забуває, — 
Він ніколи не лишає, — 
Так любить Він!

На хресті терпів страждання, —
Так любить Він!
Всім дарує виправдання, — 
Так любить Він! 
Він минуле все прощає, (двічі) 
Дивну радість відкриває 
Тим, хто Богу довіряє, — 
Так любить Він!

Хто пізнать Христа бажає,
Як любить Він, —
Мир і спокій той зазнає, — 
Так любить Він! 
Він лікує наші болі (двічі) 
І життя дарує нове, 
Потішає Його Слово, — 
Так любить Він!`,
  54: `За все Тобі я дякую,
Ісус, Спаситель мій,
За кров святу пролитую,
За дар любові Твій.

Приспів: 
Я дякую за все:
За те, що спас мене,
За те, що Небо дав,
Мене Своїм назвав. 
О Господи Святий, 
Живи в душі моїй, 
Завжди мене навчай, 
Веди в Небесний Край

За те Тобі я дякую,
Що Ти у світ прийшов
І душу стомлену мою
Для вічності знайшов.

За все Тобі я дякую:
За мир і Дух Святий,
Котрий у пору всякую
Живе в душі моїй.

За все Тобі я дякую!
Ти Небо дав мені.
Я з вічною подякою
Служитиму Тобі.`,
  55: `Не знаючи Бога, життя я не знав,
Без Слова Святого у світі блукав,
Та серцю моєму Святий Дух сказав:
«Він любить, Він любить, за тебе вмирав».

Приспів: 
Я жив у гріхах, Христос мене спас,
Він любить! Він любить! Ісус вмер за нас

Коли я втомлюся в земній боротьбі,
Спокою не зможу знайти для душі,
Тоді знов почую чудові слова:
«Він любить, Він любить, Він — світло життя».

Христові довірився, Ним лиш живу,
Долиною смерті без страху іду,
І Він не покине, бо чую я знов:
«Він любить, Він любить, наш Бог є любов».`,
  56: `Хваліть Ісуса, Бога сил,
Володаря світу. Хвали
Його, душе моя,
бо Він — любов вічна.

Зберіться всі,
Кобзу і арфу візьміть, — 
Хай хвали лунає пісня

Хваліть Ісуса, що створив
Всесвіт наш чудовий;
Він нам спасіння подарив,
Потішає Словом.

В лукавих днях
Нас тримав в Своїх руках
І дає життя нам нове

Хваліть Ісуса, — Він усім
Мудро володіє,
На крилах віри носить нас,
Світу дав надію.

Він нас веде
І на землю знов прийде.
Хто ж цього не розуміє?

Хвали Його, душе моя,
Співом слави в хорі,
Хваліть повік святе Ім'я,
Праведні всі в зборі.

Хвалім Його, Бога і Творця свого, —
Все творіння у просторі`,
  57: `Творцю співаю гімн хвали 
За мудрість всіх чудес, 
Приношу я Йому дари — 
Честь, славу до небес. 
Він Слово сили лиш сказав — 
Вмить світлом стала тьма, 
І до життя наш світ повстав, — 
Вже темряви нема

Світ наш чудовий Бог створив,
Закон творінню дав,
І гори снігом Він покрив,
За хмари їх підняв.
І сонце ллє своє тепло,
Землі дає життя.
Нехай за ласку і добро
Творцю звучить хвала

Я славлю мудрість Бога сил,
Що дивно світ створив;
Він цілий Всесвіт утвердив,
Закон Свій всім відкрив.
Творець премудрий і благий
Явив нам міць Свою.
Тож за життя — Твій дар святий
Прийми хвалу мою`,
  58: `Хвала Христу! Я знов слуга Його,
Він страх і муки з серця зняв мого,
Послав мені і радість, і спокій,
Він в груди влив надії промінь Свій.

Приспів: 
«Хвала Христу, хвала Христу!» — 
Хай скажуть так уста Йому.
І в небі з золотим вінком
Співати буду я: «Спасен Христом»

«Хвала Христу!» — співаю я Йому,
Своє життя і волю віддаю;
Служити хочу щирим серцем я,
На Нього лиш надія вся моя.

Хвала Христу, що сили всім дає, — 
Мене за руку всюди Він веде,
Зі мною йде в час горя і тривог, — 
Він мій Спаситель, вічно добрий Бог.`,
  59: `Господь — моє світло, я не боюсь,
І вдень, і вночі до Нього молюсь.
Він вічне спасіння всім людям приніс;
Він — захист і втіха в день горя і сліз.

Приспів: 
Господь — моє світло, радість і спів,
Він всюди зі мною — вдень і вночі.
Господь — моє світло, радість і спів.
Я славлю Його від серця й душі

Господь — моє світло, хоч тьма іде,
Живий погляд віри світло знайде.
Там в сяйві Спаситель царює повік
І радість життя Він дарує для всіх.

Господь — моє світло й сила моя,
Всю слабість і страх переможу з Ним я.
В годину спокуси й душевних тривог
Завжди захистить і спасе вічний Бог.`,
  60: `Я співаю, як Спаситель
Світ наш щиро полюбив,
Як страждав мій Викупитель
І за мене кров пролив.

Приспів: 
Пісня ллється про Ісуса,
Про любов, яку явив,
Кров пролив Свою невинну
І мої гріхи простив

Я співаю, як Спаситель
В небі зіркою сія,
На дорозі правди світить
І веде нас в дім Отця.

Струни серця звучно грають
І несуть хвалу Христу.
Хай Земля вся прославляє
Божу щедрість, доброту.`,
  61: `Буду співати, славу складати
Тому, Хто на хресті за нас вмирав.
Мудрий Учитель, добрий Спаситель,
Людям спасіння всім дарував.

Славити вічно буду Христа,
В Ньому знайшов я світло й життя.
Силу ворожу з Ним переможу
Тут, в боротьбі земній

Я на Ісуса завжди дивлюся,
Ним лиш Одним на світі я живу.
Він — моя радість, сила і святість,
З Ним буду жити вічно в раю.

Радості в людях я не знайду,
А від Ісуса більш не піду.
З Богом прямую в славу святую
По земному шляху

Тут все минає, там вже чекає
Втомлених радість і святий спокій.
З Богом я буду, горе забуду,
Як прийде в славі Спаситель мій.

Там залунає пісня свята,
Славити вірні будуть Христа.
Пісню спасіння, пісню хваління
Буду співати я`,
  62: `Радійте, співайте і славте
Повіки Ісуса Христа!
Ви пісню нову заспівайте,
Бо Він спас людей від гріха.

Приспів: 
Співайте, радійте
І славте Ісуса Христа!
Співайте, радійте
І славте Ісуса Христа!

Спаситель в великій любові
Нас, грішних, простив, оправдав,
Обмив нас пречистою кров'ю
І щастя навіки нам дав.

З Ним силу гріха переможем,
Він нас в боротьбі підкріпить,
Любов'ю Своєю піддержить
І Духом Святим утвердить.

Всі радісним серцем співайте
Предвічному Богу Отцю.
Себе на служіння віддайте
Навіки Ісусу Христу.`,
  63: `Коли почую про Христа,
Я серцем веселюсь,
В душі лунає пісня та:
«Спаситель мій — Ісус».

Коли згадаю, як я жив,
То сам себе боюсь, —
Мої гріхи Ти кров'ю змив,
Спаситель мій, Ісус!

Приспів: 
Ти, Боже, радість дав, (мені дав)
Я за те молюсь, (Тобі молюсь)
Щоб світ хвалу Тобі співав,
Спаситель мій, Ісус!

Тебе я славлю за любов,
Ім'ям Твоїм хвалюсь.
Спасла мене пречиста кров,
Спаситель мій, Ісус.

Колись я в темряві ходив, —
Тепер з гріхом борюсь;
Твій Дух мене знов оживив,
Спаситель мій, Ісус!`,
  64: `Я хочу співати кожний день
І славити Христа,
Йому хай несеться спів пісень
За радість нового життя.

Приспів: 
Співай (співай), співай (співай)!
Для Господа співай (співай).
Співай (співай), співай (співай)!
О друже, хоч сумно, співай!

Хоч серце порою заболить
І сльози на очах,
Хоч хрест до землі мене гнітить,
Я славлю Ісуса в піснях.

Я буду співати без кінця
Про вічний Божий рай
І хочу, щоб славна пісня ця
Звучала завжди з краю в край.`,
  65: `Брате, знову нагадай
Про святу любов,
Про небесний Божий рай
Розкажи нам знов.

Спів хвали хай ллється,
Поки серце б'ється.

Приспів: 
Славте Христа, славте Христа, (двічі)
Славте любов Христа

З неба від Отця приніс
Нам Христос любов.
Щоб спасти від смерті й сліз
Він в цей світ зійшов.

Нас Христос навчає,
Всі гріхи прощає.

Брате, знову нагадай
Про святу любов.
Зникне з серця сум, відчай,
Прийде радість знов.

Кличе спів любові
До життя нового.`,
  66: `Прийди з висот небесних,
Дух істини Святий,
Влий світло правди в серце,
Думки всі освіти.

Допоможи незмінно
Завіт Твій берегти,
Твоїм вогнем священним
Дорогу освіти

Байдужість та невір'я
Намножились кругом, —
Благаєм: дай терпіння
Для боротьби зі злом.

Пошли нам більше віри
І силу укріпи,
Щоб встояти в спокусах
З Тобою ми могли

Зверши, Дух Божий, чудо,
Наповни всі серця,
Нехай проникне всюди
Спасіння й мир Христа.

Цю вістку сповіщати
Нам всім допоможи,
Щоб ми могли пожати
Достиглі вже лани`,
  67: `Духу правди і любові,
Що тебе послав Господь,
Дай плоди Свої чудові,
Духу правди і любові,
Духу правди, Сам зійди з висот

Духу правди і любові,
Нам освічуй темну путь,
Щоб служили ми Єгові,
Духу правди і любові,
Духу правди, Ти нам світлом будь

Духу правди і любові, —
Лікар Ти для ран моїх,
Нас веди в оселі нові.
Духу правди і любові,
Духу правди, будь Вождем повік`,
  68: `Дух Святий, до нас прийди,
Всіх любов'ю наповняй,
З нами будь у кожну мить 
І Христа нам відкривай.

Приспів: 
О величний Дух, прийди, 
О величний Дух, прийди!
(О величний Дух, прийди!)
Силою нас наповняй,
(Силою нас наповняй,)
Всіх, хто молить, потішай, (ждем ми) 
Ждем Тебе ми, о прийди, (Дух Святий) 
Дух Святий, (до нас прийди), 
До нас прийди (до нас прийди).
О прийди, (благаєм ми,)
Благаєм ми, 
(О прийди, благаєм ми!)
Всім Ісуса відкривай,
Дивно Бога прославляй

Все Тобі я віддаю:
Душу, тіло, розум мій,
Все життя і волю всю, —
Хочу бути завжди.

Твій Дух Святий, як Пізній дощ,
Щедро ороси серця,
Щоб готовими були
Ми до Приходу Христа.`,
  69: `Дух Святий закликає людей,
До спасіння і щастя веде.
О друже, Він кличе й тебе.

Приспів: 
«Прийди» — (кличе Він), (двічі) 
Прийди тепер, —
В Нім щастя знайдеш

Що у світі тримає тебе,
Й спішиш до Ісуса прийти?
Чому від любові біжиш?

І за тебе Син Божий страждав,
Дар спасіння тобі обіцяв.
Прийми ж Його дар вже тепер.`,
  70: `Всевишній Бог наш і Отець,
Ми в Ім'я Твого Сина знов
Зійшлися в єдності сердець
В Твій храм святий під Твій покров

Тебе благаємо в цей час:
Прийми молитви, спів від нас
За вічні милості й любов,
Що нам даруєш нині знов

І щоб могли всім серцем десь
Прийняти вість Твою з Небес,
Вивчати розумом своїм
Живі Слова в Письмі Святім

Ісусе, молимо ще раз:
Прослався Ти посеред нас,
Пошли Святого Духа всім,
Хай Він веде нас в Отчий дім`,
  71: `Ісусе мій, до Тебе йду,
Від серця шлю мою хвалу,
Прийми її таку, як є.
Хвала і честь Тобі за все!

До Тебе кличу, Боже мій,
Поглянь на мій душевний біль,
Думки і серце обнови,
По правді жити научи

Ісусе, змий мої гріхи,
Зміцни, бо дуже я слабкий,
Дай серце чистим зберегти,
Любити Твій Закон святий

Я знаю: скоро Ти прийдеш,
Своїх дітей в Свій край візьмеш;
Там будемо ми без кінця
Всі славити Тебе, Творця`,
  72: `В долині гріха я
Втомивсь, занеміг
Від смутку й страждання,
Від болів моїх.

Мій зір помутився,
Світильник погас,
І дух утомився
В борні кожний час

І мовби, Ісусе,
Мене Ти забув,
В годину спокуси
Мій голос не чув.

Не гайся ж, доволі,
Скоріш поспіши,
І в смертній юдолі
Дай сил для душі

О Боже, дай сили,
Щоб я не упав,
Кріпивсь до могили,
За правду стояв.

І вічним союзом
Любові й добра
Завжди лиш з Ісусом
Був зв'язаний я`,
  73: `«Просіте — і дано вам буде», —
Спаситель навчає всіх нас.
Просіть, з вами буде Він всюди,
Любов і терпіння вам дасть.

Просіть щиро Духа Святого
І мудрості й сили в житті.
Пізнати дух Слова живого, 
Щоб вірною стежкою йти

Шукайте завжди — і знайдете
Ту віри перлину живу.
В ній радість й спокій осягнете
Та славу небесну, святу.

Шукайте щодня, безустанно,
І царства, і правди Творця, —
Він дасть вам з любов'ю негайно
Блаженство і мир без кінця

Тож стукайте сильно — й відкриє
Вам двері Христос-Ієрей,
Всі ваші пороки покриє,
Зітре сльози з ваших очей.

Невпинно ви стукайте тільки, —
Він добрий наш Бог без кінця.
Його Ім'я славте повіки,
Радійте на славу Творця!`,
  74: `Прославляйте Бога в звучних піснях,
Прославляйте всім життям своїм;
Прославляйте радісно, з хвалінням
Навіть серед горя і терпінь.

Приспів: 
Прославте Бога!
Славте від душі
За Святий спокій.
Прославте Бога!
Славте нині і повік

Прославляйте Бога щохвилини
В справах ваших, думках і словах.
Він до всіх нас дуже терпеливий,
Хоч не раз блудили ми в гріхах.

Прославляйте щирою хвалою
За велику і святу любов,
Бо від смерті спас Він нас Собою,
На хресті пролив пречисту кров.

Прославляйте Бога безконечно,
Він вже скоро другий раз прийде.
І введе нас в Царство, де безпечно
Без турбот, без горя житимем.`,
  75: `Ось зібрались знову ми
Ім'я Боже прославлять.
Отче наш, хвалу прийми
І пошли нам благодать.

Дух наш в вірі підкріпляй,
Щоб з Тобою ми були, —
І в небесний, вічний Край
Дружно й радісно ввійшли

Господи, Ти нас навчай,
Як життя земне пройти,
Духа Правди посилай,
Щоб любити всіх, як Ти.

Боже, всім нам поможи
Жити як одна сім'я,
Сили наші Сам зміцни
До приходу Твого дня

Будем з радістю в серцях
Господа-Отця молить;
Віджене Він горе й страх,
Вірних всіх благословить.

Всю забудемо журбу,
Будем славити Творця,
І Спасителю Христу
Будем вірні до кінця`,
  76: `Такий, як є, сьогодні йду
До Тебе, мій Спасителю,
Тобі я серце віддаю,
Прости і змий вину мою

Такий, як є, в безодні зла
Не маю сили для добра.
Лиш Ти мій щит, моя Скала, —
До Тебе, мій Ісусе, йду

Такий, як є, безсилий я.
Бажає спрагнена душа
Напитись з Твого джерела, —
До Тебе, мій Ісусе, йду

Такий, як є, мене прийми,
Життя моє Ти обнови,
Святою кров'ю очисти.
О Агнець Божий, я вже йду`,
  77: `Як гарно і любо на небі вгорі!
Там гріх, і терпіння, і біль вже чужі.
Все золотом сяє, чудово блищить,
І серце втішає та й око манить

Над містом прекрасним на славній горі
Видніє престол Божий в дивній красі,
Від нього виходить живих вод ріка
І дерево щастя росте по боках

Несеться там ніжних пісень відгомін,
І Ангели Божі складають поклін.
Громада спасенних хвалу принесе
Творцеві навіки, що був, є й буде

Я також щасливим до трону прийду
І разом з святими хвалу принесу:
«Агнцеві вдасть, мудрість, честь. Сила й хвала
Повік від спасенних хай буде дана!»

Тож Дух і Невіста говорять: «Прийди!»
Хто чує, нехай також скаже: «Прийди!»
А хто має спрагу, хай прийде і п'є
Життя воду даром, що Агнець дає`,
  78: `Боже мій, Джерело щастя,
Серце Ти напій моє.
Хочу заспівати пісню,
Що святить Ім'я Твоє.

Вчи мене такої мови,
Що дух ближніх укріпить,
Піднесе його угору
І від пут гріха звільнить

Ми були, як вівці блудні,
Але Ти нас відшукав
І життя за нас, нещасних,
На хресті колись віддав.

Ми вже темряву лишили,
Ти освічуєш нам шлях.
Від гріхів тяжких звільнились,
Радість чуємо в серцях

Всю Твою любов безмежну
Людський розум не збагне.
Як віддати честь належну
За спасіння дороге?

Тож дозволь же, добрий Боже,
Присвятити все життя.
Хай Твій Дух Святий поможе
В вірі йти у майбуття`,
  79: `Боже наш святий, Єгово,
Шлях в пустелі освіти;
Мене, бідного й слабого,
В Ханаан Свій приведи.

Приспів: 
Хліб небесний, дар чудесний
Дай нам, Боже, серце підкріпляй.
Дай нам (хліб небесний),
Дай нам (дар чудесний),
Дай нам (хліб небесний),
Дай нам (дар чудесний),
Хліб небесний,
І веди нас в рідний край

Хай струмінь води живої
Скеля дасть Твоїм рабам,
Хай горить в час тьми нічної
У дорозі світло нам.

Скоро прийдем до Йордану,
Скоро буде рідний край.
Боже, в радість Ханаану
Сам народ Свій направляй.`,
  80: `Творець мій і Господь,
Від Тебе сила вся.
Мені надію в час незгод (двічі)
Дає любов Твоя

Ти Сам мене створив
І дух життя Свій дав,
З любов’ю пестив і водив, (двічі)
Своїм мене назвав

Хай благодать Твоя
В мені збудує дім,
І силу Духа влий, щоб я (двічі)
Навіки був Твоїм`,
  81: `О Ісусе, через хвилі
І пустелю нас веди.
Глянь, ми немічні й безсилі, —
Завжди перед нами йди.

Хліб небесний, дар чудесний
Дай нам нині з висоти
Свій струмок води живої
Ти відкрий із скелі нам.

До країни неземної
Дай дійти Твоїм рабам.
О ласкавий, Боже правий,
З нами будь і тут, і там

Хай над водами Йордану
Світить світло й зникне страх,
Щоб в край рідний Ханаану
Було видно добре шлях.

Щоб в країні тій, як рідні,
Ми жили в Твоїх дворах`,
  82: `Візьми мене за руки,
Зі мною йди.
Шляхом терпіння, муки
Мене веди.
Коли Ти йдеш зі мною,
Ісусе мій,
Спокійний я з Тобою
На цій землі

Твої благословення
Пошли мені,
Дай сили і натхнення
В суворі дні.
До Тебе зір звертаю,
Твоє дитя,
Тобі навік ввіряю 
Своє життя

Коли буває важко
І сил нема, —
Ти в мить засяєш ясно,
Немов зоря.
Візьми мене з Собою,
Ісусе мій,
Долиною земною
Веди в край Свій`,
  83: `Ісусе мій, прийди,
Від зла мене звільни,
В серце моє ввійди
І вічно там живи.

Приспів: 
Прийди, Ісусе мій, прийди,
В мені навіки поселись,
Кров'ю з мене змий всякий гріх,
І буду біліший, ніж сніг.
Білий, як сніг, білий, як сніг.
Кров'ю з мене змий всякий гріх,
І буду біліший, як сніг

До доброго життя
Нових сил приділи,
Світлом Свого лиця
Дорогу освіти.

Будь Сам провідником
На життєвім шляху,
Тоді Твоїм слідом
Безпечно вже піду.`,
  84: `О Боже, будь Ти з нами,
В житті нам помагай,
Правдивими шляхами
Веди в небесний Край

Об'єднуй нас любов'ю,
І віру дай святу,
Зрідни Твоєю кров'ю
Усіх в одну сім'ю

Спасителю, помилуй,
Дай благодать Отця,
Хай Дух Твій, Утішитель,
Пошле Свій мир в серця

Ми хочем посвятити
Життя своє Тобі,
Аби добро творити
Всім ближнім на землі`,
  85: `Богу слава і хваління
За всіх вибраних мужів,
Що несли в світ дар спасіння
З давніх літ до наших днів.

Приспів: 
Боже наш, і нам дай сили
Світло правди всім нести,
Щоб у вірі ми міцніли,
Царство вічне осягли

В святості життя, в надії, —
Ось Енох, Ной, Авраам
І Мойсей, — герой, муж віри,
Даниїл, Син Божий Сам.

Для прогресу і культури
Поштовх ці мужі дали,
Всіх віків герої віри
З неба світло в світ несли.`,
  86: `Богослужіння скінчилось,
Ми додому йдем.
Все, чого ми тут навчились, (двічі)
У серця візьмем.

Приспів: 
Мирно, тихо і спокійно
Ми додому йдем.
Слово Боже, що ми чули,
В серці збережем

Отож будемо старатись
В дім молитви йти,
І учитися там правди, (двічі)
Як життя вести.

Друже, залиши турботи,
До Христа прийди,
І старайся щосуботи (двічі)
В дім молитви йти.`,
  87: `Мій дорогий Ісусе,
Душу мою втішай,
Лагідними словами
До неї промовляй,
Щоб зникли хвилювання,
Щоб дух повеселів,
Щоб знов прийшло бажання
І сила для трудів.

Приспів: 
Мій Спасе, хай щоденно
Твої святі уста
Шепочуть до вух моїх:
«Нічого не лякайсь».
Хай в найніжніших тонах
Говорять до душі:
«І в горі, і в спокусах
Рятунок дам тобі»

Веди мене, Ісусе,
Прямим Твоїм шляхом,
Рятуй від зла й спокуси,
Сповняй святим страхом;
Щоб міг Тобі служити
Усе своє життя
І з радістю зустріти
Щасливе майбуття.

Промінням Свого Духа
Мій розум осявай,
А хлібом Твого Слова
Щоденно підкріпляй;
Щоб я Тебе постійно
Любив і величав, 
Твою святую волю
Охоче виповняв.`,
  88: `День цей суботній, освячений, славний,
Знову для нас подих раю приніс.
Радість і мир для душі Бог Всесильний
Шле в день святий серед горя і сліз

Дай мені сили, любові, терпіння
Бути рабом твоїм вірним завжди,
Славити в день цей Твоє вічне Ім'я
В радісних піснях святої хвали

О поможи мені гідним явитись
З жертвою уст чистих — даром моїм,
І перед троном Твоїм поклонитись
В дусі і в правді з народом Твоїм`,
  89: `Субота дана людям Богом,
Несе всім радощі святі.
Спокій в цей день той може мати,
Хто переносить біль душі.

O Боже, нас благослови
I втомлений дух оживи

Душа у повній мірі щастя,
Бог нині йде назустріч нам,
І чудо благодаті вдасться
Узріти знов моїм очам.
Він хлібом душу наситить
І щедро нас благословить

Дивлюсь на зорі в темнім небі,
Як хмаронька вгорі пливе,
Як пульс життя скрізь б'є і в серці
Подяки Богу гімн росте.
І відкриваються уста,
Щоб славити любов Христа

Твоє творіння все радіє,
Нема того, щоб хтось мовчав.
Співають всі тобі, кого Ти
В день сьомий Сам благословляв.
І нині, Боже всеблагий,
Прийми від нас цей спів святий`,
  90: `Спочатку, як Господь
Прекрасний світ створив,
Законом і життям
Природі всій вділив.
Він після днів шістьох спочив,
Він після днів шістьох спочив,
Навік день сьомий освятив

Бог освятив цей день,
Його благословив,
Щоб кожний, так як Він,
В суботу відпочив.
Бо ще перед падінням в гріх,
Бо ще перед падінням в гріх
Він дав цей день для нас усіх

Коли з Синаю Бог
Закон Свій сповіщав,
То вся гора тряслась
І страх людей проймав.
Він з-поміж громів промовляв,
Він з-поміж громів промовляв,
Святити сьомий день казав

Спаситель наш помер,
Закон Свій не змінив.
Як жити нам тепер,
Він приклад залишив.
Він Заповіді всі сповняв,
Він Заповіді всі сповняв,
І так людей усіх навчав`,
  91: `Я — вінець творіння мудрого Творця,
Він — мій добрий Пастир, я — Його вівця.
Від душі хваління багато пісень
Занесу я Богу в цей суботній день

Правдою Твоєю дух освячуй мій,
Від пороків серце Ти моє обмий.
Щоб душею чистий, вірою живий
Міг Тебе благати нині в день святий

Радістю святою замість марноти
Моє слабе серце Сам наповни Ти.
О прийди, мій Боже, храм Собі збудуй,
В цій малій оселі Ти завжди домуй

Перед вишнім троном я стою тут знов,
Славлю вічну мудрість і Твою любов.
Хай хвали спів ллється, мов струмок дзвінкий,
До престолу ласки нині, в день святий`,
  92: `В день суботнього спокою
Щастям сповнена душа.
Зустрічаюся з Тобою,
Боже мій, Тобі хвала!
Приспів: 
Славлю серцем і душею
Всі Твої благі діла,
І звучить понад землею
З уст дітей Твоїх хвала

Слава, слава, Боже правий,
За Твої дари святі.
Отче добрий і ласкавий,
Нас почуй на висоті.
Як колись Свій люд стежками
Ти в земній долині вів,
Так і будь сьогодні з нами,
Стережи від злих вітрів.
І в цей день святий, в суботу,
Мир і ласку нам даруй,
На Свою святу роботу
Нас, о Боже, приготуй.`,
  93: `Замовкни, суєто всіх днів, —
День Божий наступив.
Для відпочинку від трудів
Цей день Бог освятив. (Двічі)
Хай приготує нас Твій Дух
Перед лицем святим,
І розум дай, відкрий наш слух
До всіх наук благих. (Двічі)
Народ Твій нині в домі цім
До Тебе кличе знов, —
Почуй молитви, Боже, всіх,
Відкрий Свою любов. (Двічі)`,
  94: `Як любо і легко на серці мені,
Коли день Господній надходить в тиші.
Як тільки побачу вечірню зорю,
Я з радістю Богу приношу хвалу.
Приспів: 
Слава, слава Христу за те,
Що в Свій відпочинок привів Він мене

Затісно в хатині, — я прагну піти
До Божого дому, щоб радість знайти,
І в тихій молитві до свого Творця
Я буду просити, як просить дитя.
Святий день суботній спокій всім несе,
Вселяє надію, що скоро прийде
Христос, наш Спаситель, у славі Отця
І всім Своїм вірним дасть вічне життя.`,
  95: `Погляньте, як сьогодні
Радіють небеса,
Співає в день суботній
Все твориво Творця.
Приспів: 
Суботу пам'ятай завжди, її в покорі ти святи.
Так, завжди, так, завжди В покорі ти святи

Якщо Закон небесний
В серцях людей живе,
Тоді спокій чудесний
Суботній день несе.
Сьогодні Бог ще кличе
Дітей Своїх у дім, —
Щоб бути там з Ним ближче;
Нас буде вчити Він.
Коли сьогодні любий
Для нас цей день святий,
Яка ж то радість буде
В Вітчизні дорогій!`,
  96: `Суботній день святого спілкування, —
Минули дні всіх клопотів, тривог,
Забуті всі незгоди і страждання, (двічі)
І ми Тобі співаєм, вічний Бог
Душею й тілом в храмі спочиваєм,
Забувши світ з його життям марним.
Зібравшись, ми Ісуса прославляєм, (двічі)
Бадьорі духом, серцем молодим
Хай світ шукає нині в хвилях грішних
Пустих розваг для серця і душі, —
Їм невідомі звуки псалмів ніжних, (двічі)
Що ми співаєм Богу тут, в тиші
Хвала Тобі, Владико Всемогутній,
За день суботній, дивний і святий,
День радості тепер і в час майбутній, (двічі)
Хвала, хвала, Ісусе всеблагий!`,
  97: `Суботній день — це радість нам,
Мов рай став на землі.
Сам Дух пояснює серцям
Науки всі пресвяті
Предвічне Слово каже нам,
Який Бог добрий є.
З любові вічної до нас
Усім добро дає
Тож будем вірними Йому
У кожний день і час,
Він, Вічний Бог, веде крізь тьму
До Свого Світла нас
Ми дякуєм служителям
За їх духовний труд.
Вони про рай сказали нам
І про останній суд
Звучить ще голос той святий,
Що вибраних веде.
Ми знаємо — той час близький,
Коли в наш дім ввійдем`,
  98: `Славний, святий день, приємний спокій,
Пам'ять із раю несе він мені.
Ми знов зійшлися із різних сторін,
Щоби Творцеві віддати поклін.
Приспів: 
Славний, святий день, чудовий спокій,
День благодатний для вірних усіх.
Честь і хваління із наших сердець
Богу несеться з землі до небес

Славний, святий день — спокій від трудів,
Знайде людина все щастя у нім;
Слово Господнє, як їжу святу,
Прийме з подякою в душу свою.
В славний, святий день благого Творця
З радістю йдемо до Бога Отця,
Серце й думки лиш Йому присвятім,
В вічний спокій із святими ввійду`,
  99: `Боже, глянь, Твої ми діти,
В дім молитви всі прийшли,
Хочем серце оновити, (двічі)
Духа Свого нам пошли
Дай Слова Твої прийняти,
В серце наше запиши,
Щоб любов Твою пізнати (двічі)
Краще й глибше ми могли
І в цей день святий, в суботу,
З нами Ти перебувай.
На святу Твою роботу (двічі)
Всіх нас, Боже, посилай
В цьому світі так багато
І спокус, і боротьби;
Сили дай прожити свято, (двічі)
Щоб у вічність увійти`,
  100: `Алілуя, день суботній,
День приємний і святий,
Найдорожчий дар Господній,
Спокій від турбот земних.
День цей у красі своїй
Мир дає душі моїй
В день суботнього спочинку
Сповнений я радості.

Боже, дай його провести
У спокою й святості.
Мир і благодать Твоя
Хай наповнить всі серця
Посилай Твоє нам Слово
Через вірних вчителів,
Зрозуміти дай в покорі
Те, що Дух Святий відкрив.

Гімн подяки і хвали,
Боже, Ти від нас прийми
Поможи, щоб у хвалінні
День святий я закінчив,
Злий Твоє благословення,
Мов рясний дощ на засів.
Дай і в вічності Твоїй
Шанувати день святий`,
  101: `Який щасливий день для нас,
Який приємний серцю час,
Коли приходим в Божий дім,
Несем Творцю поклін.
Приспів: 
О, як гарно в день святий
І як любий той спокій,
Коли приходим в Божий дім,
Несем Творцю поклін

Господь серця нам просвітив
І щедро всіх благословив.
Достойний Він хвали людей —
Своїх земних дітей.

Важливіше понад усе —
Прославити Ім'я святе
В приємний час, в хвилини злі
І на Новій Землі.`,
  102: `Земні турботи залиши,
В дім Божий в день святий прийди,
Ім'я Господнє прославляй,
Честь і хвалу Йому віддай

Небесні ангели вгорі
Співають Богові пісні:
«Свят, свят, свят, Боже всеблагий,
Престол Твій вічний і святий»

Величний Боже в небесах,
Тебе ми славимо в піснях,
Із Твого храму, з висоти,
Благословення нам пошли

Своїм Ти Духом нас навчи,
Як жити в правді. Поможи,
Щоб ми святе життя вели
І в Царство слави увійшли`,
  103: `Утіху небесну для всіх сердець
Нам послав Отець, нам послав Отець.
Для слави Своєї зібрав Він нас
В цей суботній славний час.
Приспів: 
Боже наш, о прийди,
Кожне серце освяти,
Духом Сам нас навчай,
Благодать нам посилай

Ми будем молитись, щоб Бог благий
Дав нам мир святий, дав нам мир святий.
І словом Своїм підкріпляв всіх нас
В цей суботній славний час.
О Боже, даруй більше сили нам
Гріх перемогти, гріх перемогти,
Щоб ми могли всюди своїм життям
Вість спасіння всім нести.`,
  104: `Проснувшись в цей суботній день,
Подяку Богові несем
За сон міцний і за життя, —
Хвалу в молитві віддаєм

Ти нас вночі охороняв
Під Своїм захистом від зла,
І в дім молитви знов зібрав,
Коли зоря небес зійшла

Ти, Отче, нас благослови,
В духовній праці сили дай,
З Тобою жити поможи,
Із Книги вічної навчай

Свій Дух Святий з небес Ти злий
І в вірі нас усіх зміцни,
Любов'ю й ласкою зігрій,
Щоб ми щасливими були`,
  105: `Суботній день прийшов, і я радію,
Закінчив працю, тихо тут стою, —
Лише на Бога вся моя надія,
Йому поклін і славу віддаю.

Хор Ангелів хвалу мою приймає,
Мій голос славить Бога в день святий,
Того, Хто кров'ю грішних омиває, Спасителя,
Хто змив порок тяжкий

Ісусе мій, Твоя любов звільнила
Мене з гріхів, — Я маю ціль нову.
O дай, щоб правда, мов маяк, світила
В житті моєму, поки ще живу.

Бажаю я характер свій змінити,
Любити всіх, добро робити всім,
I кожний день Твоє Ім'я хвалити,
Звіщати про спасіння людям всім

Тебе, мій Боже, нині величаю, —
Мені субота серце веселить.
Люблю цей день, марний світ забуваю,
Шаную свято, як Закон велить.

Приходить він — всі клопоти лишаю, —
Господь дає мені святий спокій,
З любов'ю гімн хвали Йому співаю:
«Я — раб відкуплений, навіки Твій»`,
  106: `О, які веселі ми сьогодні всі,
Сповнені любов'ю до Творця вгорі.
Дзвінко аж до неба спів летить ген-ген,
Честь і слава Богу в цей суботній день

Це не голос дзвонів і не трубний звук.
Це любов відвічна нас єднає тут.
Ми зійшлись почути вісників слова
Про дорогу правди, світла і добра

О, який чудовий і приємний час;
Вся журба і горе залишають нас;
Під покровом Божим любо відпочинем,
Мир, любов і ласку в Ньому ми знайдем

Ми в покорі серця знов до Бога йдем,
До престолу ласки тут молитви шлем,
Щоб Він нас, як діток, поблагословив
І дарами Духа Свого наділив`,
  107: `З радісним серцем зустрічаємо день суботній.
Він — кращий день від інших днів на землі гріховній.
Радісно нам, Богом спасенним серцям,
Славен святий день Господній

Разом зібравшись в малому числі в день прекрасний,
Славим Творця, Який дає Свій мир благодатний.
День від Отця. Ми шануємо Творця.
Дав Він спокій нам відрадний

День цей в Законі дав Господь для всього творіння,
Слугам Його він завжди буде знаком спасіння.
Божа сім'я зустрічає святість дня
З радісним співом хваління

Хто збереже Закон, той на кристальному морі
Співати буде Агнця гімн в небесному хорі,
В Царстві Отця будем славити Христа
Вічно в небесному зборі`,
  108: `Боже, до Тебе йду,
Мій Боже, йду.
Всім серцем лину я
В славу Твою.
Весь шлях тернистий мій
І страх в душі моїй,
Боже, до Тебе йду,
Мій Боже, йду

Боже, до Тебе йду,
Мій Боже, йду.
Не бачу сонця я
В темряві зла.
Ти світло засвіти,
Дай сил перемогти.
Боже, до Тебе йду,
Мій Боже, йду

Боже, до Тебе йду,
Мій Боже, йду.
Зміцни слабий дух мій
В борні земній.
Дай шлях вузький пройти
І мир в Тобі знайти.
Боже, до Тебе йду,
Мій Боже, йду

Боже, до Тебе йду,
Мій Боже, йду.
Хто б дав на цій землі
Крила мені?
Піднявся б в небо я,
Де горя й зла нема.
Боже, до Тебе йду,
Мій Боже, йду`,
  109: `Спасителю мій любий,
Ти — зміст моїх пісень,
Пораднику єдиний
В час горя в смутний день.
Приспів: 
Спасителю мій славний,
Ти приклад доброти.
Немає в світі друга
Дорожчого, ніж Ти

Лиш Ти моя надія
В похмурі дні життя.
Як гряне зла стихія,
В Тобі сховаюсь я.
Тобі я довіряю,
Ти мій надійний Вождь.
Візьмеш мене до раю
З долини зла й незгод.`,
  110: `Я — не свій. Христом спасенний,
І належу лиш Йому.
Як здобуток той священний,
Я Ісусові служу.
Приспів: 
Я — Твій! Я — Твій!
І належу лиш Тобі.
Все, що маю, —
Всі бажання
Я до ніг кладу Твоїх

Я — не свій. Христос Спаситель –
Володар мого життя.
Він — Єдиний Відкупитель,
Провідна моя Зоря.
Я — не свій. Бог милостивий
Сам мене Своїм назвав.
В Царстві вічнім і щасливім
Дати уділ обіцяв.`,
  111: `Господь — мій Вождь, щасливий я,
Веде мене шляхом добра.
Я піду скрізь, де Він іде, —
Його рука мене веде.
Приспів: 
Він Сам веде, Він Сам веде,
Господь завжди зі мною йде.
Я піду скрізь, де Він іде, —
Його рука мене веде

Він радісним шляхом веде,
Веде в недолі день за днем,
Вдень чи вночі, — я сміло йду,
Бо держить руку Він мою.

Хоч часом ураган шумить,
І людське море клекотить,
Я не тривожусь і тоді, —
Моє життя в Його руці.

А як закінчу боротьбу
І віру в серці збережу,
То вічно з Богом буду я
В Країні щастя і добра.`,
  112: `Серце моє, Господь, даю Тобі,
Воно Твоє цілком,
У світі зла в великій боротьбі
Веди Своїм слідом.
Мене купив святою кров'ю,
Віддавсь я, Боже, Твоїй волі
Серцем моїм, серцем моїм

Серце моє, навік його прийми,
Хоча це дар малий,
Я прошу Ти моїм життям ряди,
Небесний Царю мій.
Хоч серце все гріхом покрите,
Немов темрявою повите
Серце лихе, серце лихе

Серце моє, що було кам'яне,
Принижене тремтить.
До Тебе лине, бідне і сумне,
Бо гріх його гнітить.
Під тягарем тяжким ридає,
До Тебе, Боже мій, зітхає
Серце моє, серце моє

Серце моє отримує спокій
В святій крові Христа.
Ісусе, Ти Один земний скарб мій,
А смерть Твоя — життя.
Мене спасають Твої рани,
І падають гріха кайдани
З серця мого, з серця мого

Серце моє, хай Дух Твій буде в нім,
Зроби його новим,
Як храм живий, благословенний дім,
Зроби його святим.
Завжди за Богом щоб тужило,
Його боялось і любило
Серце нове, серце нове`,
  113: `По шляху життя ми з радістю підем, —
Тільки треба вірити Ісусу.
Силу Божу в праці завжди ми знайдем, —
Тільки треба вірити Ісусу.
Приспів: 
Просвітліє шлях тоді,
Радість буде на душі,
Не впадемо в боротьбі, —
Тільки будем вірити Ісусу

Слово Боже зрозуміємо усі, —
Тільки треба вірити Ісусу.
Благодать наповнить серце в повноті, —
Тільки треба вірити Ісусу.
Воля Божа стане принципом життя, —
Тільки треба вірити Ісусу.
І щасливим буде наше майбуття, —
Тільки треба вірити Ісусу.`,
  114: `За Тобою, мій Ісусе,
Я бажаю завжди йти.
Куди Ти йдеш, туди рівно ж,
Прошу, і мене веди.
Приспів: 
За Тобою всюди піду,
Бо за мене Ти помер;
По дорозі тій тернистій
І мене веди тепер

Хоч вузький шлях і тернистий
І, мов море, без сліду,
Ти, однак, вперед ітимеш,
За Тобою я піду.
Якщо горе десь спіткає,
Небезпека надійде, —
Буду я й тоді спокійний,
Бо зі мною Ти ідеш.`,
  115: `Що потрібно більш, Ісусе,
У моїм житті?
На землі і в небі бути
Хочу при Тобі.
Приспів: 
Ти Один, Ти Один
Є завжди моїм життям
І тепер, на землі,
І колись в Небі

Хоч я славу й скарби мав би
Нарівні з царем,
Та якби Тебе не знав би,
Був би злидарем.
Хто б так довго терпеливість
Ще до мене мав?
Як схиблю, хто б на дорогу
Вірно направляв?
За весь світ я не віддав би
Віри у Христа,
Бо вона мені дорожча
За усе життя.
Відтепер Тебе всім серцем
Я триматимусь,
Аж візьмеш мене до Себе
В славу неземну.`,
  116: `Ісусе добрий мій,
Я чую голос Твій.
Ти звеш мене, щоб я прийшов,
І мир душі знайшов.
Приспів: 
О Ісусе мій,
Йду до Тебе я.
Вірю, змиє гріх тяжкий
Пречиста кров Твоя

Слабий і грішний я,
Та сила є в Тобі.
Оновлена душа моя,
Потужна в боротьбі.
Нове життя даєш,
І я радію тим,
Що в рідний край мене ведеш,
Де правди вічний дім.
Тобі повік хвала,
Ісусе, за любов;
Мене від зла навік спасла
Твоя пречиста кров.`,
  117: `В славний край чудес
До хвали небес
Стежкою добра вузькою,
Боже, я піду з Тобою
В Твій небесний рай,
Тихий, рідний край

Якщо прийдуть дні
Тяжкі і лихі, —
Силу дай, щоб в час недолі
Не зганьбив Твою я волю,
Бо до Неба шлях
Йде крізь сльози й страх

Ти — мій вірний Вождь,
Шлях життя злагодь.
Хоч і хрест буде нелегкий,
Ціль життя вже недалеко.
В дім небесний мій
Хай веде Дух Твій

В боротьбі тяжкій
Силу дай душі.
В час незгоди і терпіння
Дай надію на спасіння.
Хоч і зло навкруг,
Ти — мій вірний Друг

В душу влий мою
Ти любов Свою.
Боже, мудрість дай і вміння
Сміло нести стяг спасіння
Стежкою добра
В світлий дім Царя`,
  118: `Чую голос я Ісуса,
Ним постійно веселюся,
Його звуки в серце ллються:
«Візьми хрест свій і за Мною йди».
Приспів: 
Я візьму свій хрест з любов'ю,
Мій Ісусе, й за Тобою
Піду з вірою живою,
Цим тернистим і вузьким шляхом

Хоч мій шлях тернистим буде
І не злюблять мене люди,
Я, однак, з Ісусом всюди
Буду завжди йти Його шляхом.
Через гори і долини,
Хоч зустріну глум і кпини,
Мій Господь завжди щоднини
Сам поможе хрест тяжкий нести.

Мій Ісус завжди зі мною,
Він підтримує любов'ю,
Тож невпинною ходою
Я незмінно йтиму за Христом.`,
  119: `Ісусе мій, я хочу Тебе знати
І кров Твою пролиту пам'ятати,
До Тебе лиш звертати свої очі
В духовній ночі

Довго блукав по світі я, нещасний,
Шукав скрізь долі й шлях до Неба ясний,
Бог Сам знайшов мене і спас любов'ю,
Своєю кров'ю

Боже, я вдячний за Твій дар спасіння,
Хай Тобі з серця лине гімн хваління.
Дозволив Ти до Себе приступити,
Щоб я міг жити

Дай мені сили вірним Тобі бути,
Важкий Твій хрест ніколи не забути,
Тебе в житті постійно прославляти
І величати`,
  120: `Був той час, коли по світі
Я без Бога скрізь блукав
І Його Благої вістки
Про спасіння я не знав.
Але вічною любов'ю
Він в гріхах мене знайшов
І Свою дорогу нову
Сам відкрив до Неба знов.

Приспів: 
За Ісусом хочу йти,
(За Ісусом хочу йти, щоб спасіння осягти)
Щоб спасіння осягти.
(За Ісусом хочу йти, щоб спасіння осягти)
Буду лиш Йому служити
(Буду лиш Йому служити і завіт з Ним берегти).
І завіт з Ним берегти.
(Буду завжди я Завіт з Ним берегти)

О, яка велика радість,
Що Ісус мене знайшов,
Він мені дарує милість,
Він мій Бог — моя любов.
Смерті більше не зазнаю,
Бо Ісус зі мною йде,
А як прийде час відчаю,
Він потіхою буде.

А тепер моє бажання —
Вічно славити Христа.
Він дає під час страждання
Нам надію на життя.
O візьми мене за руку,
Мій Ісусе дорогий,
I направ з долини муки
В Свій небесний Край святий.`,
  121: `В наших руках прапор Бога живого, —
Встанем і вище його підіймем.
Він до життя нас покликав святого,
Ми за Христом нашим сміло ідем.

Приспів: 
Всі за Ісусом,
(Всі за Ісусом сміло)
Радісно в битву ідем, (ми ідем!)
Повну одержим
(Повну одержим над злом)
Ми перемогу,
(Ми перемогу сміло)
Всі за Ісусом вперед (ми підем)

Гордість і славу забудем назавжди,
Грішних покличемо Бога любить.
Він їх звільнить від духовного гніту,
В Небі з Ісусом ми зможем спочить.

Сміло підем до людей цього світу,
З радістю скажемо їм про Христа.
Він їх звільнить від духовного гніту,
Дасть всім надію на вічне життя.

Бог нам послав силу Духа Святого.
Браття, вперед за Ісусом підем!
Візьмемо прапор життя й перемоги,
З вірою його й співом понесем.`,
  122: `Вперед! Всі за Ісусом, —
Ми воїнство Його,
Здолаємо спокуси
І переможем зло.
Негайно запасемось
Щитом Його святим;
Меч істини візьмемо
І переможем з Ним!

Вперед! В ім'я Ісуса
Ми з вірою підем,
Нещасну бідну душу
До Бога приведем.
Він прагне освятити
Наш труд і шлях земний,
Тож будемо любити
Закон Його святий

Вперед! Всі за Ісусом!
Він скоро вже прийде
І всім, хто з Ним працює,
Заплату принесе.
Хто гріх тут переможе
І правду збереже,
Таких прийняти зможе
Христос, коли прийде`,
  123: `Як світло дня, життя моє
Хай в темряві сія,
Заблудних до Христа веде
В щасливе майбуття.

Приспів: 
Боже, все життя
(Боже, все життя віддаю Тобі)
Віддаю Тобі,
(Боже, все життя віддаю Тобі)
Ти мною Сам керуй щодня
Тут, на землі

Мов квітка та, моє життя
Хай пахне і цвіте,
В похмурі дні всього буття
Надію всім дає.

Життя хай піснею звучить,
До неба кличе всіх.
Хай дух ослаблий підкріпить,
Надію й віру їх.

Убогим, бідним і сумним
Присвячую життя,
Щоб і вони шляхом вузьким
Прийшли у дім Отця.

Безцінний дар — життя моє,
Що маю від Творця,
Хай щастя людям всім дає
До славного кінця.`,
  124: `Свій маяк Отець Небесний
Вічним світлом засвітив.
Нам вогонь цей прибережний
Пильнувати доручив.

Приспів: 
Хай же світло наше сяє,
Людям вказує всім путь,
В тиху пристань направляє,
Де їх щастя й спокій ждуть

Мов ті хвилі, гріх вирує,
А навколо — темнота,
Подорожнього турбує, —
Світла нашого нема.

Тож поправ світильник, брате,
Щоб плавець, що заблукав,
В морі зла не став безрадним,
І навіки не пропав.`,
  125: `Божа правда світить ясно,
Мов у пристані маяк,
На котрий то повсякчасно
Пильно дивиться моряк.

Приспів: 
Хай же світло правди сяє
Ясно в темряві нічній,
Щоби ті, котрі блукають,
Підійшли до пристані

Тьма покрила світ широко,
Море піниться, шумить.
Не одне тривожне око
Пильно вдалечінь глядить.

Тож поправте ваше світло!
Може, не один моряк
Біля пристані десь гине,
Бо не світить ваш маяк.

Незабаром вже скінчаться
Всі незгоди на землі.
Видно рідний берег щастя,
Де радіти будем всі.`,
  126: `Спокій небесний я знайшов,
Як до Христа прийшов.
Моє Він серце відновив,
Мої гріхи простив.

Біля криниці Сихаря
Я був з Христом моїм.
Не раз була душа моя
Там, в Галілеї з Ним.

Приспів: 
Там, в Галілеї з Ним,
Так часто бачу я
Себе там, в Галілеї з Ним,
Там, в Галілеї з Ним

Я бачу той тернистий шлях,
На нім Христову кров.
Ми всі блукали у гріхах,
Та нас спасла любов.

Любов Христа нас підняла,
Гріхи простила всі.
Бушують в світі хвилі зла,
Життя лише в Христі.

Іду вперед вузьким шляхом
В небесний вічний край.
Я вірю: йдучи за Христом,
Ввійду в блаженний рай.

Я на служіння все життя
Спасителю даю
І у щасливе майбуття
Колись з Ним увійду.`,
  127: `О Боже мій, не ради слави
Всім серцем я Тебе люблю.
Єдиний Ти у світі правий,
Мені дай праведність Твою

Прямую, Боже, за Тобою, —
Навіки я служитель Твій,
Бо Ти ціною дорогою
Купив мене, простив гріх мій

Про Тебе людям розказати —
Найбільше щастя це моє,
Спасіння вічне сповіщати,
Щоб Ім'я славилось Твоє

З Тобою завжди хочу бути
Тут, на землі, і в Небесах.
Вітчизну слави осягнути,
Прославити тебе в піснях`,
  128: `Хто з вірою гляне на жертву Христа,
Прощення одержить в ту ж мить.
Мій друже, прийди до підніжжя хреста,
Тобі всі гріхи Бог простить.

Приспів: 
Глянь, глянь, друже, глянь!
Хто з вірою гляне на жертву Христа,
Прощення одержить в ту ж мить

Спаситель страждав за провини твої
І в муках помер на хресті,
Святу кров пролив в милосерді Своїм,
Щоб дати спасіння тобі.

Сумнів геть відкинь і на хрест подивись,
Скоріш до Ісуса прийди.
Син Божий помер, щоб могли ми спастись,
Надійся на Нього завжди.`,
  129: `Хоч твій хрест важкий порою, —
Вгору поглянь.
Не слабій, Христос з тобою, —
Вгору поглянь.

Приспів: 
О, неси свій хрест з терпінням, —
Вгору поглянь.
І одержиш ти спасіння, —
Вгору поглянь!

Хоч буває часом страшно, —
Вгору поглянь.
За Христом іди безстрашно, —
Вгору поглянь.

В боротьбі хоч і ослабнеш, —
Вгору поглянь.
Тільки з Богом переможеш, —
Вгору поглянь.

Хоч і смуток душу гнобить, —
Вгору поглянь.
Знай: Спаситель тебе любить, —
Вгору поглянь.`,
  130: `Твердо я вірю в те, що Ісус
Є мій Спаситель, я Ним веселюсь.
Вічність на Небі тим Він дає,
Хто Божу ласку тут визнає.

Приспів: 
Славити будем Ім'я святе,
Ім'я Ісуса всім дороге.
Він лиш достойний слави й хвали,
В Ньому спасіння люди знайшли

Твердо я вірю з того часу,
Як осягнув я молитви ціну.
Мир наповняє серце моє,
В вірі відкрив я щастя своє.

Твердо я вірю: В Божих руках
Доля людини і вічне життя,
Що би не сталось, — радісний дух —
Вічно зі мною Пастир і Друг.

З Господом маю повний спокій,
Він — моє Світло, Він Вчитель мій.
Дай, щоб Тобі я серце віддав
І волю Неба людям звіщав.`,
  131: `Від гріха вільний я
Через жертву Христа.
Щирим серцем я вірю в Ісуса.
Він спокій дав мені
І тягар зняв з душі.
В Сина Божого вірую я.

Приспів: 
Вірю я, вірю я,
Щирим серцем я вірю в Ісуса.
Вірю я, вірю я,
В Сина Божого вірую я

Що за радість Він дав, —
Своїм сином назвав.
Щирим серцем я вірю в Ісуса.
Він мене полюбив,
Шлях спасіння відкрив.
В Сина Божого вірую я.

Він мене викупив,
Щоб Йому я служив.
Щирим серцем я вірю в Ісуса.
Він чекає мене,
І до Себе прийме.
В Сина Божого вірую я.`,
  132: `Ми ідемо в Ханаан,
В наш небесний Край.
З вірою пройдем Йордан,
Жде нас Божий рай.

Приспів: 
Боже, віри більше дай,
З нею ми ввійдем
В той небесний, вічний Край,
Де спокій знайдем

Може, доведеться йти
Через море нам, —
Будем твердо вірити
Всім Його словам.

У небесний Ханаан
Шлях вузький веде.
Ним пройшов Спаситель
Сам І нас проведе.`,
  133: `За святу Христову віру
Станем дружно, як один,
І за Господом всі сміло
Лиш вперед, вперед за Ним!

Приспів: 
Сміло, дружною сім'єю,
Як один, вперед ідем.
Щирим серцем і душею
Богу ми хвалу несем

За Тобою йти не страшно
По дорозі цій земній.
Пронесемо ми відважно
Прапор правди Твій святий.

Наша сила — віра в Бога.
Гедеон це добре знав.
Він одержав перемогу
І поразки не зазнав.

Віри щит у бій візьмемо
В боротьбі з важким гріхом.
Сміло, радісно підемо
За Спасителем Христом!`,
  134: `Сильну віру, брате, май,
На Христа свій зір звертай.
Хоч і море зла кипить,
«Не лякайсь!» — Ісус велить.

Приспів: 
Вір, мій брате, як дитя,
В вірі — праведність твоя.
Скоро наш Господь прийде,
Нагороду принесе

Сильна віра — Божий дар,
В серці чуєш мовби жар.
Це Дух Божий свідчить нам,
Що кінець прийшов гріхам.

Не лякайся, брате мій,
Непохитно в вірі стій,
Хоч би навіть смерть прийшла,
В вірі радість і життя.`,
  135: `Коли Божий мир наповняє серця,
Хоч буря навколо шумить,
В надії я Богу вручаю життя, —
Тільки Він є мій захист і щит.

Приспів: 
Мій Господь (мій Господь),
Мій Господь (мій Господь),
Мій Господь є мій захист і щит!

Коли ворог злий ставить сіті свої
І віра ослабне моя,
То вістка блага, що простив Ти мій гріх,
Сяє в темряві, наче зоря.

Гріхи всього світу на Себе Ти взяв,
Святу дарував нам любов,
І кров'ю Своєю спасіння всім дав;
Нас, заблудних овець, Ти знайшов.

Віднині бажаю я жити з Христом,
Бо в Ньому знайшов свій спокій.
Навіки сьогодні прощаюсь з гріхом,
Щоб любити Закон Твій святий.`,
  136: `«Вір, душе, надійся! — каже Пастир твій, —
Завжди лиш дивися на світильник Мій.
На шляху тернистім поміч Я подам.
Я з тобою всюди, вір, що тепер ти не сам!»

Приспів: 
Ні, я не один.
(Я не один, я не один)
Ні! Я не один!
Спаситель Сам завіряє: (Двічі)
«Ні, ти не будеш один!»

Квіти всі зів'януть, сонечко зайде,
Та Господня милість з нами вік живе.
Хоч лютує буря в темряві нічній, —
Мій Ісус зі мною, відтепер навіки мій!

Хоч важка дорога земного життя,
Чую голос Божий: «Ти — Моє дитя».
Вірю, що Спаситель вгорі захистить.
Скоро всі спасенні з Ним навіки будуть жить.`,
  137: `Коли мій дух ослабне тут порою,
Заниє серце боляче до сліз,
Коли нещастя гіркою рікою
Підуть лавиною на мене скрізь;

Приспів: 
Тоді молюсь в надії я живій:
«О будь зі мною, Боже мій.
О будь зі мною кожний день і час,
Щоб мій світильник не погас»

Коли залишать, погордують мною
Мої всі добрі друзі давніх літ,
Залишусь я самотньою душею
І стане темним навколишній світ.

Коли смерть люта забере з собою
Того, хто найдорожчий понад все,
І біль страшний камінною стіною
До ліжка мого прикує мене, —

Тоді молюсь я з вірою живою:
«Пролий, мій Боже, світло й мир на всіх,
Тьму освіти зорею провідною,
Щоб світ увесь Тебе пізнати міг».`,
  138: `Браття, всі радійте, — славний день настав!
Сестри, веселіться, — Бог нам радість дав:
Ми, колись далекі, а тепер свої:
Нас усіх з'єднала кров Христа навік.

Приспів: 
Всі співайте: алілуя!
(Всі співайте: алілуя! Всі співайте: алілуя!)
Бог нас спас і оправдав.
(Бог нас спас і оправдав, Бог нас спас і оправдав,)
Наші імена навіки
(Наші імена навіки, наші імена навіки)
В Книгу вічну записав.
(В Книгу вічну записав, навіки записав)

Ми тепер відвагу маємо в серцях
З вірою просити прощення в Отця.
Слово благодаті чуємо з хреста, —
Ми спаслись від гніву через кров Христа.

В єдності й любові відтепер живем,
І, обмиті кров'ю, до Небес ідем.
Віра і надія веселять серця;
Будем жити вічно через кров Христа.`,
  139: `Почув я про Церкву Христову, — 
В ній радість для себе знайшов, 
Відчув я у серці обнову 
І вдячний за Божу любов.

Приспів: 
О друже, йди, йди, 
До Церкви живої йди, друже, 
(Йди, йди, йди, йди, йди, йди, йди) 
Там радість для серця знайдеш. 
(Йди, йди, йди, йди, йди, йди, йди) 
Повір і віддайся Ісусу, — 
У вічне блаженство ввійдеш

Ходив я усюди по світу 
І щастя ніде не знайшов. 
Скінчився мій шлях безпросвітній, 
Коли я в цю Церкву прийшов. 
«Прийдіть, — всіх Христос закликає, — 
Я радість вам дам і спокій, 
Де горя і сліз вже немає, — 
У вічній Країні святій».`,
  140: `Радість невимовну мають Небеса: 
Блудний син назавжди повернувсь; 
З Богом примирився, каявся в сльозах, 
І в одежу Батька зодягнувсь.

Приспів: 
«Слава, слава Богу в небесах!» — 
Вторить ангелам уся земля. 
Не замовкне хор невільників гріха; 
Їх спасла від смерті кров Христа

Радість невимовну мають Небеса: 
Знайдена загублена вівця; 
Мандрівник нещасний, мертвий у гріхах, 
Нині встав для вічного життя. 
Скоро заспіває наша вся земля, 
Звільнена від смерті і гріха, 
В небі засіяє, мов нова зоря, — 
Так прославиться любов Христа.`,
  141: `Радісно пісня лунає  
І славлять Господа Небеса  
В той день, як грішник вертає  
В свій рідний дім до Отця,  

Приспів:  
Радісно всі заспівайте —  
Грішник до Бога вернувсь!  
З ангельским хором з'єднайтесь,  
Сина приймайте в сім'ю (у сім'ю)

Небо радіє й співає  
Про Божу ласку до всіх людей.  
Бог всіх охоче приймає,  
Мов батько рідних дітей.  
Ця радість буде тривати  
Вічно, як прийде Господь з небес.  
Кожний там буде співати,  
Як прийме вірних Отець,  
Двері до неба відкриті,  
Дух Божий кличе всіх нас: «Прийдіть,  
Кров'ю святою омиті,  
І в Царстві слави живіть.`,
  142: `Радість щира і хваління  
Хай несуться із сердець,  
Наші співи і моління  
В небі чує Бог Отець.

Приспів:  
Хай постійно радість віри  
Підкріпляє нам серця,  
Любить нас Христос без міри  
І приводить до Отця

Бог тримає нас за руку,  
Підкріпляє в боротьбі,  
Він відводить від спокуси,  
Помагає у біді.  
Ми несем подяку щиру  
За ту радість, що Бог дав;  
Він в сім'ї єдиний, в мирі  
Із Собою об'єднав.  
Вірних Бог охороняє  
У Своїй руці міцній,  
Із недолі підіймає  
І дає душі спокій.`,
  143: `Якщо важко нам на серці стане, —  
Скажем Ісусу, скажем Ісусу.  
Якщо в горі стан стрункий зів'яне, —  
Скажем Ісусу про все.  

Приспів:  
Скажем Ісусу, скажем Ісусу, —  
Він нас спасе від спокус.  
Нема друга близького такого,  
Як наш Спаситель Ісус  

Тяжка втрата нам спокій зворушить, —  
Скажем Ісусу, скажем Ісусу.  
Чи таємний гріх постійно мучить, —  
Скажем Ісусу про все.  
Смерть найближчих вносить тінь сумніву,  
Скажем Ісусу, скажем Ісусу.  
Чи не можем подолати гніву, —  
Скажем Ісусу про все.`,
  144: `Хоч і важко не раз, може, сльози гіркі  
Затуманюють ясний твій зір, —  
Не сумуй і не плач, бо  
Спаситель тобі Дасть рятунок. Йому лиш повір!  

Приспів:  
Він, Він, тільки Він!  
Тільки Він помагає тобі в боротьбі,  
Зігріває в любові Своїй  

Хоч і давить тягар твоїх власних гріхів,  
І не раз страшний відчай гнітить, —  
Ти не слабни, за гріх твій Спаситель терпів,  
Йди до Нього, тебе Він простить.  
Хоч і серце твоє часто ниє від мук,  
Може, жити й страждати втомивсь, —  
Не сумуй, не складай безнадійно ти рук,  
Бог з тобою завжди, підіймись!  
Укріпи знемагаючі руки твої,  
І надію на Бога зміцни,  
Та з любов'ю у серці, в покорі святій,  
Брате, стежкою правди іди.`,
  145: `Якщо ти знеможений впадеш в безсилля,  
Ослабнеш в нерівній тяжкій боротьбі,  
І каплю за каплею з чаші страждання  
Ти вип'єш, і важко так буде тобі, —  
Не падай же духом, вперед іди знов, —  
Є віра, надія, любов  

Якщо твоє серце заниє від болю,  
Настануть сумні та безрадісні дні,  
Душа не відчує святого спокою,  
Ніхто їй не скаже: Іди, відпочинь, —  
Одне лиш зігріє і душу, і кров, —  
Це віра, надія, любов  

А може, спіткає тебе важка втрата —  
Не плач безутішно, в тугу не впадай.  
Хоч сталось нещастя в житті, любий брате,  
Надійся на Бога і не нарікай.  
У той час потішить твоє серце знов, —  
Це віра, надія, любов  

Не вистачить волі, ослабнуть всі сили  
І буде тонути в сумнівах душа,  
Одне пам'ятай й збережи до могили:  
З Христом і в стражданнях нам любе життя,  
Бо щастя найбільше у тому лежить, —  
Надіятись, вірить, любить`,
  146: `Укрий своє горе від людських очей, —  
Сліз в світі багато і горя в людей.  
Схились на коліна в нічну цю пору,  
Відкрий твоє горе Ісусу Христу  

Христос тільки знає все горе твоє, —  
Тебе приласкає, на груди візьме,  
І світло засвітить в дорозі твоїй,  
Він смуток розвіє, душі дасть спокій  

Серця так страждають під гнітом гріха, —  
З любов'ю скажи їм про благість Христа,  
Зітри свої сльози, сумним радість дай,  
В день горя і смутку Ісуса шукай`,
  147: `Дорогі слова Ісуса,  
Що в обітниці Він дав:  
«Як зустрінеш ти спокусу,  
Поведу тебе Я Сам».  
Приспів:  
«Поведу Я, поведу,  
(Поведу Я, поведу Я)  
Поведу тебе Я Сам.  
(Поведу тебе, тебе Я Сам)  
Через всі земні тривоги  
(Через всі земні тривоги)  
Поведу тебе Я Сам».  
(Поведу тебе, тебе Я Сам)  

А як ворог підступає,  
Хоче звабити мене,  
Вмить слова Христа згадаю:  
«Поведу Я Сам тебе».  
І коли в тяжкім відчаю  
Смуток серце обійме,  
То й тоді я твердо знаю:  
Не залишиш Ти мене.`,
  148: `Друже, з гріхом ти борися,  
Який все руйнує кругом.  
Кров'ю Ісуса омийся,  
Зморений тяжким гріхом.  
Якщо приходить спокуса,  
Клич ти на поміч Ісуса,  
До Нього йди без примусу,  
Ти, зморений тяжким гріхом,  
Ти, зморений тяжким гріхом  

Він збереже тебе всюди,  
Сам твій тягар понесе,  
В горі тебе не забуде,  
Сльози з очей обітре.  
Бачить твої Він страждання  
І співчуває зітханням.  
Скоро затихнуть ридання,  
Він сльози з очей обітре,  
Всі сльози з очей обітре`,
  149: `«З нами Бог! Хто буде проти нас? (З нами Бог!)  
З нами Бог! Хто буде проти нас? З нами Бог!  
З нами Бог! Хто буде проти нас? (З нами Бог!)» —  
Так Павло, апостол, записав  

«Ось Я з вами буду кожний день, (кожний день).  
Ось Я з вами буду кожний день, кожний день.  
Ось Я з вами буду кожний день, (кожний день)», —  
Так Господь Спаситель нам сказав  

«Кров Христа змиває кожний гріх, (кожний гріх).  
Кров Христа змиває кожний гріх, кожний гріх.  
Кров Христа змиває кожний гріх, (кожний гріх), —  
Так Йоан, апостол, написав  

Дар Святого Духа нам Господь (обіцяв),  
Дар Святого Духа нам Господь обіцяв,  
Дар Святого Духа нам Господь (обіцяв), —  
І пророк Йоіль це провіщав`,
  150: `Воїнів Своїх Господь провадить в бій,  
Щоб з гріхом боротись в боротьбі земній.  
Хоч числом нас мало, — духом сильні ми,  
Не страшні нам вороги.  
Приспів:  
Сміло, дружно в бій підем з гріхом,  
Духом сильні за Вождем Христом!  
Правди стяг ми вище підіймем, —  
Перемога жде нас з кожним днем!  

Грізний та суворий бій нас не страшить,  
Чистих уст молитва в битві підкріпить.  
Стійте в вірі твердо проти сил гріха!  
Перемога — дорога.  
Воїни Христові, сміло йдіть за Ним,  
За Христом єдиним, за Вождем святим.  
Переможець славу вічну осягне,  
Як Господь з небес прийде.`,
  151: `Якщо тебе тягар гнітить,  
Не думай, що це страшний суд.  
Хотів би ти кудись втекти,  
Однак терпіти треба тут.  
Приспів:  
Чекай, (тихим будь), (Двічі)  
Тихим будь, не нарікай,  
Чекай, (тихим будь), (Двічі)  
Чекай, не нарікай (не нарікай)  

У тебе терен на путі, —  
Він був в Христа на голові.  
Згадай, як тяжко Він страждав,  
За тебе хресну смерть прийняв.  
Надійсь на Бога і кріпись,  
Ісус з тобою поруч йде,  
Тож з вірою завжди молись, —  
Твій хрест на Себе Він візьме.  
Вже скоро світлий день прийде,  
Минеться біль, журба і гріх.  
Христос усіх нас приведе  
В край щастя, миру й вічних втіх.`,
  152: `Мир — це є мрія всіх людей землі,  
Та лиш в Ісусі мир знайдуть усі.  
«Мир Свій небесний Я даю для вас» —  
Слова Христа звучать в останній час.  
Приспів:  
Мир, повний мир,  
(Мир, повний мир, мир, повний мир,)  
Бог шле в усі серця.  
(Бог шле в серця, Бог шле в серця)  
Цей благодатний мир  
Бог ллє в серця,  
(Цей повний мир  
Бог ллє в серця,)  
Бог ллє в серця.  
(Цей повний мир  
Нам ллє в серця)  

«Мир Свій даю вам, хоч і боротьба  
Ще не прийшла до славного кінця,  
Але із миром ви ідіть в цей світ,  
Про мир небесний людям розкажіть».  
Мир, повний мир і радість всю сповна  
Дістануть вірні з рук Свого Творця.  
Під новим мирним небом всі разом  
Прославим Бога за Його любов.`,
  153: `На серці лиш пісня одна (одна),  
І з радістю ллється вона (вона),  
Завжди, як жива течія,  
Мир, мир — дарунок Христа.  
Приспів:  
Мир, Божий мир, —  
Славний дарунок Небес (Небес).  
О дивний, солодкий той мир!  
Мир, мир — дарунок Христа!

Світ викупив смертю Христос (Христос),  
За гріх наш Себе Він приніс (приніс),  
Бог дав нам і ліки від сліз,  
Мир, мир — дарунок Христа.  
Коли я Ісуса пізнав (пізнав),  
Він в серце спокій мені дав (Він дав),  
Його я навіки прийняв,  
Мир, мир — дарунок Христа.  
Христос — моя радість і мир (і мир),  
Мені він життя подарив (дарив),  
До неба дорогу відкрив,  
Мир, мир — дарунок Христа.`,
  154: `Ісуса люблю я, бо Він спас мене,  
До Нього молюся, Він чує мене.  
Ісусе, за мене Ти в муках помер,  
Тому усім серцем люблю я Тебе.  
До самої смерті любитиму я  
Ту жертву Голгофи — Ісуса Христа.  
Мої всі гріхи Він на Себе поклав  
І смертю Своєю життя дарував.  
В Країні небесній, куди я прийду,  
Христові віддам честь, поклін і хвалу.  
Там вічно з Ним житиму я в Небесах,  
І горе забуду, і сльози, і страх.`,
  155: `Хоч би я всі земні скарби,  
Мудрість і знання придбав,  
План і Божу волю знав би  
І всім серцем виповняв,  
Та мої усі старання  
Перед Господом святим,  
І вся мудрість, і пізнання  
Без любові є нічим  

Хоч би царські мав палати,  
Славу добру між людьми,  
Хоч би мав я дар зціляти,  
І добро робив завжди,  
Хоч би ангельські знав мови —  
Все це не спасе мене.  
Без братерської любові  
Я, як мідь, що лиш гуде  

І хоч був би я пророком,  
Все таємне виясняв,  
Віру мав таку глибоку,  
Як муж Божий Авраам,  
Так, щоб на наказ мій гори  
Пересунутись могли,  
Але віра без любові  
Буде словом лиш пустим  

Хоч майно своє роздав би  
Тим, в кого його нема,  
І за друзів я віддав би  
Навіть і своє життя.  
Та даремні всі старання  
Без небесного вогню,  
Як у всіх цих починаннях  
Божого нема дару  

Бо любов — це дар найвищий,  
Даний Господом для всіх.  
Срібло, золото час знищить,  
Буде лиш любов повік.  
Навіть віра і надія  
Відійдуть, як час прийде,  
І зруйнуються стихії, —  
Лиш любов не промине`,
  156: `За святу Христову віру  
Прапор правди підіймем,  
З Духом Божим в повній мірі  
Лиш вперед, вперед підем.  
Приспів:  
Всі єдиною сім'єю,  
З Словом правди і псалмом,  
Щирим серцем і душею  
Підем сміло за Христом

Люди істину забули  
І відкинули Христа.  
Всім розкажем, щоб почули:  
Він — лиш Правда і життя.  
Будем вірно захищати  
Вічний Божий Заповіт,  
Про спасіння сповіщати,  
Щоб почув увесь наш світ.  
Подвиг віри — шлях суворий,  
Але треба ним пройти,  
Зберегти Закон Христовий,  
В Царство Боже увійти.`,
  157: `О Ісусе, дай сили мені  
Щирим серцем любити Тебе,  
Не забути, як Ти на хресті  
Дав розп'яти за грішних Себе  
Ти спасіння всім даром даєш,  
Тішусь я, що мене Ти купив,  
Але чую Твій голос благий:  
«Отче Мій, чи усім Ти простив?»  
О, я знаю, як важко було  
Відкупити Тобі усіх нас.  
Маю щастя в житті лиш одне —  
Що люблю Я тебе кожний час  
Хочу жити з Тобою завжди,  
Твій Закон до кінця зберегти,  
Хочу всім сповістити, як Ти  
Захотів грішний рід наш спасти`,
  158: `Слуги Христові, день швидко летить, —  
Нива доспіла давно вже стоїть.  
Встаньте до діла, беріть всі серпи,  
Жніть на полі жниво і в'яжіть у снопи.  
Приспів:  
Брате мій, трудись і молись!  
Бог ще чекає на сніп твій живий.  
Скоро закінчим ми труд наш святий.  
О Господь великих жнив, скоріше прийди!

Праці багато, та мало женців, —  
Всюди чекають Господніх рабів.  
Встаньте скоріше в ряди Божих слуг,  
Сам Господь Спаситель — Помічник ваш і Друг.  
З поля пшеницю збирайте мерщій, —  
Бог вам готує вінок золотий.  
Скінчивши жниво, усі зі снопом  
З радістю постанем перед славним Христом.`,
  159: `Ідіть, посли, по всіх краях  
З Христовим світлом у серцях.  
Усіх, кого б зустріли ви,  
Просіть, щоб до Ісуса йшли.  
Приспів:  
Приведіть, приведіть,  
Приведіть всіх у батьківський дім.  
Приведіть, приведіть,  
Приведіть їх до Ісуса

До всіх знеможених ідіть,  
У вірі й правді підкріпіть.  
Хто заблудився, наверніть,  
Про ласку Божу розкажіть.  
Слухайте: голос Пастиря  
Лунає в горах і лісах,  
Скликає Він ті овечки,  
Що від отари відійшли.  
Прислухайся: там, вдалині,  
Ледь чути тихий зойк душі;  
Господь тобі велить: іди,  
Заблудних до Отця веди.`,
  160: `Слухайте, як Божий голос  
Знов до праці кличе вас:  
«Ниви білі, повний колос  
І настав гарячий час!»  
Бог заплату обіцяє  
Тим, хто вже до праці йде,  
Хто на клич відповідає:  
«Я піду, — пошли мене!»

Хоч не можеш десь далеко  
Нести людям вість благу,  
Постарайсь серед сусідів  
Душу щиру віднайти.  
А коли ти скарбом бідний,  
Хоч вдовину лепту дай,  
Бог прийме завжди дар гідний,  
Тільки щире серце май

Хоч ти менше красномовний  
Від апостола Павла,  
Завжди будь життям готовий  
Свідкувати про Христа.  
Станем дружно працювати,  
Сповним ревністю серця,  
І підем людей всіх звати  
В рідний дім Свого Отця`,
  161: `О дай нам, Боже, давніх свідків,  
Котрі б на варті пильними були,  
Вдень і вночі від хижих звірів  
Твою отару вірно стерегли.  
Щоб голос їх по всій землі звучав,  
В серцях людей надію відживляв  

Хай всюди вість Твоя лунає  
Могутнім голосом із краю в край,  
З пітьми гріха всіх направляє  
На шлях вузький, який веде в Твій рай.  
O Боже, глянь, як цілий світ доспів,  
Жнива великі, та нема женців  

Пошли скоріше правди Слово  
До всіх людей, що в темряві живуть,  
А нам з Небес дай Духа Свого,  
Щоб ревністю наповнив нашу грудь;  
Від сну гріха народ Твій пробуди  
I слуг Своїх благослови труди  

Рівняй стежки дочки Сіону,  
А Сам лише вперед як Вождь іди;  
Під стягом вічного Закону  
Своїх відкуплених дітей веди.  
Спаси овець від пастирів лихих  
І приведи до чистих вод живих`,
  162: `Одне лиш листя без плода.  
Ти засмутив Христа.  
Тебе до смерті Він любив,  
А чим Йому ти відплатив?  
Ти не приніс плодів, —  
Твоїх трудів, твоїх трудів  
Одне лиш листя без плодів  
Від всіх твоїх трудів.

Де ж добрий плід з життя твого,  
Що твій Господь чекав його?  
Без плоду все життя, —  
Одне листя, одне листя  
Сумний це стан, коли нема  
Ні жодного снопа.  

Чи встоїш ти перед Христом?  
Що скажеш ти перед судом?  
Покайся й принеси  
Святі плоди, святі плоди`,
  163: `Дехто звершив труд золотий,  
Здійснивши подвиг свій святий.  
Дехто Ісуса прославляв,  
Про Його ласку сповіщав.  
Друже, чи був то ти? (Двічі)  

Дехто у світлі лиш ходив  
І вірно Господу служив.  
Дехто про ближніх завжди дбав,  
З любов'ю їм допомагав.  
Друже, чи був то ти? (Двічі)  

Дехто жив в правді на землі  
І славив Господа всі дні.  
Дехто за правду постраждав,  
Навіть життя за неї дав.  
Друже, чи був то ти? (Двічі)`,
  164: `Браття, скоріш до діла,  
Бо надійшла пора,  
Вже нива побіліла  
І зійшла зоря.  
Виходьте всі на ниву,  
Спішіть, бо дні пройдуть,  
Бог нам дарує всім силу,  
Щоб скінчити труд  

Браття, вставайте дружно,  
Працюйте серед дня.  
На працю треба мужньо  
Посвятитися.  
О ви, раби Христові,  
Прийдіть допомогти,  
І будьте всі готові  
Вже на ниву йти  

Браття, вставайте сміло, —  
Бог світлий день дає,  
Візьмемося за діло, —  
Скоро ніч прийде.  
Людям спішіть сказати,  
Що ласки дні пройдуть,  
Сили усі віддайте  
І закінчим труд`,
  165: `Всі до праці спішіть, о ви, слуги Христа.  
По Господніх слідах ми підем до кінця.  
Дух поради Його сили нам додає,  
Хто лиш любить трудитись, той працю знайде.  
Приспів:  
Всі спішіть, (всі спішіть)  
Всі до праці спішіть.  
(Всі спішіть, всі спішіть)  
О молись,  
(Всі спішіть, терпи,)  
Вірним будь (і жди)  
Трудись, аж поки Бог прийде.  

Всі до праці спішіть! Хай голодний прийде,  
Із струмочка життя кожний спраглий хай п'є.  
Хрест і віра Христа — наша сила і стяг.  
Хай надію в людей на життя оживить.  
Всі до праці спішіть! Труд знайдеться для всіх,  
Переможем з Христом царство темряви й гріх.  
Хай про подвиг Христа вістка всюди звучить  
І надію в людей на життя оживить.  
Всі до праці спішіть, Божих слуг нива жде,  
Скоро осінь настане і жниво пройде.  
В Небі ми відпочинем від праці й турбот,  
Як у славу нас прийме Спаситель — Господь.`,
  166: `Іди в виноградник й сумлінно працюй.  
В нім праці багато, хвилин не марнуй.  
Бур'ян виривати, щоб лози росли,  
Рядки поливати, збирати плоди.  
Ти мусиш лозу від лисиць стерегти,  
Для Господа весь виноград зберегти.  
Там кожний по силах роботу знайде,  
Аж поки у славі Спаситель прийде.  

Іди в виноградник, — тебе Я купив,  
І кров'ю Своєю твій борг заплатив.  
Весь час твій, думки і всі сили твої,  
Весь розум і воля віднині Мої.  
Все царство Моє Я за тебе віддав,  
Пісні херувимів — на світ поміняв.  
Я чашу скорботи всю випив до дна,  
І смертю Своєю тобі дав життя.  

Іди, попрацюй, наближається ніч,  
Спіши в виноградник, не бійся терпінь.  
Вже скоро стемніє, надійде пітьма,  
Поглянеш навколо — надії нема.  
Працюй від зорі до зорі — і Я Сам  
Вкладу в тебе силу і засоби дам.  
Ти будеш щасливий, вінець осягнеш,  
І плату від Бога за працю приймеш.`,
  167: `О де ж ті женці? Спілі вже поля,  
Добрі колоски ждуть давно серпа.  
Беріть же скоріше усі серпи,  
З полів всього світу зберіть снопи!  
Приспів:  
Де ж ті женці, де? О, хто піде?  
На Божий клич хто на жнива вже прийде?  
Хто хоче жати снопи добра  
Для житниць Неба з полів гріха?

Ідіть і шукайте всі колоски, —  
В траві, поміж терня знайдете їх.  
Збирайте усюди на поклик цей,  
Відкуплених Богом Його дітей.  
Бери ж і свій серп, на жнива іди,  
На ниві доспілій в'яжи снопи.  
Працюй, бо вже скоро Господь прийде,  
Всім вірним женцям нагороду несе.`,
  168: `Хто добро тут сіє й сльози проливає,  
В небі той зрадіє, як збере врожай.  
Зерно розсівати Бог нас посилає  
Правди і любові всюди з краю в край.  
Приспів:  
Принесе снопи, принесе снопи,  
Хто в сльозах тут сіє, принесе снопи,  
Принесе снопи, принесе снопи,  
Хто добро посіє, з радістю пожне.

Сійте рано-вранці слово правди й згоди,  
Не дозвольте вдень ослабнути рукам,  
Сійте опівночі, хоч нема погоди,  
І тоді пожнете добрі ви жнива.  
Хоч здається нам, що сіємо даремно,  
Бур'яни великі глушать ниви всі,  
Але добре зерно виросте напевно,  
І воно стократні дасть плоди свої.  
Силу і уміння Бог нам посилає,  
Щоб розумне й добре сіяти могли,  
І благословення в праці обіцяє.  
Принесім же Богу з радістю снопи.`,
  169: `Всюди так багато праці,  
Глянь, як лан позолотів,  
Вже прийшли жнива гарячі,  
А так мало скрізь женців.  
Щиро Господа благайте,  
Щоб Він більше дав женців,  
І самі в ряди ставайте,  
Всі, охочі до трудів.

Праці так багато всюди,  
Бог і нині кличе вас:  
О, чому ви, добрі люди,  
Марно гаєте свій час?  
Я сьогодні ще найму вас,  
Тож до праці йдіть мерщій,  
І до вечора працюйте  
На цій ниві золотій.

Всюди так багато праці.  
Хто ж почує, хто піде  
І поможе в Божій ланці  
Діло скінчити святе?  
Хто цій справі присвятиться  
І віддасть їй все життя,  
Той, коли Христос з'явиться,  
Прийме славу від Отця.`,
  170: `Дружно в згоді для Христа працюєм  
В винограднику Його щодня;  
Повеління вірно виповняєм,  
Що в Своїм Завіті записав.  
Приспів:  
Працюймо щиро  
(Будем щиро працювати)  
Для Ісуса все.  
Він нагороду  
(Він нам нагороду скоро,)  
Скоро всім нам принесе.

Ми всім людям радісно розкажем  
Про Христа і про Його любов,  
Як колись Він за провини наші  
На хресті пролив невинну кров.  
Йдіть покірно за Христом щоденно  
І Закон любові збережіть.  
Всім, знеможеним в гріхах, постійно  
Про спасіння Боже говоріть.`,
  171: `Божа любов обнімає  
Людство всієї землі.  
Добрий Господь нас навчає,  
Щоб не жили ми у злі.  
Приспів:  
Тисячі душ погибають.  
Браття, скажіть їм про Христа.  
Хай голос ваш не вмовкає,  
Сійте скрізь зерна добра.

Люди блукають в темряві,  
В серці надії нема,  
Душі їх мріють про славу,  
Прагнуть утіх і добра.  
Бог нас покликав до діла —  
Вістку спасіння нести.  
Нас обновить Божа сила,  
Ближніх любити навчить.`,
  172: `О друже, розкажи всім  
Про Христову святу любов.  
Хто захоче її прийняти,  
Той вічне щастя знайшов.  
Приспів:  
Знову і знову скажи,  
Знову і знову скажи,  
Чудові слова про Ісуса  
Знову і знову скажи.

О друже, розкажи всім  
Про Христову пролиту кров.  
Він воскрес, піднявсь на небо,  
Скажи всім знову і знов.  
О друже, розкажи всім,  
Що удруге Христос прийде,  
Він святих Своїх покличе  
І в Царство слави введе.`,
  173: `Овець заблудних Пастир шукає,  
Ходить по горах вдень і вночі.  
«Прийдіть до Мене, — Він закликає, —  
І ви знайдете спокій душі».  
Приспів:  
Пастир пішов Сам в долини й гори,  
(Пастир пішов Сам в долини й гори),  
Блудну вівцю Він від смерті спас,  
(Блудну вівцю Він від смерті спас),  
А в небесах вже співають хори,  
(А в небесах вже співають хори),  
Славлять Ісуса, що вмер за нас.  
(Славлять Ісуса, що вмер за нас)

Шукайте грішних в муках терпіння,  
Що заблудились і відійшли,  
Їх направляйте на шлях спасіння,  
Щоб до Ісуса вони прийшли.  
Я піду також слідом Христовим  
Шукати в горах Його овець,  
Скажу всім бідним, сліпим і хворим,  
Що їх з любов'ю прийме Отець.`,
  174: `В Царство Боже тим дорога,  
Хто приносить тут плоди.  
Хоч і важко, та на Бога  
Ти надію поклади.  
Приспів:  
Будем щиро працювати,  
Щоби людям помогти  
Божими дітьми всім стати,  
В Царство слави увійти

Нам Христос життя дав, знаю,  
Більше смерті не боюсь.  
Але сам себе питаю:  
З чим я перед Ним з’явлюсь?  
Нива Божа побіліла,  
Тільки мало ще женців.  
Тож візьмемось всі за діло  
І зберем снопи з ланів.  
Будем вірно працювати  
На всій ниві світовій,  
Щоб вінець життя прийняти  
Й жити на Землі новій.`,
  175: `О Ісусе любий, Ти помер за всіх  
І Своєю кров'ю з нас змиваєш гріх.  
Ти звершив спасіння в муках на хресті,  
А сьогодні в Небі — в горній висоті  
До святого храму в світлих Небесах  
Ради бідних нас, що гинули в гріхах,  
З кров'ю дорогою Ти туди ввійшов,  
Щоб з Отцем навіки примирити знов  
З вірою підносим погляд в Небеса,  
До престолу ласки вічного Отця,  
Ми в Ім'я Ісуса всі до Бога йдем,  
Він Заступник наш перед Його лицем  
Чуйно ждем Тебе в надії ми живій,  
Тож прийми навік нас в дім небесний Свій.  
Всі незгоди наші проминуть тоді,  
Будем ми щасливі й вічно молоді  
День за днем минає, скоро наш Господь  
Сам прийде звільнити від тяжких знегод,  
А тому залишим гріх і марноту,  
І служити будем з радістю Христу`,
  176: `О смертний, вважай! Суд в небі почався,  
Над домом Божим суд іде.  
Короткий час для всіх остався,  
І Суддя ось-ось прийде.  
Приспів:  
Як станемо перед судом?  
З чим прийдемо і ти, і я?  
Всі станем ми перед престолом,  
Що скаже нам в той день Суддя?

Тисяча вісімсот сорок четвертий —  
Це рік, коли почався суд,  
Судяться ті, хто нині мертві,  
І для нас часи ті йдуть.  
Хто вистоїть перед справедливим Богом?  
Він зважить все твоє життя,  
І тайний гріх, ділом чи словом,  
Чи в той день вистою я?`,
  177: `Над землею і морями  
Ангел з книгою стояв  
І могутніми словами (Двічі)  
Вість народам сповіщав  

Книга та була закрита  
В давнину — в старих віках,  
А тепер вона відкрита (Двічі)  
В сильних Ангела руках  

Книгу ту на час останній  
Даниїл — пророк — лишив,  
Щоб пророцтва промінь ясний (Двічі)  
Церкві в темряві світив  

Ангел з клятвою віщає  
Вість останню для людей:  
«Часу більше вже немає, (Двічі)  
І Господь біля дверей  

Церкво Божа, Ти ту книгу  
Із рук Ангела візьми,  
З'їж її, і вість останню (Двічі)  
Всім народам сповісти`,
  178: `Чуєш вістку, що лунає  
Над широтами землі?  
Ангел в небесах літає,  
До людей несе її:  

«Бійтесь Бога, честь і славу  
О, віддайте, люди всі!  
Виявіть Йому повагу  
Із любові, в чистоті. 

Божий день — великий судний —  
В Небі вже давно настав».  
І могутній голос трубний  
Над землею пролунав  

Чуєш вістку? Ангел Божий  
Сповістив по всіх краях:  
«Вавилон великий, гордий  
Впав, заплутаний в гріхах. 

Він вином гріха й розпусти  
Всі народи напоїв  
І впровадив у спокусу  
Усіх вільних і рабів;  

Вчив людей наук фальшивих,  
І змінив святий Закон».  
Ось чому в гріхах огидних  
Впав духовний Вавилон  

Чуєш вістку? Ангел сильний  
Всім народам подає:  
«Чашу гніву Бог Всесильний  
Над людьми всіма проллє. 

Хто Творцю не поклонявся  
І Закон Його топтав;  
Хто в гріхах гідких кохався,  
Світло правди зневажав, 

Той, звичайно, мусить пити  
Чашу гніву аж до дна  
І за гріх свій заплатити  
Смерті злій своїм життям»`,
  179: `По всіх краях землі лунає вість з небес:  
«Віддайте Господу достойну славу й честь,  
Бо тільки Він — наш Бог і всеблагий Отець,  
Землі і Неба Він Творець».  
Приспів:  
Цю добру вість несуть в устах  
Три ангели по всіх краях:  
«О бійтесь Господа, віддайте славу всі,  
Бо вже настали судні дні!»  

В гріхах блудив і впав великий Вавилон,  
За це і жде його караючий вогонь.  
«О вийди з нього, Мій святий народе, вмить», —  
Так вістка ангелів звучить.  
Зухвалий лютий звір у світі тут рядить  
І кожний кланятись до ніг йому спішить.  
Та хто поклониться і прийме знак його,  
Спіткає Божий гнів того.  
В великий судний день устоять тільки ті,  
Хто тут Закон зберіг і віру в чистоті.  
На землю в славі знов Господь з Небес прийде  
І в Царство вічне нас введе.`,
  180: `Два шляхи перед тобою —  
Вибирай, яким іти:  
Чи дорогою вузькою,  
Чи широкою піти?  
Шлях вузький.  
Він добрий, вічний,  
Ним Ісус провадить тих,  
Хто прямує до Вітчизни,  
До осель Його святих,  
До осель Його святих  

Бачиш, там тісні ворота?  
Важко через них пройти.  
Горе, смуток і турботи  
Ти не зможеш обійти.  
А широкая дорога  
Вабить тисячі людей.  
І по ній ідуть без Бога  
Всі, що шлях обрали цей,  
Всі, що шлях обрали цей  

Той широкий шлях приводить  
До загибелі людей.  
Хто сьогодні ним проходить,  
Не знайде святих осель.  
Два шляхи перед тобою.  
По якому ти підеш?  
Йди дорогою вузькою, —  
Вічну радість там знайдеш,  
Вічну радість там знайдеш`,
  181: `Лагідно й ніжно сьогодні Бог кличе,  
Просить тебе і мене.  
Жде, хто відкриє Йому своє серце,  
Просить тебе і мене.  
Приспів:  
«Прийдіть, (прийдіть),  
Прийдіть, обтяжені всі».  
Лагідно й ніжно сьогодні Бог кличе:  
«Прийди, нещасна душе»  

Чи ти не чуєш, як щиро Він просить?  
Любить тебе і мене.  
В Слові Своїм нам спасіння приносить,  
Жде і тебе, і мене.  

Час пролітає, хвилини минають,  
Як тобі, так і мені.  
Вже небосхил чорні хмари вкривають, —  
Не залишайся в пітьмі.`,
  182: `Я знаю струмок — це жива течія,  
Що дивно і тихо біжить,  
Горить вся вогнем, повна жару життя.  
До тебе потік цей спішить. 

Приспів:  
Мій друже, чи чуєш? Прийди,  
Цей славний потік знайдеш ти.  
Струмок тихо плине ще щодня,  
Повір, він дає всім життя  

І всюди, куди цей потік потече,  
Там радість приходить в серця.  
Він скарби небесні тим людям несе,  
Терпіння дає в смутних днях. 

Глибокий, прозорий і чистий струмок,  
Приємна на смак в нім вода.  
Лікує хвороби і нищить порок,  
Гріхи всі змиває вона. 

В струмочку життя оживаємо знов;  
Вода ця біжить від Христа.  
Спаситель пролив на хресті Свою кров,  
Щоб грішних спасти від гріха. 

Хай спрагнений кожний приходить і п'є  
І Церква, і Дух Божий звуть.  
А тих, що омились, життя вічне жде,  
Вони в Царство слави ввійдуть.`,
  183: `В країні далекій, в чужому краю  
Шукає син блудний там долю свою.  
Він батька покинув, пішов від рідні,  
Тепер сам бідує в чужій стороні. (Двічі)  

Із місця на місце спішить він притьмом —  
В погоні за щастям, розбитий гріхом.  
Він скоро протратив батьківське майно,  
І стала нещасною доля його. (Двічі) 

Не бачить він ласки. Прийшли смутку дні,  
Навколо — неправда, насмішки одні.  
І став перед очі обман його мрій,  
Тоді зрозумів безпорадний стан свій. (Двічі) 

Любов він відчув до своєї рідні,  
Вмить думка майнула в його голові:  
Я встану, зберуся, додому піду,  
До ніг свого батька покірно впаду. (Двічі)  

Несміло, хвилюючись, вирушив в путь,  
Розкаяння сльози з очей все течуть.  
Він батька зустрів, впав з риданням душі:  
«Прости, Отче мій, всі провини мої. (Двічі)  

Від радости батько любов'ю горить,  
Він рідного сина цілує, пестить:  
«О сину мій бідний, ти мертвим блукав,  
Та слава Творцю, що від смерті ти встав!» (Двічі)`,
  184: `Хоче всіх людей Господь благословить,  
Вістку добру в серце кожному дарить.  
Двері серця ти широко відчини,  
Світло із Небес впусти!  

Приспів:  
Світло із Небес впусти,  
Світло із Небес впусти,  
Двері серця ти широко відчини,  
Світло із Небес впусти!  

За гріхи Спаситель на хресті страждав,  
Воскресінням на життя надію дав.  
Двері серця ти широко відчини,  
Світло із Небес впусти!  

Ти страждаєш серцем, хочеш шлях знайти,  
Знай: тебе Ісус прийшов навік спасти.  
Двері серця ти широко відчини,  
Світло із Небес впусти!  

Темрява у світі покриває все,  
Та Христос з Собою світло всім несе.  
Двері серця ти широко відчини,  
Світло із Небес впусти!`,
  185: `Вернись, вернись! Ти так блукав далеко,  
В дорозі часто падав і страждав.  
Скалічений і втомлений смертельно,  
Свою погибель ти не відчував  

Ти довго йшов, поранив собі ноги,  
І юності вогонь в очах погас.  
Вернись скоріш з гріховної дороги,  
Ще поки не пробив останній час  

Вернись, вернись, — в твоїй країні рідній  
Душею й тілом там ти відпочнеш,  
З Христом навік в сім'ї небесній, вільній,  
Забудеш горе все і мир знайдеш  

Твої гріхи, спокуси, всякі болі,  
Мов сон страшний навіки відійдуть,  
В любові Божій, в Його добрій волі  
Минулі дні на пам'ять не прийдуть`,
  186: `Сліпий, нещасний Вартими  
Дізнався від людей,  
Що поруч з ним дорогою  
Великий Лікар йде.  

«Давидів Сину, — він кричав, —  
Помилуй Ти мене!»  
У відповідь почув слова:  
«Іди, Він жде тебе». 

Приспів:  
Іди, (іди), Він жде тебе, (Двічі)  
Він зніме з серця болі всі,  
(Він зніме з серця болі всі,  
зніме з серця болі всі)  
Іди, (іди, іди, Він жде)  
Він жде тебе. (Тебе, Він жде тебе)  

Христос страшну, ганебну смерть  
За грішників прийняв,  
Невинне і святе життя  
Без нарікань віддав.  

В важких стражданнях на хресті  
Розп'яти дав Себе.  
Він ніжно кличе грішника:  
«Прийди, Я жду тебе».  

Сьогодні ще той Божий клич  
Запрошує людей:  
Нещасних, хворих і сліпих,  
Страждальців всіх земних.  

З любов'ю закликає нас —  
Усіх, хто хрест несе.  
Тож відгукнись, ще поки час,  
Іди, Він жде тебе.`,
  187: `О Слово Боже вічне,  
Любові клич святий.  
В нім є багатство славне,  
Блаженство і спокій.  
Всім бідним і нужденним,  
Знеможеним в гріхах,  
Приносить всім надію  
Той клич Христа: «Прийдіть!»  
Приспів:  
До Христа прийди,  
До Христа прийди,  
Втомлений, безсилий,  
До Христа прийди.  
До Христа прийди,  
До Христа прийди,  
Друже, не вагайся,  
До Христа прийди!  

Ісуса ніжний голос  
Нас кличе в Небеса,  
Де ми забудем горе  
І мир знайдуть серця.  
Тривогу і невір'я,  
Мій друже, віджени,  
І слухай клич спасіння,  
Той клич Христа: «Прийди!»

Мені дай, Боже, сили  
Прийняти клич святий,  
Щоб вірним до могили  
Я був на цій землі.  
Коли ж засядеш знову  
На троні в славі Ти,  
Почути дай з любов'ю  
Той ніжний клич: «Прийди!»`,
  188: `Прийди ти до Христа,  
Він кров святу пролив,  
І смертю на хресті  
Гріхи твої обмив. 

Спаситель постраждав,  
Щоб все тобі простить,  
Лиш в Ньому зможеш ти  
Навіки відпочить. 

Приспів:  
Скоро той день прийде!  
Тебе Спаситель жде.  
Двері відкриті є,  
Ввійти ти можеш ще. 
Якщо не поспішиш,  
Пізно буде тобі.  
О друже мій, прийди,  
Ласку Його прийми  

Руки Господь простяг,  
Щоб пригорнуть тебе,  
Надійсь на Нього лиш, —  
Радість тобі пошле.  
Йому довірся ти,  
Тягар Ісус здійме,  
Такого, як ти є,  
В любові Він прийме.

Глянь на Голгофу ти,  
Спаситель там страждав,  
Розп'ятий на хресті,  
В муках важких вмирав.  
Голос почуй Його,  
В любові кличе Він,  
Іди, не відкладай,  
Христу себе віддай.`,
  189: `Я чую ніжний клич Христа:  
«Прийдіть до Мене всі,  
Страждаючі у світі зла,  
Я дам вам Свій спокій».  
На ніжний клич Учителя  
Таким, як є, іду.  
В святій крові Спасителя  
Я змив вину мою  

Я чую ніжний клич Христа:  
«О спрагнений, прийди,  
Візьми напийся без грошей  
Цілющої води».  
І я на поклик той пішов,  
Напивсь із Джерела,  
Спокій душі своїй знайшов  
І силу до життя  

Я чую ніжний клич Христа:  
«Я — Світло всім світам.  
Хай світить правдою життя,  
Іди шляхом добра».  
Підняв я очі на Христа,  
Він на шляху моїм,  
Як вічна сяюча Зоря,  
Веде в батьківський дім`,
  190: `Прийди ти до Ісуса,  
Мій друже дорогий,  
Тебе стомив до краю  
Тягар гріха важкий.  
Прийди і не вагайся,  
Христос приймає всіх.  
Повір, що з твого серця  
Він зніме всякий гріх  

Віддайся лиш Ісусу  
І слухайся Його,  
Поллється пісня щастя  
Із серденька твого.  
Іди і не вагайся  
До Господа Христа.  
Знайдеш ти в Нім для себе  
Надію на життя  

Живи завжди з Ісусом,  
Іди вузьким шляхом,  
Здолаєш всі спокуси  
У боротьбі з гріхом.  
Іди і не вагайся  
До Господа Христа.  
Ввійдеш ти в вічну радість  
Небесного Отця`,
  191: `До Христа всіх прикликайте,  
Що блукають там і тут,  
Про спасіння їм звіщайте,  
Може, ще Його приймуть.  
Кличте грішників нещасних.  
Їх гріховні тягарі  
Важчі від кайданів власних, —  
Люди мовби у ярмі  

Матері, діток приводьте,  
Їх Христос благословить.  
Хворі і сліпі, приходьте,  
Вірте: вас Ісус зцілить.  
Кого стрінете, скажіть всім,  
Щоб спішили до Христа.  
Він гріхи усі простить їм, —  
Благодатна це пора  

Кличте тих, що впали низько,  
Що від правди відійшли.  
І для них Ісус є близько,  
Жде з любов'ю, щоб прийшли,  
Кличте всіх, бо вечоріє,  
Темна ніч на землю йде.  
Хто за дня цього не вдіє,  
Потім буде пізно вже`,
  192: `Прийме грішників Христос,  
Хто б до Нього не прийшов, —  
Всіх, хто в темряві живе  
І тягар гріха несе.  
Приспів:  
Всім скажи, (всім, ти всім скажи)  
Ти всім скажи: (всім, ти всім скажи)  
Прийме грішників Христос.  
(Прийме грішників Христос,  
Прийме грішників Христос).  
Вість любові оповідай:  
(Вість оповідай, вість оповідай)  
Прийме грішників Христос!

В жертву Сина Бог віддав,  
Щоб ти дар спасіння мав.  
Він простить твої гріхи, —  
Тільки до Христа прийди.  
Кличе Він — до Нього йди,  
Біль душі всю розкажи.  
Бог потішить і зміцнить,  
Рани серця всі зцілить.  
Прийме грішників Христос.  
Вірю, прийме і мене.  
Він пролив за людство кров.  
Славлю я Його за все.`,
  193: `Слухай, мій друже, як кличе Господь.  
Він хоче дати спокій від незгод.  
По всьому світу звучить клич Христа:  
«О поспішай, будеш мати життя».  
Всім, хто втомився в тяжкій боротьбі,  
Сили додасть Він, поможе тобі.  
Всім обіцяє Свій мир неземний, —  
Тож обізвися на поклик святий  

Світ буде гнати, — не бійся, терпи,  
Сміло тернистою стежкою йди.  
Йшов наш Спаситель тим вузьким шляхом,  
Підем покірно і ми за Христом.  
Він — наш Учитель, наш вірний Оплот,  
Захист пошле нам від бурі й незгод.  
Чуєш, як поклик звучить той благий:  
Йдіть всі до Мене, — Я дам вам спокій!  

Чуєш, як нині Він лагідно зве.  
O не вагайся, Він прийме тебе.  
Час промине, змовкне голос Христа,  
Втратиш навіки ти вічне життя.  
I заридаєш гірко тоді.  
«О відійди», — скаже грізно тобі.  
Поки час ласки, до Нього спіши,  
Він тебе кличе: «Прийди, о прийди!»`,
  194: `Чуєш голос ти Ісуса, —  
Лагідно звучить?  
Голос ніжний, голос тихий  
Просить: «Відчини!»  
То не пізній перехожий  
Стукає ще раз,  
То Спаситель тебе просить:  
«Відчини в цей час!»  

В твоїм серці смертний холод,  
Темрява нічна.  
Відчини і не вагайся, —  
Стане там весна.  
І поллються звуки щастя,  
Як небесний спів.  
Чуєш стук той? Чуєш голос?  
Відчини скоріш!  

О відкрий Йому ти серце,  
Він ще нині жде,  
В нім оселю Бог збудує,  
Радість з Ним знайдеш.  
Не вагайся, милий друже,  
Швидше відчини.  
Поспішай, не будь байдужим  
І Христа впусти!`,
  195: `Спасіння Бог подарував  
Для всіх людей землі,  
Усім Христос надію дав  
На прощення гріхів.  
Приспів:  
О друже, не вагайся, вір,  
Прийми Христа тепер.  
Зверни на Нього віри зір, —  
За тебе Він помер  

Ісус так грішних полюбив,  
Що кров за них пролив,  
Він на хресті в предсмертний час  
Отця молив за нас.  
Христос нас, грішних, воскресив  
До нового життя.  
Він волю Божу всім відкрив  
І шлях у майбуття.  
Коли, Ісусе, знов прийдеш,  
Побачать всі Тебе.  
Коли Ти вірних всіх візьмеш,  
То не забудь мене.`,
  196: `Чи нема вже в тебе місця,  
Щоб Ісус міг загостить?  
Слухай, стукає у двері,  
Чом не хочеш відчинить?

Приспів:  
О віддай себе Христові,  
Двері серця відчини,  
Щоб ввійшов і Духом Своїм  
В ньому мешкав і рядив  

Для справ світа місце маєш,  
Для Христа його нема.  
І життя так пролітає  
Без надії, без добра. 

А якщо Христа відкинеш  
І до серця не приймеш,  
То в гріхах своїх загинеш,  
Без надії в гріб підеш.  

О віддай себе Ісусу,  
Бо минає ласки час.  
Вже прийшла година суду,  
І Суддя покличе нас.`,
  197: `«Я стою біля дверей.  
О (о впусти Мене) впусти (о впусти Мене),  
О впусти скоріш Мене.  
О (о впусти Мене) впусти (о впусти Мене).  
В серце стукаю твоє.  
Чи для Мене місце є?  
О впусти, впусти Мене.  
О (о впусти Мене) впусти (о впусти Мене)»  

«Двері серця відчини,  
О (о впусти Мене) впусти (о впусти Мене)  
У свій дім Мене прийми.  
О (о впусти Мене) впусти (о впусти Мене)».  
Вір Ісусу від душі,  
Бо Він — кращий Друг в житті.  
О впусти, впусти Його,  
O (о впусти Його) впусти (о впусти Його)  

Голос ніжний чути знов:  
«О (о впусти Мене), впусти (о впусти Мене).  
I прийми Мою любов, —  
О (о впусти Мене), впусти (о впусти Мене)».  
Поспішай, не зволікай,  
Його радо зустрічай.  
О впусти, впусти Христа.  
О (впусти Христа) впусти (о впусти Христа)`,
  198: `Пробудись від сну, мій друже,  
Скинь гріховний свій тягар.  
Ось, Спаситель тебе кличе, — (Двічі)  
В Нім знайдеш спасіння дар  

Будь з Христом завжди в єднанні, —  
Він гріхи твої простить.  
Тож іди, і без вагання, (Двічі)  
Щоб спасіння осягти  

І коли прийде Спаситель,  
Ти залишишся тоді  
І розділиш спільну долю (Двічі)  
З світом грішним на землі`,
  199: `Самарянка ще не знала,  
Що Христос її шукав.  
Як з криниці воду брала,  
Пити Він прохав.  
І Спаситель відкриває,  
Як вона колись жила,  
Ніби з книги Він читає,  
Ким вона була.  
Приспів:  
О довірся, милий друже,  
Ще тебе Спаситель жде.  
Серцем ти не будь байдужий, —  
Скоро Він прийде.  

В тій країні, де схилялись  
Тихо пальми й мирт дрімав,  
Люди йшли і дивувались:  
Їх Спаситель ждав.  
Самарянка розповіла:  
«Дивний Хтось оце стоїть.  
Може, це Христос, Месія,  
Вже прийшов в наш світ?»  
Живу воду пийте даром,  
Поки є ще ласки час.  
Хай серця любови жаром  
Запалають в вас.  
Той, хто любить Бога щиро,  
Благодать Його прийме.  
Він таких з'єднає миром,  
В вічність приведе.`,
  200: `Чути стукіт лагідний,  
Тихий голос: «Відчини...»  
Це Спаситель — Гість небесний,  
Хоче в дім твій увійти.  
Він твій Цар, твій Друг чудесний,  
Не вагайсь, Його впусти.  

Стук вже вдруге залунав.  
Хто б так довго ще чекав?  
Це Господь наш милосердний  
Під дверима серця жде.  
Він спокій приносить певний,  
Відчини, нехай ввійде.  

Слухай, стукає ще раз,  
Відчини Йому в цей час,  
Бо як Він тебе покине,  
І навіки відійде,  
То в гріхах своїх загинеш,  
В Край небесний не ввійдеш.`,
  201: `Що я дам Тобі, мій Спасе,  
За безмежную любов?  
За дароване спасіння,  
За святу пролиту кров?  
Приспів:  
«Дай Мені (Дай Мені)  
Своє ти серце, (своє ти серце)  
Щоби жити міг Я в нім.  
(Щоби жити міг Я в нім)  
Весь твій вік (весь твій вік)  
Земний, короткий (земний, короткий)  
Сином добрим будь Моїм».  
(Сином добрим будь Моїм, будь Моїм)

Дав би я Тобі всі скарби,  
Що на цій землі придбав,  
Та Ти того не бажаєш, —  
Так в Святім Письмі читав.  
Де не гляну, подивлюся, —  
Все Твоє, Спаситель мій.  
Чим Тобі я відплачуся  
За той дар великий Твій?`,
  202: `Спасителя маю я в славі небесній,  
Він кров'ю Своєю прощення здобув.  
Мене зігріває в любові чудесній.  
О, якби Він вашим Спасителем був!  
За вас я молюся, за вас я молюся.  
О, якби Він вашим Спасителем був!

На небі мій Бог і благий Промислитель  
Готує блаженство і радість святим.  
Там, в райських оселях, мене жде Спаситель.  
О, якби Він вашим Спасителем був!  
За вас я молюся, за вас я молюся.  
Хотів би я з вами в ту радість ввійти!

Для мене в Ісуса одежа чудова,  
Не бачило око такої краси.  
Я вийду до Бога в цій славній обнові.  
О, якби цей одяг отримали й ви!  
За вас я молюся, за вас я молюся.  
О, якби цей одяг отримали й ви!

Свій мир в мою душу Спаситель вливає,  
Цей мир непідвладний для людських умів.  
Він серце розбите життям обновляє.  
О, якби цей мир ти прийняти хотів.  
За тебе молюся, за тебе молюся.  
О, якби цей мир ти прийняти хотів!

Якщо ви прийняли всім серцем Ісуса,  
Про Нього всім людям тепер розкажіть.  
Моліться, щоб вас не здолали спокуси,  
І віру у серці завжди бережіть.  
Моліться за себе, моліться за ближніх  
І віру у серці завжди бережіть!`,
  203: `Прийдіть, я розкажу вам,  
Що Бог мені вчинив,  
Як Він в моєму серці  
Створив життя нове? 

Я хочу всім сказати,  
Як Бог мене прийняв,  
Усі гріхи, пороки  
Колись на Себе взяв.  

Приспів:  
Прийдіть, я розкажу вам,  
Що Бог мені вчинив,  
Як Він мене з неволі  
Гріховної звільнив

Чи є що в світі краще  
За чудо це святе?  
Господь в моєму серці  
Створив життя нове? 

Я був нечистим, грішним,  
Смерть вічну заслужив,  
Та Бог змилосердився,  
Мої гріхи простив. 

Я буду промовляти  
Завжди оці слова:  
Бог ласкою багатий,  
Спасає від гріха.  

Щоб люди всі почули,  
До Господа прийшли,  
Спасіння осягнули  
І мир душі знайшли.`,
  204: `Я був непокірним сином,  
Залишив свій Отчий дім.  
На дорозі злій я гинув,  
Думати почав над тим:  

Приспів:  
Я вернусь (вернусь), я вернусь (вернусь),  
Отче любий, я вернусь (о, я вернусь).  
Всі гріхи Тобі скажу я,  
Знов до Тебе я вернусь, (о, я вернусь)!

Бо тяжка моя тут доля  
І далеко мій Отець,  
Всюди так багато горя.  
Чи прийде ж йому кінець? 

Я грішив перед Тобою,  
Признаюсь тепер в сльозах.  
Буду я Тобі слугою,  
Не дай гинути в гріхах.`,
  205: `Христос вийшов з храму на гору Оливну,  
Де часто народ Він учив;  
Почав там розмову незвичну і дивну  
І учням майбутнє Він відкрив  
«Ви бачите, друзі, над містом ще нині  
Здіймається гордий цей храм?  
Зруйнована буде чудова святиня —  
Віддасть Бог її ворогам»  

«Скажи нам, Учителю», — учні спитали, —  
«Ознаку, що знову прийдеш?  
Коли кінець світу, щоб добре ми знали,  
Коли Своїх вірних візьмеш?»  
Сказав їм: «Почуєте слухи воєнні,  
Повстане народ на народ  
І царство на царство. Прийдуть дні непевні,  
Дні горя, тривог і незгод  

Стихії страшні захитають землею,  
Хвороби і голод прийдуть.  
Всі люди від страху зімліють душею,  
Спокою ніде не знайдуть  
В ненависті виступить брат проти брата,  
Незгода сім'ю розіб'є,  
Зустрінеться горе, страждання і страта  
За правду, за Ім'я Моє  

Фальшиві пророки візьмуться за діло,  
В обман багатьох заведуть,  
І сонце погасне, не дасть місяць світла,  
І зорі на землю спадуть  
Народ втратить віру, ослабне надія,  
Любов охолоне в серцях.  
Тоді запанує усюди невір'я,  
Світ буде тонути в гріхах  

Коли смоківниця листочки пускає,  
Ви знаєте, — літо вже йде.  
Так кожний в ознаках цих добре хай знає,  
Що скоро кінець надійде  
Пильнуйте, моліться, і будьте готові  
Зустріти Мене повсякчас,  
Поправте світильники ваші духовні, —  
Я скоро прийду вже по вас`,
  206: `Сторож, скажи, ти на башті стоїш,  
Як довго ждати, коли сповістиш:  
На зміну темряви Сонце іде  
І той славний день Господній вже настає? 

Приспів:  
Близько вже ранок, хоч ще пітьма,  
На небосхилі вже сходить Зоря.  
В променях світла чудового дня  
Скоро вже відкриється вся слава Христа

Очі свої вірний сторож підняв,  
З башти віків на Зорю показав,  
І всім народам, усім племенам  
Голосно про прихід близький він розказав. 

Близько вже, близько день славний Христа,  
Скоро скінчиться епоха гріха.  
Тьму переможе досвітня Зоря  
І засяє світло щастя нового дня.`,
  207: `Спаситель прийде без вагання,  
Не знаємо тільки коли.  
Тож наше сердечне бажання —  
Готовими бути завжди.  

Христос нам сказав: «Всі пильнуйте,  
І вдень, і вночі стережіть.  
Ви дім свій духовний будуйте  
І свято в надії живіть». 

Приспів:  
О, не дрімайте,  
(О, не дрімайте, чекайте Христа)  
Вістку приймайте,  
(О, не дрімайте, чекайте Христа)  
Христа чекайте, —  
(О, не дрімайте, чекайте Христа)  
Він скоро у славі прийде!

Христова любов є без міри,  
Безцінна і вічна вона.  
Не можна втрачати нам віри,  
Котра всіх веде до Христа. 

Ми будем Ісуса чекати,  
Він скоро прийде другий раз.  
Пильнуйте, щоб не задрімати,  
Він з радістю прийме всіх нас. 

Ісусе мій любий, благаю:  
Скоріше на землю прийди,  
Візьми мене до Свого раю,  
В обіцяну славу введи.  

Для грішних Суддею Ти прийдеш,  
Злякаються Твого Лиця.  
Однак вірю: Ти мене приймеш  
В оселі благого Отця.`,
  208: `Пильно глядіть за знаками усі,  
Скільки ще йти лишилося в житті?  
Бог їх колись звістив для наших днів,  
Щоб знати всім, чи скоро день Христів.

Приспів:  
Всі прослідіть ви дорожні знаки ті!  
Чи довго йти лишилось нам в житті?  
Все проминуло, і близько вже кінець, —  
В небі жде нас Бог Отець

Перший знак — давній гордий лев стояв  
І Вавилона царство означав.  
А в Мидоперсії знайдем слідом  
Тайну ведмедя з тим трійним іклом. 

Греції символ в барсі пізнаєм,  
Потім і знак четвертий ми знайдем:  
Звір той страшний, тремтить все перед ним;  
Ось і земний шлях скоро всі пройдем. 

Нас ріг маленький далі поведе  
І до кінця подій всіх приведе.  
Знаки здійснились, — ми в кінці живем,  
Ось і земний шлях скоро всі пройдем.`,
  209: `В той день, може, раннього ранку зорею,  
Як сонячний промінь пройде над землею, —  
Тоді, може, прийде Господь в вічній славі  
Зібрати з землі Своїх.

Приспів:  
О Ісусе, ми ждем,  
Коли в день новий всі гукнем:  
«Алілуя, ось Він, Бог наш!»  
Алілуя, амінь! Алілуя, амінь!

А може, тоді, коли в темряві ночі  
Всіх морок повиє, зімкне наші очі,  
Прийде наш Господь в сяйві блискавок, громів  
Зібрати з землі Своїх.  

З Ним ангели зійдуть спасенних вітати  
І праведних Бог буде в Царство приймати.  
Йому спів хвали з уст поллється рікою,  
Як візьме з землі Своїх.  

О радість! О щастя від смерті спасенним,  
Від тяжких недуг до життя знов натхненним  
І в славу одягненим, благословенним,  
Коли Він візьме Своїх.`,
  210: `Святі обітниці Христа  
Несіть у села і міста,  
Що скоро Він прийде з Небес  
Нас взяти в край чудес. 

Приспів:  
О, як добре (о, як добре) буде там (буде там),  
Де Христос (де Христос) царює Сам (царює Сам),  
Там, де зустрінуться святі,  
Що жили на землі

Всіх праведних Бог воскресить,  
Живих одягне в славу вмить,  
А наш спокусник, давній змій,  
Пробуде в тьмі страшній. 

Коли ж той темний вік промчить  
І землю сонце освітить,  
Воскреснуть, хто з гріхом дружив  
І смерть лиш заслужив.  

Господь весь гріх і смерть спалить,  
А Землю й Небо обновить,  
І зацарює в світі знов  
Мир Божий і любов.`,
  211: `Як швидко день за днем летить,  
Вперед життя іде.  
Лиш сонце рано заблищить —  
І ніч вже настає.  

Приспів:  
Час за часом (час за часом),  
День за днем (день за днем)  
До кінця (до кінця)  
Ми швидко йдем (ми швидко йдем).  
Ось останній (ось останній) час проб'є  
І Спаситель наш прийде

Так скоро наші дні пройдуть  
І зникнуть мов туман.  
Нас до могили підведуть  
Віддати смерті дань. 

Хто в світі йшов Христа слідом  
І жив життям святим.  
Хоч і засне він смертним сном,  
Та встане знов живим.  

А може, скоро і мені  
Прийде остання мить,  
І лиш в останній день землі  
Мене Бог воскресить? 

Тож поможи, Ісусе мій,  
Щоб я тут свято жив;  
Щоб там, в країні неземній,  
Тобі повік служив.`,
  212: `Скоро прийде Спаситель з Небес  
З херувимами в славі Своїй,  
Він народ Свій з Собою візьме  
І введе в Край небесний святий. 

Приспів:  
Скоро Він (скоро Він)  
Знов прийде (знов прийде),  
Милосердний наш Бог і Творець (вже прийде).  
О, ми ждем (о ми ждем),  
Він прийде (Він прийде)  
І в небесну Вітчизну введе

О, який буде радісний час,  
Як побачимо в славі Христа!  
Всі незгоди залишать вже нас,  
В пісні щастя зіллються уста. 

О Спасителю добрий, прийди,  
Ми давно так чекаєм Тебе.  
Нас спаси від земної журби,  
В Царство вічної слави введи.`,
  213: `Господь мій прийде, хоч години не знаю,  
Та все сповіщає від краю й до краю,  
Що скоро прийде. Вірю я і чекаю,  
Хоч не знаю коли.  

Приспів:  
Він прийде (Він прийде),  
Будьмо пильні, молімся,  
Він прийде (Він прийде)!  
Алілуя, алілуя!  
Він на хмарах прийде,  
В славі й силі небесній,  
Хоч не знаємо дня

Він слуг Своїх всюди тепер розсилає,  
Пророцтво Його очі всім відкриває,  
Що близько кінець, грізний день наступає,  
Близько всьому кінець.  

О брате, пильнуй: твій світильник духовний  
Ясніше хай світить в темряві гріховній,  
Трудись і молись, щоб завжди був готовий  
Зустрічати Христа.`,
  214: `Я чую, що світ цей, як море, шумить,  
Господній вже день наступає.  
Охоплений страхом, він стогне, тремтить,  
І сонце мінливе згасає. 

Приспів:  
Прийди, мій Ісусе,  
Прийди, дорогий,  
Я хочу вже бути з Тобою.  
Мене Ти очистив у крові Своїй,  
Купив дорогою ціною

Пройдуть із гудінням страшним небеса,  
Прийде довгожданна хвилина —  
Відкриється скоро небесна краса  
Спасителя, Божого Сина.  

Покинь, друже, світ і його марноту,  
Господній вже день наступає.  
Охоплений страхом, він стогне, тремтить,  
І сонце мінливе згасає.`,
  215: `Ось прийде Христос на хмарі,  
Він за грішників помер,  
Ангели усі з Ним в славі, —  
Поміркуй про це тепер.  
Алілуя, в славі наш Господь прийде!  
Алілуя, нам спасіння принесе 

І усі побачать люди  
Велич Божу та красу,  
Грізним день для всіх цей буде,  
Хто віддав життя гріху.  
Ти подумай, чи спасешся ти тоді?  
Ти подумай, чи спасешся ти тоді? 

І пробудить всіх спасенних  
Голос Божої труби.  
Будемо в Краю блаженнім  
З нашим Богом назавжди.  
А невірні в Божу славу не ввійдуть.  
А невірні в Божу славу не ввійдуть  

Честь, хвалу, поклін, подяку,  
Господи, від нас прийми,  
Міць Свою яви велику,  
Нас від зла навік звільни.  
Алілуя, наш Господь у славі йде!  
Алілуя, вірних всіх Своїх візьме!`,
  217: `Швидко так життя минає,  
Близько славний день Христа.  
Ми в надії вже вбачаєм  
Берег вічного життя. 

Приспів:  
Будем з вірою чекати,  
Поки наш Христос прийде.  
Він бажає вічність дати  
Всім, хто правду збереже.

Місто Боже сонцем сяє. —  
Це новий Єрусалим.  
Там Творця всі величають  
Співом звучним, неземним. 

Там не буде сліз і горя,  
Дасть Господь нове життя.  
Божий край — це край спокою,  
Втіхи, радості й добра.`,
  218: `Як прийде Господь у славі,  
Чи готовий будеш ти?  
Доки житимеш в темряві, (Двічі)  
По шляху широкім йти? 

Подивися на Ісуса,  
На Голгофі Він страждав,  
Переміг усі спокуси, (Двічі)  
Щоби ти спасіння мав.

Нині ще ніхто не знає  
Дня, коли Христос прийде.  
Благодатний час триває, (Двічі)  
Та яким тебе знайде?  

Якщо будеш Богу вірним,  
Прийме з радістю тебе.  
Стань дитям Його покірним, (Двічі)  
В рідний край тебе прийме.`,
  219: `В день, коли труба Господня  
Нас збере від зла й незгод,  
Чи зустрінемось ми в небі  
Біля вод, (чистих вод).  
Як на той бенкет весільний  
Приведе Ісус Христос  
Свій незлічений, відкуплений народ?  
Приспів:  
О, яка ж то зустріч  
(О, яка ж то зустріч буде,  
Коли кожний з нас прибуде)  
Сповістить про день спасіння голос нам  
(трубний нам)  
О, яка ж то зустріч!  
(Там зустрінем наших близьких  
В райських тих садах тінистих)  
Нерозлучні будемо навіки там

Сповістить Господній Ангел:  
«Часу ласки вже нема!»  
І підхоплені ми будем  
В Небеса (в Небеса).  
Там зійде на нас від трону  
Слави вічної краса.  
О, які щасливі будем в Небесах!  
Хто гріхи свої безпечно  
Тут робив і притаїв,  
На суді там все відкриє  
День Христів (день Христів).  
Там зійде на нас від трону  
Слави вічної краса.  
О, яке блаженство буде без кінця!  
Там під звуки гуслів зграйних,  
Арф небесних, золотих,  
Заспіває нову пісню  
Хор святих (хор святих).  
Пісня Агнця і Мойсея  
З сонмом праведних святих,  
Гімн, що світ не чув ніколи, прозвучить.`,
  220: `Бийте тривогу, хай чує весь світ:  
Скоро Господь наш прийде!  
Тіштесь, радійте, всім людям скажіть:  
Скоро Господь наш прийде! 

Приспів:  
Скоро Господь знову прийде,  
Скоро Господь наш прийде!

Хай прозвучить нині в горах, полях:  
Скоро Господь наш прийде!  
З тьмами святих слуг в небесних вінках  
Скоро Господь наш прийде!  

Вість над морями лунає сильніш:  
Скоро Господь наш прийде!  
На островах голос чути ясніш:  
Скоро Господь наш прийде! 

Світ весь тремтить, всюди смуток і страх,  
Скоро Господь наш прийде!  
Бурі страшенно бушують в морях,  
Скоро Господь наш прийде!  

Грізні стихії і горе навкруг,  
Скоро Господь наш прийде!  
Свідчать ознаки, говорить нам Дух:  
Скоро Господь наш прийде!`,
  221: `В рідний край, в рідний край  
Серцем лину я.  
Там стихнуть бурі і відчай,  
Вітчизна там моя.  
Цей грішний світ зробивсь чужим,  
Нерідний він мені.  
Знайду своїй душі спокій (Двічі)  
В небесній стороні  

До небес, до небес  
Шлях вузький веде,  
Там в сяйві слави мій Отець  
Давно на мене жде.  
Тут зло кругом, лукаві дні,  
Втомивсь я в боротьбі  
І рвусь в оселі неземні (Двічі)  
До рідної сім'ї  

Славний час, славний час  
Скоро надійде,  
Коли весь гріх і смерть від нас  
Навіки відійде.  
Чого ніколи розум мій  
Збагнути тут не міг,  
Там Бог готує край новий (Двічі)  
Для всіх дітей Своїх`,
  222: `Хто ті, що з віттям пальмовим в руках,  
В білих одежах, в золотих вінках?  
Як вони прийшли усі  
В славу Небес від землі? 

Приспів:  
Бог ціною крові їх спас і оправдав,  
Білу одежу вірним Він дав.  
Хто до смерті вірним у світі пробував,  
Агнець тих в славу прийняв  

Всі вони — ті, що в горі тут жили  
І за Христа свій тяжкий хрест несли, —  
Агнець в славу їх прийняв,  
Білі одежі їм дав.  

Пастирем Агнець буде всі віки  
І поведе до чистих вод ріки.  
Сльози горя тих людей  
Агнець зітре з їх очей.`,
  223: `Над кристальною рікою,  
Біля чистих вод живих,  
Чи зустрінемось з тобою  
Там, де Бог збере святих?  
Приспів:  
Там, над славною рікою,  
Де Агнець Божий всіх збере спасенних,  
Ми зустрінемось з тобою  
В той день перед троном Творця  

Ми з ріки води живої  
Будем пити вічно там,  
І плоди Землі Нової  
Дасть Господь Своїм рабам.  
Скоро ми ріки досягнем,  
Так прийде шлях до кінця,  
Співом радісним прославим  
В Царстві нашого Творця.`,
  224: `О, як радісно нам чути,  
Що Господь все обновить  
І на нову Землю з неба  
Зійде рай чудовий вмить.  
Світ гріховний, смерть і тління  
Знищить наш Господь вогнем,  
А все нове пречудово  
Засіяє вічним днем. 

Приспів:  
О прийдіть, благословенні,  
(О прийдіть, благословенні, о прийдіть),  
Хто спасен Христом Самим,  
(Хто спасен Христом Самим, Христом Самим)  
Принесіть дари священні  
(Принесіть дари священні в вишній дім)  
В вишній дім — Єрусалим.  
(В вишній дім — Єрусалим, Єрусалим)  

Місто нове і прекрасне  
Із населенням святим  
Зійде з неба в дивній славі —  
Це новий Єрусалим.  
Воно гарне і просторе,  
В сяйві Божому горить.  
Мир, любов і справедливість  
В місті Божому рядить.

Через місто вічне, славне  
Вод живих ріка тече,  
Над водою біля трону  
Дерево життя росте.  
Той не ввійде в місто дивне,  
Хто служив неправді злій, —  
Лиш записаний до Книги,  
Вибраний народ святий.`,
  225: `Вже бачу рідний Ханаан —  
Кінець всій боротьбі.  
Коли я перейду Йордан,  
Знайду спокій душі. 

Приспів:  
Пора, пора, вже пора  
Іти, де зла нема.  
Минає ніч, зійшла зоря,  
Вітчизна там моя  

В країну милу я іду,  
Нема там сліз, жалів.  
Я повний мир душі знайду,  
Вже чую славний спів.  

Ще небагато — і пройду  
Тернистий шлях земний,  
Я відпочинок свій знайду,  
Де Божий рай святий.  

О краю рідний, краю мій,  
До тебе лину я.  
У вічній радості твоїй  
Надія вся моя.`,
  226: `Ми ідемо в край небесний,  
Де немає вже гріха,  
В світлих променях чудесних  
Там зустрінемо Христа. 

Приспів:  
Там країна свята,  
Там Вітчизна моя,  
Там Отець наш святий —  
Вічний Бог всеблагий.  
Він жде нас в рідній стороні  
І не залишить на чужині  

Тут ненависть, гріх, нещастя,  
Ллються сльози, мов ріка,  
Але там край, повний щастя,  
Там любов живе свята.  

В цьому світі смерть царює,  
Сіє горе, біль в серцях.  
Там спокій і мир домує,  
Вічне й радісне життя.`,
  227: `Вітчизна моя в небесах  
І душею я лину туди (в небеса).  
Там прославлю Ісуса в піснях,  
Заспіваю Йому гімн хвали (в небесах).  
Приспів:  
В небесах (в небесах),  
В небесах (в небесах),  
Вітчизна моя в небесах (в небесах),  
В небесах (в небесах),  
В небесах, в небесах,  
Вітчизна моя в небесах  

Господь жде мене в небесах,  
Він готує оселю мою (в небесах).  
Відпочинок там вірним Він дасть  
В Його світлім, блаженнім Раю (в небесах).  
Я скоро піду в небеса,  
Мій Спаситель за мною прийде (із небес).  
Буду там прославляти Творця,  
Де вже горя і сліз не буде (в небесах).`,
  228: `Я — мандрівник земний,  
В небі мій дім.  
Іду в той край святий, —  
В небі мій дім.  
Тут всюди смертна тінь  
Гнітить з усіх сторін, —  
В небі мій рідний дім,  
В небі мій дім  

Вже видно близько ціль,  
В небі мій дім,  
Зникне там смуток, біль,  
В небі мій дім.  
Хоч часом важко йти  
До вічної мети, —  
Скоро ввійду в той дім, —  
В небі мій дім  

Там в славі Бог живе, —  
В небі мій дім,  
Він дасть життя нове, —  
В небі мій дім.  
Душею рвусь туди,  
Там буде мир завжди.  
В небі мій рідний дім,  
В небі мій дім`,
  229: `Оновлене Небо і Землю  
Побачу по Слову Творця.  
І славу від Бога одержу, —  
Щасливим повік буду я.  
Приспів:  
Всі святі (всі святі)  
В небесах (в небесах)  
Ждуть з Христом там мене  
У Творця (в небесах).  
З мене хрест (з мене хрест)  
Бог здійме (Бог здійме)  
І в небесні оселі прийме (прийме)  

Побачу я місто Ісуса  
І дерево щастя й життя.  
Там в славу Христа зодягнуся, —  
Щасливим повік буду я.  
В тім місті ворота перлові,  
І слава там Божа сія.  
У ясних проміннях Христових  
Щасливим повік буду я.  
В оселях небесного Дому  
Зіллються у пісні серця,  
Хвалу віддадуть усі Богу, —  
Щасливим повік буду я.`,
  230: `В Край небесний поспішаю, —  
Щастя там знайду.  
Працюватиму охоче,  
Аж ціль осягну.  
Хто спиняв би, — ухилюсь,  
Якщо впав би, — підіймусь.  
Добіжу я до мети,  
Щастя осягну  

Чую клич і поспішаю,  
Прагну до мети,  
Бо коли б я запізнився, —  
Марні всі труди.  
Хоч біжить хтось, але зле,  
Той вінця не осягне,  
Що минуло, те забулось,  
Біжімо вперед  

До Небес, Ісусе любий,  
Погляд мій звертай,  
А коли в житті я слабну,  
Сили мені дай.  
У спокусі підкріпляй,  
У зневазі потішай,  
Ноги мої із лихої  
Стежки навертай`,
  231: `Ми тут лиш гості й чужинці,  
Всі на спасіння наше ждем.  
Вітчизна вибраних вгорі,  
І ми до неї всі ідем. 

Приспів:  
А тим часом в шатрах живем,  
Кінець ось-ось, і ми підем.  
Спаситель скоро вже прийде,  
Нас в рідний Край всіх забере  

Так Богом вибраний народ  
Теж по пустелі тут мандрував  
В край Ханаанський, де їм Бог  
Спокій і щастя обіцяв. 

Але в мандрівці цій земній  
Не нарікаймо, як вони.  
Пошле нам Бог Свій Дух Святий  
І сили дасть цей шлях пройти.  

І там, в Країні неземній,  
Знайдемо радість і спокій.  
Мандрівка скінчиться земна,  
Коли ввійдемо в дім Отця.`,
  232: `Ідуть подорожні в країну святу,  
В край вічний, де жде їх спокій.  
Ні горя, ні сліз там вони не знайдуть,  
Їх прийме Ісус дорогий. 

Приспів:  
Там нема (там нема)  
Вже гріха (вже гріха).  
Там весна (там весна)  
І життя (і життя).  
Сонце правди там вічно сія,  
Сонце правди там вічно сія  

Немає там смерті, немає страждань,  
Де будуть спасенні усі.  
Немає там зла, ні гріховних бажань,  
Там Царство Ісуса Христа.  

Ідуть подорожні; і близько вже Край,  
Де будуть спасенні усі.  
Ісус подарує навіки їм Рай,  
Що сяє в небесній красі.`,
  233: `Ми по водах океану  
В Край небесний всі пливем.  
Стихне буря й хвиль не стане,  
В пристань вічну увійдем.

Приспів:  
Скоро стихне буря в морі,  
Видно береги чудові.  
Ми до пристані пливемо  
Аж досягнемо мети,  
Відпочинок там знайдемо,  
Будьмо ж радісні, брати!

Як багато виглядають  
Ті завітні береги.  
Батьківщина їх чекає  
Після горя й боротьби. 

Припливемо в пристань нову  
З піснею: «Кінець сльозам!»  
В місто ми ввійдем чудове,  
Щоби жити вічно там!`,
  234: `Вже наближається той час:  
Знову Господь прийде,  
Щоб взяти до Себе всіх нас.  
Там кожний мир знайде.  
Будемо Бога хвалити, —  
Він нас з гріхів підняв.  
Будемо Богу служити,  
Бо Він життя нам дав.

Приспів:  
Слава, слава Христу, —  
Там заспіваємо.  
Слава, слава Христу,  
Бога прославимо.  
Алілуя, хвала,  
Ми йдемо в Край святий.  
Нас любов Божа привела  
В Єрусалим святий

В Божий Дім світлий, небесний  
Смерть більше не ввійде.  
Вічне життя — дар чудесний —  
Там в Слові ми знайдем.  
Вічно радіти ми будем,  
Як прийдем в дім Отця,  
Горе і смуток забудем,  
Там радість без кінця!  

Боже, бажаю я бути  
В країні неземній,  
Горе навіки забути  
Там, на новій Землі.  
Дай мені віри, терпіння,  
Щоб шлях вузький пройти,  
І осягнути спасіння,  
В славу Твою ввійти.`,
  235: `Країна в Небі є свята,  
Вітчизна щастя і добра.  
Там буде вічний ранок дня,  
Не буде темряви і зла. 

Приспів:  
О, славний край!  
О, дивний край!  
Розкішний, гарний вічний рай.  
Побачим скоро там в красі  
Величність Божу в повноті.  
Там і мені Спаситель мій  
Готує місце на спокій

Там буду славити Творця,  
Йому співати без кінця,  
В красу діл рук Його вглиблюсь,  
І з них я мудрості навчусь. 

Там квіти гарні, чарівні  
Дарують пахощі нові,  
Там дерево життя росте,  
Живий струмок води тече.  

Легенько вітер шелестить  
І хор небесних арф звучить,  
Це праведні співають всі  
Хвалебні Господу пісні.`,
  236: `Заспіваймо пісню, яка потішить нас:  
Скоро ми підем у вічний Дім.  
Ніч гріха мине і прийде спасіння час,  
Скоро ми підем у вічний дім. 

Приспів:  
Дружно всі підем (дружно всі підем),  
Дружно всі підем (дружно всі підем),  
Перейдем через Йордан  
І ввійдемо в Край,  
В довгожданний Ханаан.  
Скоро ми ввійдем у вічний Дім

Ми трудитись будемо щиро для Христа,  
Скоро ми підем у вічний дім.  
І розкажем всім про Його святі діла,  
Скоро ми підем у вічний дім. 

Ми знайдем спокій у Небесного Отця,  
Як прийдемо всі у вічний дім,  
І не буде там більше смерті і гріха,  
Скоро ми підем у вічний дім.`,
  237: `Хто піде з нами на Сіон, (тричі)  
Де Спас Царем буде?  
Навкруг престола станемо (тричі)  
З ясніючим лицем.  
Приспів:  
Ти, Сіонська горо,  
(Ти, Сіонська горо, ми до тебе спішимо),  
Ми до тебе спішимо,  
(Ми до тебе спішимо, ми до тебе)  
Спішимо, бо там  
(Спішимо, спішимо, бо там)  
Христос (Христос царює Сам)  
Христос царює Сам (царює Сам)

Ах, щоб нам бути і співать (тричі)  
На Сіонській горі,  
Любов Христову прославлять, (тричі)  
З ангелами вгорі.  
Чекати довго не будем, (тричі)  
Спаситель наш прийде,  
І той лиш в Край святий ввійде, (тричі)  
Хто віру збереже.`,
  238: `Ах, радість радість буде там,  
Спасенним всім серцям,  
Коли земний залишим край  
І прийдем в Божий Рай.  
Там дерево життя росте,  
Навкруг чудово все цвіте,  
Струмочок весело біжить,  
Тихесенько дзюрчить. 

Приспів:  
О що за радість там,  
Радість там, радість там!  
О що за радість там  
Спасенним буде нам!  
Красу побачим неземну,  
Христову славу осяйну,  
Величність нашого Творця,  
Там щастя без кінця

Шляхом вузьким потрібно йти,  
Щоб в Небеса ввійти.  
Якщо підемо ми по нім,  
То ввійдем в Божий дім.  
Хоч шлях тернистий і вузький,  
А нас спіткає час тяжкий,  
Підемо сміло за Христом  
Його святим шляхом.  

Христос воскрес, і зникнув жах,  
Настав величний час.  
В чудових світлих Небесах  
Чекає Він на нас.  
Повірте, стомлені, сумні, —  
Скінчаться клопоти земні.  
Хоч часто важко в світі нам,  
Але спасіння там.`,
  239: `Прекрасний білий стрій,  
Чудовий край святий,  
Світла Земля нова,  
Де ночі вже нема.  
Там я вінець життя  
Одержу від Христа,  
Ясними зорями  
Сіятиме. 

Приспів:  
Прекрасний стрій (прекрасний білий стрій),  
Світла земля (прекрасна та земля),  
Прекрасний дім (прекрасний дім святий)  
Для вірних там (для вірних слуг є там).  
Славний вінець (славний вінець нас там жде),  
Сіяючий (ясно сіяючий).  
Чудесний хор там є (чудесний хор там є),  
Славить Христа (все славить Христа)

Прекрасні ті думки —  
Утіха для мене,  
Туди ми всі дійдем,  
Як наш Господь прийде.  
Нехай же радість ця  
Наповнює серця  
Усіх бажаючих  
Жити з Христом. 

Чудовий жде нас край —  
Едемський Божий Рай.  
Все земне — марнота,  
Нас вічність жде свята,  
Де смерті вже нема,  
Щасливе там життя.  
О радість буде нам в  
Країні тій.`,
  240: `З Богом ми сміло додому пливем  
Морем життя в рідний Край.  
Море шаліє, кидає човном,  
Всюди неспокій, відчай.

В Гавань небесну, де вічний спокій,  
Сміло пливемо в наш дім неземний,  
Охороняє нас Божа рука,  
Нас не тривожить вже страх  

Хвилі здіймаються, вітер шумить,  
Видно вже берег святий.  
Ось і Вітчизна нас кличе, манить, —  
Сміло додому пливіть.

О, укріпись, і не бійся, плавець,  
Парус піднявши, радій і співай,  
Човен спасіння Небесний Отець  
Сам приведе в рідний Край  

Скоро, вже скоро надійде кінець  
Бурям і хвилям страшним.  
Бог дасть нетлінний і славний вінець  
Слугам всім вірним Своїм. 

В Гавань пристанем з хвалою в серцях  
Ми перед Тим, Хто нас в горі зберіг,  
Духом Святим вів крізь бурі і страх,  
Слава Йому будь повік!`,
  241: `Слово правди вічне Господь наш сказав,  
Ним нашій Він вірі основу поклав.  
Не скажуть щось більше людськії слова,  
В них віра, надія і любов свята 

«Я з вами, не бійтесь! Я ваш Щит в бою,  
Я — ваш Бог, і поміч скоро вам пошлю.  
Хай вас не лякають сили зла і тьми,  
Буду вас постійно у житті вести  

І якщо покличу вас крізь води йти,  
Хай вас не лякають хвилі і вітри.  
Буду завжди з вами — кожний день і час,  
Від нещастя вкрию кожного із вас  

Як полум'я жаром шлях ваш перетне,  
Вічна Моя милість поміч надішле.  
Ніхто не загине у тому вогні,  
Він лише очистить Церкву всю Мою 

Тож скажіть сьогодні всім земним братам:  
Їх Я вже ніколи злому не віддам.  
І хоч вас спокуси стрінули б тяжкі,  
Я дам перемогу, — вірте лиш Мені»`,
  242: `О ні, ніхто нас не розлучить  
З Христом в жорстокій боротьбі,  
Хоч смерть лютує, гріх нас мучить,  
Ми будем вірити й тоді.  
Якщо ж дух злоби знов повстане  
На Богом вибраних дітей, —  
Він Сам тоді на захист стане  
І їх спасе від злих людей  

О ні, Своїх Бог не покине, —  
Він міцно держить їх в руці.  
Престол Ваала скоро скине  
З висот гордині при кінці.  
Коли ж на землю прийде знову,  
Щоб царювати тут повік,  
Не буде скривджений нуждою  
В Христовім Царстві чоловік  

О так, я знаю: Бог незмінний  
В Своєму Слові обіцяв  
З нас зняти стан гріховний, тлінний  
І дати те, що ум не знав.  
І цим словам ми довіряєм,  
Бо їх сказав Сам Бог-Творець.  
Ми Богу вірим, твердо знаєм:  
Стражданням всім прийде кінець`,
  243: `Щасливий день! Моя душа  
На клич Христа відповіла.  
Мої гріхи Ісус простив,  
Уклав Завіт і освятив.

Приспів:  
Славний день, світлий день,  
Коли Христос мене прийняв.  
Святий союз Він Сам здійснив,  
Свою любов мені відкрив.  
Славний день, світлий день,  
Коли Христос мене прийняв  

Блаженний труд Господь звершив,  
Щоб з Ним колись я в Небі жив.  
Мене Він кликав, — я прийшов  
І щастя в Богові знайшов.  
Щасливий я — знайшов спокій  
В Тобі, Ісусе дорогий. 

Ти кров'ю всі гріхи омив,  
Мене із Богом примирив.  
Блаженний час! Господь прийняв  
Мене і в Книгу записав.  
Тому, Хто так нас полюбив,  
Хай буде слава назавжди!`,
  244: `Як колись перед Йорданом,  
Перед Богом стоїмо,  
До вітчизни Ханаану  
Увійти ми спішимо. 

Поможи нам, Боже добрий,  
Шлях тернистий наш пройти,  
Поможи, Господь Всесильний,  
За Тобою хочем йти  

Ось стоїть перед Тобою  
Твій покірний раб в воді,  
Він звертається з мольбою:  
«Сили дай у боротьбі».

Бути вірним обіцяє,  
Ти його не залишай.  
Щирим серцем він благає,  
Духа втіхи йому дай  

Хоче бути Тобі вірним,  
З чистим серцем назавжди,  
І в союзі нероздільно  
За Тобою вслід іти.  

А коли прийдеш Ти знову  
В славі ангелів Своїх,  
Поможи, щоб був готовий  
Жити в радощах Твоїх`,
  245: `Господь навчав учеників  
Хрестити тих людей,  
Хто волю Божу зрозумів,  
Святе життя веде.  
Приспів:  
О друже, не вагайся, вір,  
До ніг Христа впади.  
О друже, не вагайся, вір,  
Завіт з Ним уклади  

Христос всім приклад показав,  
Прийшовши на Йордан.  
Йому святе хрещення дав  
Хреститель — сам Йоан.  
Слідами хто Ісуса йде  
В земнім своїм житті,  
Його спасіння вічне жде  
Там, на Новій землі.`,
  246: `Я з Христом в Завіт вступаю,  
Від гріха омиюсь я.  
Серце й розум з Ним з'єднаю,  
Свою волю, все життя.  
Вірю твердо: Бог поможе  
Йти мені вузьким шляхом.  
Звести ворог вже не зможе, (Двічі)  
Якщо буду я з Христом  

Світ мене вже не лякає,  
Його владі не корюсь.  
Справи всі Христос рішає,  
Я ж слідом Його іду.  
В час тяжкий Він підкріпляє  
Своїм Духом скрізь, завжди.  
Мої кроки направляє (Двічі)  
На Свої святі стежки  

Хто з вас хоче пізнавати  
Добру волю, що в Христі,  
Без сумніву наверніться  
До Христа сьогодні всі.  
З світом грішним розлучіться  
І покиньте всякий гріх.  
В Ім'я Боже охрестіться, (Двічі)  
Він прийме тоді вас всіх`,
  247: `Боже, на Твоїй Вечері  
Духом ми ожили знов.  
Подаруй нам силу віри  
І святу Свою любов.  

В образ світлий Твій змінитись  
Поможи рабам Твоїм,  
До життя дай відродитись  
Словом вічним і святим.`,
  248: `Господь Свої веління  
Сповняти заповів,  
І приклад у служінні  
Лишив ще з давніх днів.  

Ісусе, Ти підвищив  
Учеників Своїх  
І Сам Себе понизив  
В покорі серед них.  

Ти ноги їм водою,  
Мов той слуга, обмив,  
І кров'ю дорогою  
Спасіння їм відкрив.  

Тепер ми всі твердо вірим,  
Що Заповідь Твоя  
Для всіх свята і вірна,  
Як і колись була.  

Ми ноги омиваєм  
Всім ближнім в простоті,  
З любов'ю споминаєм  
Твій подвиг на хресті.  

Твої благі веління  
Нам любі і святі.  
Дай сили і терпіння  
Сповняти їх в житті.  

В Свій Край святий, чудовий  
Віднині нас веди,  
Омий Своєю кров'ю  
Для правди й чистоти.`,
  249: `Хто з вас, браття дорогі,  
Куплений святою кров'ю,  
Хто від мертвих діл вільний,  
До Вечері йдіть з любов'ю.  

І наново підтвердіть  
З Господом Новий Завіт,  
Їжте хліб, згадайте знов  
Тіло Бога, що ламалось.  

А ця чаша — Його кров,  
Що за всіх нас проливалась.  
Боже, голос наш почуй,  
Духом серед нас гостюй.  

Про терпіння й смерть Христа  
Всюди людям сповіщайте.  
Тим, в кого важке життя,  
Допомогу подавайте.  

І прийміть до серця те,  
Що Він скоро знов прийде.`,
  250: `Прийдіть, відкуплені Христом,  
Згадайте хлібом і вином  
І заспівайте всі гуртом  
Про смерть Його, про смерть Його. Амінь  

Душі тривогу, біль тяжкий,  
Кривавий піт Його страшний  
Хай споминає збір святий,  
Як Він терпів, як Він терпів. Амінь  

Завіт той в пам'яті держім,  
Слідом за Ним покірно йдім  
І в вірі та надії ждім  
Христа з Небес, Христа з Небес. Амінь  

Затрубить ангел в висоті —  
Воскреснуть до життя святі,  
І в Царство ми ввійдем тоді,  
Як Він прийде, як Він прийде. Амінь`,
  251: `Страждання час вже наступав,  
Коли Христос Своїх зібрав  
І на Вечері їм явив,  
Як сильно Він їх полюбив.  

Пречистий хліб Він в руки взяв,  
Благословив, і всім роздав:  
Прийміть і їжте кожний раз, —  
Це тіло, ламане за вас.  

В мольбі з'єднавсь з Отцем Своїм,  
Подав з вином Він чашу їм:  
Прийміть, і пийте з неї всі, —  
Це Мій Новий Завіт крові.  

З любов'ю згадуєм усі  
Твій смертний подвиг на хресті.  
Скоріш, Ісусе наш, прийди,  
І нас на шлюб Свій приведи.`,
  252: `Страшно бушує життєвеє море,  
Хвилі мій човен гойдають і б'ють.  
В смертній тривозі і в тяжкому горі (Двічі)  
Богу молюся: Не дай потонуть.  

Зглянься над мною, сили дай, помилуй,  
З днів моїх юних я зі злом борюсь.  
Більше боротись не маю вже сили, (Двічі)  
Боже, помилуй, благаю, молюсь.  

Не залишай мій човен в хвилях моря,  
Боже мій милий, Боже мій благий.  
Близько вже берег небесний і скоро (Двічі)  
Там лиш знайду для душі я спокій.`,
  253: `Прости мене, Ісусе любий,  
Достойний смерті грішник я,  
Почуй слабі мої моління,  
Душа схвильована моя.  
Приспів:  
Прошу, з мене вину зніми,  
О Господи, прости, прости.  
Прошу, з мене вину зніми,  
О Господи, прости, прости.  

Прости, що дні свої найкращі  
В гріхах, невір'ї я прожив.  
О дай же вірі моїй крила,  
Щоб лиш Тобі завжди служив.  

Прости мене й скорботне серце  
Святим промінням освіти,  
Прости, як в Слові обіцяв Ти,  
В Ім'я любові, о прости.  

Прости в Ім'я страждань Голгофи,  
Де і за мене Ти терпів.  
Я знаю: Ти простиш навіки,  
Бо вірю в правду вічних днів.`,
  254: `Обізвись (обізвись), мій милий Боже,  
Я тебе благаю.  
Обізвись в тяжку годину, — (Двічі)  
Тобі довіряюсь.  

Мені тісно (мені тісно) в цій хатині,  
Серцем я ридаю,  
Не лишай мене самого (Двічі)  
У чожому краю.  

Все з Тобою (все з Тобою) переможу,  
Ти — моя надія,  
Ти і радість, Ти і сльози, — (Двічі)  
Всіх народів мрія.`,
  255: `Научи мене, Боже, молитись,  
Твій священний Закон берегти,  
Горде серце Тобі покорити,  
І себе для гріха розп'ясти. (Двічі)  

Щоб з Тобою я жив нероздільно,  
Дух Святий щоб в мені пробував,  
Щоб любити Тебе міг постійно  
І лиш Ім'я Твоє прославляв. (Двічі)  

Милосердну Твою, Боже, волю  
Ти мене виповняти навчи,  
І мій хрест, як земну свою долю,  
Нести без нарікань поможи. (Двічі)  

Щоб обмитий пречистою кров'ю  
Своє серце я чистим зберіг,  
І Твоєю святою любов'ю  
Своїх ближніх любити я міг. (Двічі)`,
  256: `Боже, в цей молитви час  
Біль душі несемо свій.  
Хочемо знайти спокій.  
Чи не прийдеш, друже мій?  

Приспів:  
О спіши (поспіши), о спіши (поспіши),  
До Спасителя іди.  
О спіши (поспіши), о спіши (поспіши),  
До Спасителя іди  

Без надії ти прожив,  
В темряві гірха ходив.  
Повернися до Христа,  
В Нім знайдеш нове життя.  

Світ тебе обманював  
І спокою ти не знав, —  
На Христа зверни зір свій,  
В Ньому радість і спокій.  

Визнай, друже, кожний гріх,  
Є бальзам для ран твоїх,  
Серце Богові віддай,  
Він тобі відкриє Рай.`,
  257: `Якщо твій дух утомився  
В тяжкій життєвій борні,  
Щиро до Бога звернися —  
І стане легко тобі.  

Приспів:  
Хто (о хто) утомився,  
Хай він до Бога прийде,  
Серцю, розбитому горем,  
Силу молитва дає  

Якщо в життєвих турботах  
Серце твоє заболить,  
Не залишайся самотнім,  
Стань, в тишині помолись.  

Якщо печаль і страждання  
Душу твою потрясуть,  
В тяжкі хвилини зітхання  
Сльози з очей потечуть,  

Друже, потрібно молитись,  
Сила в молитві, повір.  
Нею твій дух укріпиться  
І стане легко тобі.`,
  258: `О Боже, Боже, дай же сили  
Прощати ближнім всім моїм  
І в серці завжди до моглии (Двічі)  
Не мати зла на ворогів  

Щоб я неправді не корився  
В тяжкій життєвій боротьбі,  
І научи мене молитись (Двічі)  
Від серця щирого Тобі  

Не раз мене тут зневажають,  
Ганьблять Твої святі Слова,  
Та я від серця всім прощаю, (Двічі)  
Як в Заповіті Ти сказав  

Тож поможи Твої веління  
Назавжді в серці зберегти,  
Звіщати людям про спасіння (Двічі)  
Безстрашно за Тобою йти`,
  259: `Коли в житті цім я втомлюся  
І втрачу в боротьбі спокій,  
Тоді до Господа звернуся:  
«Пошли спокій свій, Боже мій!»  

Приспів:  
Пошли спокій і спасіння  
(Спокій і спасіння),  
Дай мир Твій всьому творінню  
(Мир всьому творінню),  
Хай в щасті пробуває люд Твій  
(Хай буде Твій мир),  
Пошли спокій Свій, Боже мій,  
(Пошли спокій Свій Боже мій)!  

Скажи лиш слово — й грізна буря  
Замовкне і прийде спокій,  
А в небі світлої лазурі  
Засяє сонце ясних мрій.  

Дай зрозуміти, милий Боже,  
Що тільки Ти — Спаситель мій,  
Щоб в світлий день чи в час тривожний  
Я міг би бути завжди Твій.`,
  260: `Не минай мене, Ісусе,  
На земнім шляху,  
В час недолі і спокуси  
Не покинь, молю.  

Приспів:  
Боже, Боже,  
О почуй мене,  
Серцем я Тебе благаю:  
Не минай мене  

Я утомлений душею, —  
Поможи мені,  
Силою зміцни Своєю  
В дні мої земні.  
Всю надію покладаю  
Лиш на Тебе я,  
Оживи мій дух, благаю,  
Ти — моє життя.  
Ти Один лиш потішаєш,  
Радість всім даєш,  
Від нещастя захищаєш,  
В Небо приведеш.`,
  261: `Ти знаєш, Боже, моє бажання,  
Молитву слухаєш мою,  
Ти знаєш серця тяжкі страждання, (Двічі)  
Коли я гіркі сльози ллю  

Ти знаєш, Боже, що я бажаю  
Не слави й скарбів землі,  
Я щирим серцем Тебе кохаю (Двічі)  
З моїх весняних юних днів  

Сумує серце моє порою,  
А на устах немає слів,  
І я самотній, тужу душею, (Двічі)  
Змовкає мій веселий спів  

Ніхто не знає, усім байдуже,  
Куди душею лину я,  
І хто спитає, і хто потішить, (Двічі)  
Коли сумна душа моя?  

Тебе благаю: о не барися,  
Прийди до мене, Боже мій,  
Бо слабнуть сили, і я втомився, (Двічі)  
А ще далекий шлях земний`,
  262: `Я утомлений, безсилий,  
Боже мій, до Тебе йду.  
Лиш в Тобі я нові сили  
І спокій душі знайду.  

Приспів:  
Боже мій, до Тебе йду я,  
Оживи мене, молю,  
Радість дай мені святую  
І пошли любов Твою  

Я нещасний скрізь блукаю,  
Де мені спокій знайти?  
Господи, почуй, благаю,  
Вірю, втішиш тільки Ти.  
Всі нещастя і тривогу  
Відверни у час важкий,  
Поможи пройти дорогу —  
Мій тернистий шлях земний.`,
  263: `Почуй же, Господи, моління,  
Сердечно так благаю я,  
В тяжкі хвилини дай терпіння,  
В Тобі надія вся моя  

Нехай молитва моя лине  
Як той пахучий фіміам.  
Я серцем прагну безупинно  
В чудовий Твій небесний Храм  

Тебе, Спасителю, благаю:  
Прости й помилуй, я згрішив.  
Пробач, що віри мало маю,  
Що знов Тебе я засмутив  

Все зло і гріх з душі моєї  
Зніми, очисти назавжди,  
Наповни силою Твоєю,  
Щоб міг я вічність осягти`,
  264: `О Боже, Боже, дай же сили  
Прощати ближнім всім моїм,  
(І в серці завжди до могили  
Не мати зла на ворогів) (своїх)  
Щоб я неправді не корився  
В тяжкій життєвій боротьбі,  
(І научи мене молитись  
Від серця щирого Тобі). (Тобі)  

Не раз мене тут зневажають,  
Ганьблять Твої святі Слова,  
Я щиро ворогам прощаю,  
Як в заповіті Ти сказав (сказав)  
Тож поможи Твої веління  
Назавжди в серці зберегти,  
(Звіщати людям про спасіння  
І вірно за Тобою йти (вперед))`,
  265: `Боже, Отче Всемогутній,  
Глянь на нас в молитви час.  
Ми Тебе сердечно просим:  
Всіх прости, помилуй нас  

Боже, Отче Милостивий,  
Не лиши в тривожний час,  
Не позбав нас благодаті,  
А спаси й помилуй нас  

Боже, глянь, Твої ми діти,  
Тут зійшлися в добрий час.  
Дай нам сили свято жити,  
Від гріха звільни всіх нас  

Боже милий, Боже любий,  
Не лиши і сили дай,  
Підкріпляй постійно Духом  
І веди в небесний край`,
  266: `Будьте пильні завжди і моліться, -  
День останній настає.  
В силі Божій духом обновіться,  
Скоро наш Господь прийде.  
Приспів:  
Вір, молись — уже недовго,  
(Вір, молись — уже недовго,  
Вір, молись — уже недовго),  
Вір, молись — Господь велить.  
(Вір, молись — Господь велить.  
Вір, молись — Господь велить).  
Скоро Він прийде у славі,  
(Скоро Він прийде у славі,  
Скоро Він прийде у славі),  
Нас візьме, з Ним будем жить  
(З Ним будем жить)  

Будьте пильні завжди і моліться, -  
Вже надходить славний час,  
Духом правди й віри одягніться,  
Щоб світильник не погас.  
Будьте пильні завжди і моліться,  
Ворог істини тут не спить,  
Всім життям й думками обновіться  
Захистить нас віри щит.  
Будьте пильні завжди і моліться,  
Бог постійно чує вас,  
На Ісуса з вірою дивіться,  
Він поможе в кожний час.`,
  267: `Дай святість нам, Боже,  
Дай тихість, Твій страх,  
Дай вірність в стражданнях  
І спокій в серцях,  
Побільшуй в нас віру,  
І дух обнови,  
Дай радість в молитві,  
Сумнів прожени  

Дай в серце подяку  
За ласку Твою,  
Дай вірити в Слово  
І в силу святу.  
В шалених спокусах  
Будь зі мною Ти,  
Щоб міг хрест життєвий  
З вірою нести  

Дай нам чисте серце,  
Дай дух правоти,  
І світлом небесним  
Душу освіти.  
Хочемо навчатись  
Тільки від Тебе,  
Вічно прославляти  
Ім'я пресвяте`,
  268: `При Божім троні в Небесах  
Зберуться діточки,  
Чудовим співом задзвенять  
Дитячі голоси.  
Приспів:  
І там (і там), і там (і там),  
Радіють у Христі (Христі).  
І там (і там), і там (і там),  
Йому співають всі (усі)  

За них Спаситель кров пролив,  
Щоб змити кожний гріх,  
Щоб і вони у Небесах  
Зазнали райських втіх.  
Любов Христа усі вони  
Прийняли на землі,  
Тому тепер Його лице  
Так близько бачать всі.`,
  269: `Книга давня і свята —  
Правди вічної слова.  
Я пригадую свого дитинства дні:  
Моя мама дорога  
В ній читала про Христа,  
То були хвилини радісні мені.  
Приспів:  
Книга Божа (Книга Божа) —  
Найдорожча (найдорожча).  
Як люблю її з дитячих літ моїх (літ моїх)!  
Обіцяє світлий рай  
І веде у вічний Край,  
Прийме там Господь всіх вибраних Своїх  

Про любов мого Творця,  
Про спасіння і життя  
Вчила мама змалку істин дорогих.  
Як Спаситель постраждав  
І за гріх мій помирав,  
Я про те дізнався з сторінок живих.  

Хоч давно про це я чув,  
Але слів тих не забув,  
У мене ця Книга — світло на путі.  
Я Спасителя люблю  
І завжди за Ним іду,  
Він найкращий, найвірніший Друг в житті.`,
  270: `Радісні ті діти, Отцем котрих є Бог.  
Радісні ті діти, Отцем котрих є Бог.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, Отцем котрих є Бог  

Радісні ті діти, що в Церкві істинній.  
Радісні ті діти, що в Церкві істинній.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, що в Церкві істинній  

Радісні ті діти, що люблять Біблію.  
Радісні ті діти, що люблять Біблію.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, що люблять Біблію  

Радісні ті діти, що завжди моляться.  
Радісні ті діти, що завжди моляться.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, що завжди моляться  

Радісні ті діти, котрих Спаситель спас.  
Радісні ті діти, котрих Спаситель спас.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, котрих Спаситель спас  

Радісні ті діти, котрим Бог дасть вінець.  
Радісні ті діти, котрим Бог дасть вінець.  
Радісні ті діти, радісні ті діти,  
Радісні ті діти, котрим Бог дасть вінець`,
  271: `Пташок маленьких любить Бог,  
Їм їжу подає.  
Якщо Він любить пташечок,  
То любить і мене.  
Приспів:  
Так, любить Він.  
Так, любить Він.  
Я знаю: любить Він.  
Маленьких діток любить Бог,  
Він любить і мене  

Бог любить лілії в полях,  
Де річенька тече.  
Якщо Він любить квіточки,  
То любить і мене.  
Господь і пташкам, і квіткам —  
Всьому життя дає.  
Не забуває діточок,  
Він любить і мене.`,
  272: `Гляньте, що за гарний ранок,  
Як виспівують пташки,  
В ранній час легкий серпанок  
Стелиться понад луги.  
В світлім (в світлім) сонячнім промінні  
Рожевіють гір верхи,  
У яскравім мерехтінні  
Перли свіжої роси. (Двічі)

Богу щиро помолімося  
І подяку принесім,  
На служіння посвятімся,  
Сил до праці попросім.  
Він почує (Він почує) всі моління,  
Вмить потішить і зміцнить,  
Як спіткає нас терпіння,  
Він на поміч поспішить. (Двічі)

Скоро прийде вічний ранок,  
Де вже ночі більш нема,  
Там триває безустанно  
Гарна й запашна весна.  
Сам Ісус (Сам Ісус там) — наше Сонце,  
А Його любов — наш лік.  
Там веселі і щасливі  
З Богом житимем повік. (Двічі)`,
  273: `Глянь вгору, глянь вгору,  
Залиши свою журбу.  
Слухай, як пташки співають,  
Зранку Бога прославляють.  
Заспівай і Ти Йому. (Двічі)

Глянь кругом, глянь кругом —  
Сонце світло розлило.  
Ваблять зір барвисті квіти,  
Ліс підніс зелені віти,  
Гарно, як в раю було. (Двічі)

На лугах, на полях  
Буйні трави і жита,  
Про любов Творця шепочуть  
І немов сказати хочуть:  
Богу шана і хвала. (Двічі)

Друже мій, поспіши,  
Жертву Богу принеси.  
За чудовий дар спасіння,  
За красу Його творіння  
Вірно Господу служи. (Двічі)`,
  274: `Настрой струни в своїй арфі,  
Пісню з радістю заграй,  
За хороший відпочинок  
Бога в псалмах виславляй  

Ти дозволив дня діждатись,  
І зі сну мене збудив,  
Захищав від зла і смерті,  
І спокоєм наділив  

Хай подяка серця мого  
Лине зранку до Небес.  
Віджени печаль, тривогу,  
Щоб прославив я Тебе  

Поможи мені прожити,  
Боже мій, на цій землі  
Так, щоб в правді міг ходити,  
Бути славою Тобі`,
  275: `Кращі літа молодії,  
Сили бадьорі, мов дні весни,  
Ми посвятім для Ісуса  
Все, чим Він нас наділив (наділив).  
Приспів:  
Що може бути ще краще  
(що може бути ще краще),  
Ніж послужити Христу  
(ніж послужити Христу),  
Тут, у житті цім дочаснім,  
Серце віддати Йому (Йому)?

Слухай, Христос закликає,  
Час благодатний для нас настав.  
Більше вагатись не можна  
Й жити безпечно в гріхах (у гріхах).  

Сміло Ім'ям ми Ісуса,  
Битву з гріхом дружно поведем.  
Він захистить від спокуси,  
Божим запалить вогнем (тим вогнем).`,
  276: `Тобі я служити бажаю,  
Мій Спасе, від літ молодих,  
Та сили замало я маю,  
Благаю, щоб Ти допоміг. 

Приспів:  
Служити всім серцем бажаю Тобі.  
(Служити всім серцем бажаю Тобі).  
О Боже, зміцни ж мої сили слабі.  
(О Боже, зміцни ж мої сили слабі).

На славу Тобі все життя посвячу,  
(На славу Тобі все життя посвячу),  
Дорогою правди Твоєї піду.  
(Дорогою правди Твоєї піду)

А часом, як сили слабіють  
І в'яну під спекою дня,  
Хай крила Твої мене вкриють,  
Зміцнить мене сила Твоя. 

До смерті Твоїм хочу бути,  
З любов'ю служити Тобі,  
Щоб Ти мене міг пригорнути  
В небесній Країні святій.`,
  277: `Хвалу, Господь, Тобі приносим  
За щедрий дар, що нам послав.  
Благослови нас, щиро просим,  
І сил нових до праці дай.

Приспів:  
Господь, в цей час (Ти в цей час),  
Будь серед нас (будь між нас),  
І сили нам пошли.  
Господь в цей час (Ти в цей час),  
Будь серед нас (будь між нас),  
І всіх благослови

Ти не лишав нас в дні минулі,  
Свій хліб щоденний подавав,  
Провадив в цій земній долині,  
Святого Духа посилав.  

Допоможи, щоб в Царстві слави  
Нам бути на Вечері тій,  
На шлюбі Агнця, щоб ми разом  
Там заспівали гімн святий. 

Коли ж ввійдем в святі оселі, —  
З Тобою в щасті будем жить,  
Тоді Ти Сам, наш Спасе милий,  
З любов'ю будеш нам служить.`,
  278: `Господь між нами Духом Сам.  
Чи є для Нього в серці храм  
І жертва чиста від сердець,  
Яку чекає Бог Отець? 

О, хай ніхто з нас не мовчить,  
І Богу жертву уст несе,  
Бо Він — спасіння нам і щит,  
Все — Ним, Йому й для Нього все`,
  279: `За все Тобі, я дякую, мій Боже,  
За всі дари небесні і земні,  
За сльози, радість і за дні погожі, —  
За все, за все, що Ти даєш мені  

Твій Ангел, Боже, йшов завжди зі мною,  
І сили підкріпляв у боротьбі,  
За руку вів дорогою важкою,  
Щоб довірявся повністю Тобі  

За світло дякую в земній пустині,  
Що освітило шлях з Небес Твоїх,  
За втіху дивну й милості донині,  
В час смутку, горя і жалів моїх 

Ісусе, дякую Тобі безмірно  
І за життя, і за пролиту кров,  
За хрест тяжкий, який Ти ніс покірно,  
За смерть Твою і за Твою любов`,
  280: `О Боже, благаєм,  
Ти щастя їм дай,  
До вічного Краю (Двічі)  
Сім'ю направляй  

Хай завжди з Тобою  
Вони проживуть  
І світло любові (Двічі)  
Всім ближнім несуть 

Дай мудрість їм, Боже,  
В земному житті,  
Найбільше цінити — (Двічі)  
Твій мир у сім'ї  

Хай зміцнюють діти  
Подружнє життя,  
В щасливій родині (Двічі)  
Хай славлять Христа  

В надії священній  
Обох їх зміцни,  
Дар віри безцінний (Двічі)  
В серцях укріпи  

Дай Духа Святого,  
Щоб Він керував,  
На добру дорогу (Двічі)  
Завжди направляв`,
  281: `Де Божий Дух в серцях живе,  
Там радість, щастя й мир,  
Любов там близьких обійме,  
З'єднає ворогів.  

Приспів:  
О, Господи (о, Господи),  
любов пошли (любов пошли),  
Сім'ю нову (сім'ю нову)  
благослови (благослови),  
З'єднай навік (з'єднай навік)  
Ти їх серця (Ти їх серця),  
Щоб славилось (щоб славилось)  
Твоє Ім'я (Твоє Ім'я)  
  
Де згода, єдність і любов  
В громаді чи в сім'ї,  
Небесний буде там покров,  
Щасливі там усі.  
Де перемога є над злом,  
Там радість, щастя й мир,  
Життя, наповнене добром,  
Христос там — Друг сім'ї.`,
  282: `Боже, з Неба Ти зійди  
І цей шлюб благослови.  
Дай цій парі молодій  
Мир і щастя в повноті  
Їх труди благословляй  
І в руках Своїх тримай,  
Серед всіх турбот земних  
Вірним Другом будь для них  
В боротьбі важкій з гріхом  
Будь для них Помічником,  
Віру Ти їх утверди,  
В славу вічну приведи`,
  283: `Ось перед нами стоять молоді,  
Благослови їх, Ісусе, в житті,  
Духом любові союз цей скріпи,  
Стежкою правди сім'ю їх веди.  
Приспів:  
Боже ласкавий, серця їх з'єднай,  
Щастя пошли, від незгод зберігай.  
Будь вірним Другом, завжди потішай,  
Сам приведи їх в Обіцяний край  
  
Дай їм любов зберегти до кінця,  
В мирі і в згоді прожити життя,  
В горі потіш, в боротьбі укріпи,  
Духа Святого їм щедро пошли.  
Ангели Божі вам радість несуть,  
Славні оселі на Небі вас ждуть.  
Будьте готові зустріти Христа,  
Він подарує вам вічне життя.`,
  284: `О, Господи, у Галилею  
До Кани Ти на шлюб ходив,  
Святою силою Своєю  
Там перше чудо Ти створив.  

Приспів:  
Свій мир святий на нас пролий  
І славу Свою яви.  
Свій мир святий на нас пролий,  
І всіх благослови  
  
Ти світлим променем любові  
Життя тривогу їх розвій,  
Щоб звуки пісні пречудові  
Лунали скрізь в сім'ї новій.

В союзі будь і спілкуванні  
Постійно, Отче Всеблагий,  
Хай їх потішить у стражданні  
Наш Утішитель — Дух Святий. 

І щоб в земній дорозі гідно  
Тебе прославили вони;  
Повчай їх Словом, як потрібно  
Любити й вірити завжди. 

Прийди і щедрою рукою  
Пролий Свої дари на них,  
Вінцем і славою святою  
Навік звінчай дітей Своїх.`,
  285: `Спи тихим і спокійним сном  
В могилі, втомлений трудом,  
Аж поки наш Господь прийде,  
І в вічність Сам тебе введе 

Ти вік недовгий тут прожив  
І в тілі смертному ходив,  
Тепер в могилі спочивай,  
Труби Архангела чекай  

З землі ти взятий, в землю йдеш,  
В ній час короткий проведеш.  
Господь наш скоро вже прийде,  
Тебе з могили підійме  

Від всіх лихих пригод й журби  
Ти заспокійся й відпочни.  
Спаситель сон розбудить твій  
І дасть вінець безсмертя Свій`,
  286: `Звеличуй Бога, душе убога,  
Йому хвалу в піснях співай  
Аж поки скінчиться тут дорога,  
І ти в землі спочинеш, знай.  
Він дух життя всім людям дав,  
Щоб світ Його любов пізнав.  
Приспів:  
Алілуя, алілуя!  
Хай славен буде Бог повік  
  
Щасливий всюди в житті той буде,  
Кого в житті Господь веде,  
Хто в цій дорозі вузькій не блудить,  
Хоч і тривога надійде.  
Хто молить Господа в тиші, —  
Рятунок знайде для душі. 

Хвали, творіння, предвічне Ім'я,  
Бо Словом Божим світ стоїть.  
Народи світу, всі покоління,  
Хваліть Христа із роду в рід.  
Ми, діти Божі, теж хвалім  
Отця і Сина, і скажім:`,
  287: `Несем ми тіло на спокій  
Сховати у землі сирій,  
Щоб спочивало тут воно,  
Чекало Господа свого  

Тож спи, наш друже дорогий,  
В оселі темній сон міцний.  
Тебе не збудить біль душі  
І ворог не знайде лихий  

Тепер відходиш ти від нас,  
Та за короткий дуже час  
Мине життя це день за днем  
І до кінця ми всі прийдем  

Коли ж день славний надійде  
Й на землю наш Господь прийде,  
Він мертвих в Бозі воскресить,  
Безсмертя й вічність подарить`,
  288: `Схилилось сонце, лист спадає,  
Дрімає в холоді земля,  
Кругом життя все завмирає,  
Сплять гори, ниви і поля.  
Ти також після днів життя  
Ідеш в могилу, в забуття. (Двічі)  
  
Не вічно так в природі буде, —  
Знов в небі сонечко зійде,  
Весною радість знову буде,  
Уся природа зацвіте.  
До тебе теж весна прийде,  
Як Бог з могили підійме. (Двічі)`,
  289: `Спокійно спи від всіх турбот і лиха.  
У цій землі твоя оселя тиха.  
Зло не порушить сон твій спокійний.  
Смертний той час для всіх неодмінний.  
Спокійно спи  
  
Спокійно спи. Знесилений журбою,  
Ти не зазнав тут радощів, спокою.  
Серце твоє більш горя не знає,  
Мирний твій сон Сам Бог зберігає.  
Спокійно спи  
  
Спокійно спи до ранку воскресіння,  
Бог з тебе здійме цей одяг тління.  
Хай же розлука нас не тривожить,  
Божий світанок скоро надходить.  
Спокійно спи`,
  290: `Вірних Богові чекає  
Новий Край на небесах,  
Де вже сліз, хвороб немає  
І незнаний смерті страх. 

Приспів:  
Там спокій для всіх нужденних,  
Для людей від зла спасенних.  
Після днів сумних, непевних  
Вічний мир прийде.  
Там не буде сліз і горя,  
Стихнуть грізні хвилі моря  
І в саду Едема вдома  
Вірних радість жде  
  
Наш Господь уже готує  
Дорогі оселі нам,  
І коли Він приготує,  
То прийде за нами Сам.  

Там розлук й плачу не буде,  
Зникне горе, смерть і гріх,  
Кожний з нас радіти буде  
В тій країні миру й втіх.

Хто тепер Христа чекає,  
Вірить всім Його словам,  
Той, хоч тяжко тут страждає,  
Жити буде вічно там.  

Там лицем в лице побачим  
Ми Ісуса в небесах,  
З хором ангелів прославим  
Його в піснях на устах.`,
  291: `Ми побачимось напевно  
У краю чудових зір,  
В ті оселі увійдемо,  
Де святих весь Божий збір.  
Приспів:  
Так, побачимось напевно,  
Де стрінуться святі усіх віків.  
Вічну радість ми знайдемо  
В тій Вітчизні дорогій  
  
Там зустрінем наших любих,  
Що заснули у Христі.  
Всі вони на голос трубний  
Встануть зі своїх гробів.  

Ми лицем в лице побачим  
Всі Христа, коли прийде.  
Він в безсмертя нас зодягне,  
В дім Отця Свого візьме.

За Ісусом сміло йдімо,  
Він вже скоро надійде,  
Вірно тут Йому служімо,  
Він до Царства нас введе.`,
  292: `Вперед, вперед підем ми в Новий рік!  
Хто вів народ колись в земній пустині,  
Веде рукою всюди нас донині.  
Не бійся, — Він завжди із року в рік  
Веде Своїх  

Іди, іди до світлої мети.  
Відкинь від себе всі лихі сумніви.  
Вже чути недалеко райські співи.  
Хоч буря й небезпека навкруги, —  
За Ним іди!  

За Ним, за Ним крокуй шляхом вузьким.  
Хоч тисячі в цій битві відступають,  
Та стріли смертні вірних не здолають,  
Ти переможеш з Богом всеблагим.  
Іди за Ним!`,
  293: `Забудем горе і томління,  
Із себе скинем марний страх,  
І принесем Творцю хваління  
Ми в пісні дивній на устах  
За те, що нас, дітей Своїх,  
Він мудро вів в минулий рік  

Прийми ж від нас цей спів сердечний:  
Ми — любі діти всі Твої.  
До Тебе, Боже, в Храм небесний  
Хай линуть звуки голосні.  
Ти нам прощаєш всякий гріх,  
Любов'ю зігріваєш всіх  

Ми знову в новий рік вступаєм.  
Освітлюй шлях нам до мети,  
Своє життя Тобі вручаєм,  
Завжди і всюди з нами йди.  
Оберігай від тьми гріха.  
Хай нас веде Твоя рука  

За все Тобі хай буде слава  
Із уст слабих дітей Твоїх.  
Твоя і сила, і держава,  
Ти — Джерело дарів усіх.  
Благослови ж народ святий  
На цей прийдешній Рік Новий`,
  294: `Бог добрим був! В Своїй святій любові,  
Нас вів минулий рік як сильний Вождь.  
Бог добрим був, — скажу я і сьогодні,  
Візьмусь за діло знову без турбот 

Так рік за роком на землі проходить,  
І грізний день відплати надійде.  
Блажен, хто тут шляхом Ісуса ходить, —  
Той з Ним навік в життя нове ввійде  

Мій добрий Бог дає мені надію,  
Хоч і живу в останні дні земні,  
Де б я не був, — про Нього тільки мрію:  
Він — добрий Пастир, вірний Друг мені

Йому життя і волю всю вручаю,  
Хай держить Він мене в руці Своїй,  
І погляд втомлений свій підіймаю  
Туди, де ллється радість і спокій`,
  295: `О Боже, ми — Твоя сім'я,  
Тобі присвячуєм дім цей.  
Хай славлять тут Твоє Ім'я  
І бачать всі святе лице 

Хай в ньому проповідь свята  
Звучить із Біблії до всіх,  
Нехай приходять до Христа  
Всі ті, кого ще мучить гріх 

Повік тут, Господи, живи,  
І серцем кожного керуй,  
Дітей Своїх благослови,  
І храм живий з них побудуй  

Не тільки місце, але й нас  
Як Твій правдивий Божий храм  
Охороняй у кожен час,  
Аж приведеш до вічних брам`,
  296: `Люблю Господній дім, —  
Я тут пізнав любов  
І зрозумів пречисту кров, (Двічі)  
Пролиту на хресті 

В цім домі — вічний Бог  
Будує храм живий,  
Охороняє Дух Святий (Двічі)  
Від горя і тривог  

Цю Церкву я люблю,  
Люблю її дітей,  
Молюсь за Церкву із людей, (Двічі)  
В ній Богові служу  

Хотів би я завжди  
У Церкві бути цій,  
Щоб розділити час сумний (Двічі)  
І в вічний дім ввійти 

В єднанні, як сім'я,  
За Господом ідем;  
В небесний дім святий ввійдем, — (Двічі)  
Нас жде Нова земля`,
  297: `Дорогі нам хвилини Господь дарував, —  
Ми зустріли сестер і братів.  
З нами буде Ісус, як у Слові сказав, — (Двічі)  
Хай ллється з сердець Йому спів

В дорогі ці хвилини зібрались усі,  
Їх в єднанні святім проведем.  
Як колись, в давнину, на Фаворській горі (Двічі)  
Намети ми тут розкладем  

Від життєвих турбот, суєти відпочинем,  
Об'єднаєм в молитві серця,  
І в надії за Господом далі підем, — (Двічі)  
Вже близько оселя свята  

На життєвім шляху сліз немало проллєм,  
Горе й смуток зустрінуться нам,  
Але скоро в Край рідний святий увійдем, (Двічі)  
Навіки вже будемо там`,
  298: `Бог з тобою, — ми зустрінемось.  
Хай Господь охороняє,  
Кожний крок твій направляє.  
Бог з тобою, — ми зустрінемось.  

Приспів:  
Скоро ми всі зустрінемось,  
(Бог з тобою, — ми зустрінемось)  
Зустрінемось перед Христом (перед Христом).  
Скоро ми всі зустрінемось.  
(Бог з тобою, — ми зустрінемось).  
Ми зустрінемося із Господом  
  
Бог з тобою, — ми зустрінемось.  
Від Христа не віддаляйся,  
З світом грішним не єднайся.  
Бог з тобою, — ми зустрінемось. 

Бог з тобою, — ми зустрінемось.  
Хоч життя тут розлучає, —  
В небі зустріч нас чекає.  
Бог з тобою, — ми зустрінемось.`,
  299: `Ісусе, Твій блаженний труд  
Ти слугам доручив,  
Щоб кожний про спасіння путь  
Всім людям сповістив.  
Дай сили нам з Тобою йти,  
Вершити ці святі труди,  
З любов'ю й ревністю в серцях  
І в тихих, щирих молитвах.  
Благослови і Дух Святий пошли  
  
Ти Сам покірно як слуга  
З любов'ю всім служив  
І до людей Свої Слова  
Нести нам доручив.  
Всім бідним, що в гріхах живуть,  
В журбі і горі сльози ллють,  
Наповни серце слуг земних  
Знанням наук Твоїх святих,  
Щоб ласки дар їх спас від вічних кар  
  
Ми будемо своїм життям  
Служити лиш Тобі.  
Тож поможи Твоїм рабам  
В великому труді.  
Твій Дух Святий пошли в серця  
І дай нам радість без кінця,  
В похмурі і сумні часи  
Своїх рабів Ти збережи,  
Щоб вісник Твій звершив цей труд святий`,
  300: `Знову осінь наступила,  
Листя осипається,  
Всі ліси позолотила,  
Сонце не всміхається.  
Де ж пташки, що так співали  
Ранком, як зійде зоря?  
В теплий край повідлітали (Двічі)  
За ліси і за моря  
  
Там, у теплім, дальнім краї,  
Де весна завжди цвіте,  
Дзвінко хор пташок співає  
І Творцю хвалу несе.  
Так і в кожної людини  
Літо і весна пройде.  
Буде той навік щасливий, (Двічі)  
Хто в Край Божий увійде`,
  301: `До нас прийшла нова весна,  
І сонце вже блищить,  
Встає природа до життя,  
Нам серце веселить.  
Приспів:  
Юність ти моя, вся краса життя — (Двічі)  
Це розквіт сил і мрій святих  
Для вічності  
  
Все навкруги — в полях, лісах —  
Буяє і цвіте,  
Хор птахів дзвінко в небесах  
Свій спів Творцю несе.  
Тож є пора для юних сил  
Усіх людей землі, —  
Щасливий той, хто посвятив  
Для Господа її.  
  
Мій друже, молодість твоя —  
Це чарівна весна,  
Це розквіт мрій всіх золотих  
Для добрих діл святих.`,
  302: `Хваліте Господа, всі народи,  
Прославляйте Його, всі племена,  
Дуже велика милість Його в нас.  
Істина Господня пробуває повік.  
Алілуя! Алілуя! Алілуя! Алілуя! Алілуя! (Двічі)`,
  303: `О Боже, як збагнути нам  
Твою любов святу?  
В яких піснях прославити  
Цю неземну красу?  
О, як багато Ти даєш  
На кожний день мені!  
Надія, радість і життя, —  
Це все Твої дари  
  
І сонця промінь в небесах,  
І квіти на землі,  
І мир святий в людських серцях,  
Це все — Твої дари.  
Бажаю, щоб любові дар  
У серці все зростав,  
Світив у темряві нічній  
І ближніх зігрівав.`,
  304: `Сьогодні день святий,  
Блаженний наш спокій.  
Господь Творець в цей день спочив,  
(Господь Творець в цей день спочив)  
Благословив і освятив.  
Чудовий, славний день святий для нас,  
Чудовий день святий,  
(Чудовий день, чудовий день святий)  
Приємний наш спокій.  
Блаженний мир і радість небесна  
Нас кличе всіх в наш вічний дім,  
В край рідний, дорогий  
(Суботній мир, суботній мир)  
Веде в спокій святий.  
(Спокій святий, спокій святий)  
Прийдіть у дім Отця,  
Його прославте як Творця  
За цей чудовий день святий,  
За любий наш спокій, —  
Суботній день святий`,
  305: `Душе моя, душе моя,  
Співай для Бога, співай для Бога, співай для Бога,  
(Співай для Бога, співай же, веселим співом прославляй)  
Веселим співом прославляй! Прославляй!  
Хоч часом сумно на дорозі,  
(Хоч часом сумно на)  
Ти все ж угору підіймайсь!  
(Дорозі, Ти все ж угору підіймайсь!)  
Ти все ж (Ти все ж) угору підіймайсь! 

Не бійся хмар й незгод земних ти, —  
(Не бійся хмар й незгод земних ти)  
Нехай дзвенить веселий спів,  
(Нехай дзвенить веселий спів)  
Старайсь життям своїм світити, —  
(Старайсь життям своїм світити)  
Зустрінеш радість вічних днів  
(Зустрінеш радість вічних днів) 

Радій, душе, — вже недалеко  
(Радій, душе, — вже недалеко)  
Той берег рідний, дорогий.  
(Той берег рідний, дорогий).  
Життя там радісне й щасливе  
(Життя там радісне й щасливе)  
Бог Своїм вірним подарить.  
(Бог Своїм вірним подарить).

Душе моя, душе моя,  
Співай для Бога, співай для Бога, співай для Бога,  
(Співай для Бога, співай же і)  
І будь лиш власністю Його.  
Тобі в журбі Він допоможе,  
Введе до Царства, до Царства, до Царства,  
Введе до Царства Свойого`,
  306: `Дрімає Гефсиманський сад.  
Ісуса друзі мирно сплять.  
В тривозі смертній Сам Один  
Отця благає Божий Син.  
Христос коліна преклонив  
І гаряче Отця молив.  
А голос скорбної душі  
Почувся в тій нічній тиші:  
«Хай чаша мук пройде оця,  
(«Хай чаша мук пройде оця,)  
Та воля не Моя — Твоя.  
(Та воля не Моя — Твоя.)  
Хай буде, Отче.  
Я вже йду».  
І стало тихо все в саду.  
І капав піт з Його Чола,  
Мов краплі Крові із Хреста.  
І Ангел Божий там стояв, —  
Христа в молитві  
Підкріпляв, підкріпляв`,
  307: `Благодать Господа Ісуса Христа  
І любов Бога Отця  
Та єднання Святого Духа  
Хай буде з нами,  
Хай буде з нами,  
(Буде з нами, буде з нами).  
Амінь`,
  308: `Забудь турботи й Божий день святи,  
В Божий дім прийди.  
Як славно тут потік життя води  
Ллється з висоти.  
Тут народ Христа співає  
Перед Божим вівтарем (вівтарем).  
Слово Боже він вивчає  
І святим радіє днем.  
Радість, мир, благословення  
(Радість, мир, благословення)  
День цей змученій душі дає,  
(День святий дарує)  
І за це нехай хваління  
(І за це нехай хваління)  
Серце Богу віддає.  
(Серце віддає).  

**Дует: Сопрано і Тенор**  
Господи, Тебе благаю,  
Дай цей день святити в небі нам.  
Тут коліна преклоняю,  
Щоб Тобі служити й там.  

**Хор:**  
Все забуваю, лину туди,  
Де буду вічно Тебе хвалить.  
(Суботній мир нам дорогий) —  
Свят, свят суботній мир`,
  309: `Ми славим Тебе,  
(Ми славим Тебе, славим Тебе, Тебе)  
Ісусе вічний наш!  
Ти нас від смерті відкупив.  
Ти нас від смерті Сам нас відкупив.  
(Ти нас від смерті відкупив, Ісусе, Ти нас відкупив)  
Тобі, наш Відкупителю,  
Ми славу віддаєм.  
(Ми славу віддаєм, славу віддаєм).  
Велика, Боже, є любов Твоя,  
(Велика є любов Твоя)  
Що Ти Себе не пожалів  
І кров за нас пролив.  
(І кров Свою за нас пролив).  

По горах і долинах Ти шукав загублену вівцю.  
Знайшов її і на руках приніс в отару знов Свою.  
(По горах і долинах Ти шукав загублену вівцю.  
Знайшов її і на руках приніс).  
По горах і долинах Ти шукав загублену вівцю.  
Знайшов її і на руках приніс в отару знов Свою.  
(По горах і долинах Ти шукав загублену вівцю.  
Знайшов її і на руках приніс).  

Я довго блукав (я довго блукав)  
Не знав про Христа, (не знав про Христа),  
Далеко від Бога (далеко від Бога)  
В безодні гріха, (в безодні гріха).  
Та Він — добрий Пастир,  
(Та Він — добрий Пастир).  
Мене пильнував (мене пильнував)  
Загинути тут (загинути тут)  
Мені не дав (мені не дав).  

О, слава, Ісусе (о, слава, Ісусе),  
Тобі за любов, (Тобі за любов),  
За милість Твою (за милість Твою)  
І святу Твою кров (святу Твою Кров).  
Ти нас відкупив, (Ти нас відкупив),  
Тепер ми — Твої, (тепер ми — Твої),  
З Тобою ввійдем (з Тобою ввійдем),  
Ми в Єрусалим (ми ввійдем).  

Скоро наш Господь прийде  
(Скоро Господь прийде)  
І до Себе нас візьме (нас у Свій край візьме).  
Там, у небесному хорі,  
Голос не змовкне наш.  
Славим Ісуса у зборі, —  
Слава Христу, — Він нас спас!`,
  311: `Віримо ми, що Спаситель наш  
Скоро з небес прийде,  
Всім нагороду Він принесе, —  
Скоро той час прийде.  
В славі Отця Він з'явиться,  
Світлом земля наповниться,  
Світ весь Йому поклониться.  
Скоро той час прийде!

Приспів:  
Слава! Слава!  
Звіщаймо всі про це  
(Звіщаймо всі про це).  
Слава! Слава!  
Скоро Господь прийде!  
(Скоро Господь прийде!)  
Слава! Слава!  
Слави достойний Він!  
(Слави достойний Він!)  
Слава! Слава!  
Слава Царю царів!

Віримо ми, що Спаситель наш  
Скоро з небес прийде,  
Всім нагороду Він принесе, —  
Скоро той час прийде.  
Вірних могили відкриються,  
Сплячі у славі підіймуться,  
Всі там спасенні зустрінуться.  
Скоро той час прийде!

Віримо ми, що Спаситель наш  
Скоро з небес прийде,  
Всім нагороду Він принесе, —  
Скоро той час прийде.  
Зло і страждання закінчаться,  
Сльози навіки осушаться,  
Наші надії всі сповняться.  
Скоро той час прийде!`,
  312: `Лунає над світом від краю і до краю  
Вість над морями і на островах,  
Могутньо звучить, народам сповіщає:  
«Скоро Спаситель на землю прийде!»  

Приспів:  
Лунає гучніш народам добра вість,  
Її по всьому світу три ангели з небес несуть.  
Усюди звучить народам на землі,  
Звучить народам на землі  

Та вість закликає байдужих пробудитись  
І прапор правди вище піднести,  
З'єднати ряди, невтомно всім трудитись, —  
Скоро, вже скоро Спаситель прийде.`,
  313: `Я стукаю в двері твої і стою, —  
Впусти Мене в келію свою.  
Я немічний, втомлений, бідний, сумний,  
І шлях Мій далекий, тяжкий.  
Мандрую по світу в чужій стороні,  
Шукаю притулку Собі. (Двічі)  

Хто стук Мій почує й відкриє Мені,  
І впустить в оселі свої, —  
До того ввійду, і його полюблю,  
Вечерю Я з ним розділю.  
Ти впав, занедужав, і тяжко тобі, —  
Я сили додам в боротьбі.  
Ти плачеш і ллєш гіркі сльози з очей,  
Тебе пригорну до грудей.  
З лиця витру сльози і втішу тебе,  
Прийми ж на вечерю Мене.  
Я стукаю в двері твої і стою, —  
Впусти Мене в келію свою! (Двічі)`,
  314: `Вставай, вставай, вставай, дочко Сіону,  
І в силу одягнись ти, Єрусалим, (ти, Єрусалим)  
Співай, співай, і веселися,  
Співай, співай, і веселися, (Двічі)  
Скоро повертається твій Господь з небес.  
Співай, веселись,  
Господу співай з торжеством, (з торжеством)  
Йому (радісно) хай звучить,  
Йому хай звучить, хвала, хвала, (хвала)  
Торжествуйте і співайте, всі розвалини.  
Славний ти, Єрусалиме, заспівай також,  
Бо вже викупив Христос народ Свій вірний.  
Бо вже викупив Христос народ Свій вірний.  
Тому всі співайте радісно, (радісно) (Двічі)  
Хваліте народи всі Його, (всі Його)  
Бо Він благий, (бо Він благий)  
І люблячий (і люблячий)  
До всіх, хто щиро полюбив Його (полюбив Його).  
Вставай, вставай, Сіон святий!  
Вставай, вставай, порох стряси,  
І в силу Божу одягнись, ти, Єрусалим!  
Алілуя! Амінь! (Двічі)  
Амінь!`,
  315: `О, люди, покайтесь, пізнайте Христа.  
Вже годі вам жити в гріхах,  
(Вже годі вам жити в гріхах),  
Бо в світі без Бога — усе марнота,  
(Бо в світі без Бога — усе марнота) (Двічі)  
Тривога і страх у серцях.  
(Тривога і страх у серцях). (Двічі)  
Тривога і страх у серцях.  

Чому віддаєте гріху все життя,  
Щоб тішився ворог лихий?  
Не гаючи часу, прийдіть до Христа, —  
Він дасть вам Свій мир і спокій  

О, люди, погляньте,  
Як знаки кругом  
Сповняють гріховний цей світ  
(Сповняють гріховний цей світ).  
Вставайте мерщій за Ісусом Христом,  
(Вставайте мерщій за Ісусом Христом) (Двічі)  
Він жде вас, до Нього прийдіть.  
(Він жде вас, до Нього прийдіть) (Двічі)  
Він жде вас, до Нього прийдіть.  

Вже скоро час ласки навіки мине:  
Господь наш прийде другий раз.  
І вірних дітей в Своє Царство візьме.  
А що принесе Він для нас?`,
  316: `Слухай, як Господь велить: «Пробудись!»  
Голос той до нас звучить: «Пробудись!»  
Пробудись! Пробудись!  
О, Церкво Божа, пробудись!  
Встань, мужайся!  
Встань, мужайся, укріпляйся!  
В силу Божу, в силу Божу одягнись. (Двічі)  
Скинь ярмо гріха, покайся,  
(Скинь ярмо гріха, покайся),  
І до Бога навернись (навернись).  
О, Дух Святий, до нас прийди! (Двічі)  
Вогнем святим серця збуди,  
В братній любові нас зміцни!  

Дует:  
Дай нам Духом обновитись,  
В небо з вірою дивитись,  
Йти завжди вперед, (Двічі)  
Ближче до Небес, ближче до Небес!`,
  317: `Мов та пташка за бугром  
З переломаним крилом  
Жде притулку в час важкий, —  
Господи, це ж я такий.  

Приспів:  
Хто би дав, хто би дав мені  
(Крила хто би дав)  
Крила голуба,  
(Крила хто би дав, як крила у голуба)  
Голуба?  
(Як крила у голуба)  
Я полетів би, полетів би, полетів би  
І заспокоївся.  
Я полетів би далеко (я полетів)  
Я б полетів високо, де Ти,  
Спасителю мій (Спасителю мій)  

У метелика ростуть  
Крильця, щоб почати путь  
І піднятись від землі.  
Хто б ті крила дав мені?  
О, як прагну, Боже мій,  
Оглядати образ Твій.  
Тож благаю: підніми,  
В небеса мене візьми.`,
  318: `Якби крила я мав голубині,  
Полинув би в край неземний;  
Лишив би цю смертну долину, —  
Нещастя і горе на ній  
У той край, де немає страждання,  
Ні смерті, ні мук, ні журби,  
Я рвуся з країни блукання,  
З долини гріха й боротьби  
Якби крила я мав голубині,  
Злетів би в небесну блакить,  
Туди, де в небесній Святині  
Любов ясним сяйвом горить.  

Сoda  
Дай, Боже, душі моїй крила, крила,  
Хай лине до Тебе вона,  
Бо в Тебе спасіння і сила,  
На Тебе надія моя`,
  319: `Христос чудове місто нам  
Всім вірним збудував, —  
Єрусалим новий, святий  
Йому Ім'я Він дав.  
О, приготуйсь (туди ввійти),  
Щоб перед Богом стать.  
О, приготуйсь (туди ввійти)  
Ісуса зустрічать.  
Не будь же байдужим, не гаючи часу,  
Прийди до Христа.  
Хай в серці сяє світочем ясним віра свята  
«Господь ось іде», — пролунає в ефірі  
В останній той час.  
Друже, подумай про вирок: «Я не знаю вас».  

Соло:  
О, може, уже останній раз тебе голос Божий зве,  
І горе, якщо байдуже ще  
До заклику серце твоє.  

Дует:  
Почуєш тоді страшні слова:  
«Ніколи Я вас не знав!»  
І будеш ридати гірко так,  
Що голос той не прийняв.  

Христос тепер всіх зове,  
Спасіння усім дає. (Двічі)  
Ідіть же, йдіть, є місце там,  
Ще двері відкриті вам`,
  320: `Отче наш, що на небесах, (що на небесах)  
Нехай святиться Ім'я Твоє,  
Нехай прийде Царство Твоє,  
Нехай буде воля Твоя і на землі,  
І на землі, як на небі.  
Хліба нашого насущного  
Дай нам сьогодні.  
І прости провини наші, як і ми,  
Як і ми прощаєм винуватцям нашим.  
І не введи нас у спокусу,  
Але визволи нас,  
Але визволи нас від лукавого.  
Бо Твоє є Царство,  
Царство, і сила, і слава навіки,  
Царство, і сила, і слава навіки, навіки.  
Амінь`,
  321: `Отче, почуй нас, ми Тебе благаєм, (Двічі)  
Нашим співом ми Твоє Ім'я предвічне  
Славим, Тебе величаєм.  
Отче, почуй нас, ми Тебе благаєм,  
Славослів'я і молитви, Боже наш, почуй.  
Будь славен, Господи, повік.  
Ми до Тебе кличем, бо Твої ми діти,  
Голос наш почуй з небес,  
Дай нам Твою радість.  
Тобі складаєм вічну хвалу в наших піснях.  
Наш Отче, хай звучить Тобі хвала,  
Хвала і честь повік.  
Хай Ім'я Твоє чудове прославляють народи. (Двічі)  
Бог — Цар царів! Славу і поклін  
Віддамо Йому повік віків. (Двічі)  
Всі ми заспіваєм Господу: «Осанна!»  
Віддамо хвалу і честь Творцю землі небес!  
Заспіваєм всі: «Осанна!»  
(Всі ми заспіваєм Господу: «Осанна!»)  
Віддамо хвалу Творцю небес!  
(Віддамо хвалу і честь Творцю землі й небес!)  
Хай лиш Твоєму Імені  
(Честь і слава!)  
Звучить завжди моя хвала!  
Хай Імені святому співає, співає  
(Честь, і слава, і хвала, хвала)  
Заспіваєм всі: «Осанна!»  
(Всі ми заспіваєм Господу: «Осанна!») (Двічі)  
Віддамо хвалу Творцю небес!  
(Віддамо хвалу Творцю небес, Творцю небес).  
Славте Творця!  
Слава! Слава! (Двічі)  
(Славте всі Його)  
Кожний хай Його Ім'я прославить.  
(Слав, слав, кожний хай прославить! (Двічі)  
Слава!  
(Славте всі Його!) (Двічі)  
Славте Бога, небо і земля!  
(Слав, слав, славте всі)  
Хай народи всі славлять Господа,  
Нехай Єгову всі прославлять! (Двічі)  
Слава хай звучить повік! (Двічі)  
Повіки слава!  
Амінь`,
  322: `Боже, поглянь (Боже, поглянь)  
Поглянь з небес (з небес),  
Благослови нас.  
Хай засіяє лице Твоє!  
О, обернись (О, обернись)  
Же, Господи! (Господи!)  
І збережи те,  
Що насадила Рука Твоя.  
Боже, поглянь, (Боже, поглянь)  
Поглянь з небес (з небес).  
Хай засіяє над нами лице Твоє!  
(Хай засіяє над нами лице Твоє!)  
Амінь.  
Цар царів, Бог слави  
Повіки віків,  
Ясним Ти лицем  
Поглянь на нас, поглянь з небес,  
Господь! Наш Бог! Алілуя, (Алілуя,)  
Алілуя, Алілуя!`,
  323: `Христос, почуй душі моління,  
Мій дух Собою освіти,  
І серця бурного тремтіння,  
Як хвилі моря, усмири.  
Христос, почуй душі моління,  
Мій дух Собою освіти,  
І серця бурного тремтіння,  
Як хвилі моря, Боже, усмири.  
Прийми мене в Свою оселю,  
Я — блудний син, — Отець Ти мій.  
І як над Лазарем, з любов'ю  
Заплач над мною й заспокій  

О, дай, щоб вірою живою  
Розвіяв я туман страстей  
І щоби щирою душею,  
Як Ти, прощав й любив людей,  
О, дай, щоб вірою живою  
Розвіяв я туман страстей  
І щоби щирою душею,  
Як Ти, прощав й любив людей, людей.  
О, відкупи святою кров'ю  
Гріховний, смертний світ земний,  
І в серце Сам вселись любов'ю  
Навіки, Боже мій благий`,
  324: `У Кані — весілля,  
Христос там Гостем був.  
Там чудо перше Він звершив  
І шлюб благословив.  
Приспів:  
О, Спасе пресвятий (Спасе Пресвятий)  
Любові Джерело (любові Джерело),  
До наших молодих прийди  
(До наших молодих прийди),  
До наших молодих прийди  
(До наших молодих прийди),  
І їх благослови!

І в доброті Своїй  
Пошли Ти щастя їм.  
Прославлять хай вони Тебе  
Святим життям своїм.  
Ми просимо Тебе,  
Небесного Творця,  
Щоб їх серця в одне злучив  
На ціле їх життя.`,
  325: `Прийми, Творець, хвалу і честь  
В цей день прекрасний за радість сердець.  
Сповнена співом земля,  
Щастям, любов'ю палають серця.  
Щирі благання наших молитв  
Вислухай в небі, Отче благий.  
Зглянься, Боже, тут Твої діти,  
Шлюбний союз цей благослови,  
Миром, любов'ю їх наділи,  
Світло небесним всіх освіти.  
Прийми, Творець, хвалу і честь  
В цей день прекрасний за радість сердець.  
Сповнена вся співом земля,  
Щастям, любов'ю палають серця.  
Радість в серцях!`,
  326: `О, Ти, Кого хвалить не смію, —  
Творець всього, Спаситель мій.  
Кого люблю, про Кого мрію  
Всім серцем в немочі моїй.  
Хто по Своїй небесній волі  
Гріхи любов'ю поборов,  
Прийняв страждальців бідну долю  
Як Друг, і Брат, Отець, і Бог.  
Мій Господь

Хто сонця осяйним промінням  
Все радує в красі денній  
І дивним зоряним горінням  
Чудово світить в тьмі нічній.  
Щоб промінь славної надії  
Завжди у серце проникав,  
Щоб пам'ятав благі події  
І Божу міць не забував.  
Мій Господь

Мене тяжкий хрест не лякає,  
Страждання вірою цвіте.  
Сам Бог, хоч горе допускає,  
Та з Ним терпіння нам дає.  
Твоїм слідом іти готовий,  
Молюсь, щоб дух мій підкріпив,  
Я понесу вінок терновий,  
Який колись Христос носив.  
Мій Господь`,
  326: `О, Ти, Кого хвалить не смію, —  
Творець всього, Спаситель мій.  
Кого люблю, про Кого мрію  
Всім серцем в немочі моїй.  
Хто по Своїй небесній волі  
Гріхи любов'ю поборов,  
Прийняв страждальців бідну долю  
Як Друг, і Брат, Отець, і Бог.  
Мій Господь.

Хто сонця осяйним промінням  
Все радує в красі денній,  
І дивним зоряним горінням  
Чудово світить в тьмі нічній.  
Щоб промінь славної надії  
Завжди у серце проникав,  
Щоб пам'ятав благі події  
І Божу міць не забував.  
Мій Господь.

Мене тяжкий хрест не лякає,  
Страждання вірою цвіте.  
Сам Бог, хоч горе допускає,  
Та з Ним терпіння нам дає.  
Твоїм слідом іти готовий,  
Молюсь, щоб дух мій підкріпив,  
Я понесу вінок терновий,  
Який колись Христос носив.  
Мій Господь.`,
  327: `1. Де згода в сімействі, там мир і тишина,  
Щасливі там люди, блаженна сторона.  
Їх Бог благословляє, добро їм посилає,  
І з ними вік живе, і щастя їм дає.  

2. Де згоди немає, там мир і не царить,  
Тих Бог не вітає, добра їм не дарить.  
Руйнуються пожитки, добро їх, їхні дітки —  
Все марно пролетить, все марно пропаде.  

3. Пошли нам, Боже, згоду, і мир, і Твій покров,  
І радість в Господу, і щиру дай любов.  
Пошли нам щастя, й долю. І жити в Твоїй волі.  
Ти нас благослови, Ти нас благослови.`
};
export default PISNI_TEXTS;
